/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 49);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var pug_has_own_property = Object.prototype.hasOwnProperty;

/**
 * Merge two attribute objects giving precedence
 * to values in object `b`. Classes are special-cased
 * allowing for arrays and merging/joining appropriately
 * resulting in a string.
 *
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 * @api private
 */

exports.merge = pug_merge;
function pug_merge(a, b) {
  if (arguments.length === 1) {
    var attrs = a[0];
    for (var i = 1; i < a.length; i++) {
      attrs = pug_merge(attrs, a[i]);
    }
    return attrs;
  }

  for (var key in b) {
    if (key === 'class') {
      var valA = a[key] || [];
      a[key] = (Array.isArray(valA) ? valA : [valA]).concat(b[key] || []);
    } else if (key === 'style') {
      var valA = pug_style(a[key]);
      valA = valA && valA[valA.length - 1] !== ';' ? valA + ';' : valA;
      var valB = pug_style(b[key]);
      valB = valB && valB[valB.length - 1] !== ';' ? valB + ';' : valB;
      a[key] = valA + valB;
    } else {
      a[key] = b[key];
    }
  }

  return a;
};

/**
 * Process array, object, or string as a string of classes delimited by a space.
 *
 * If `val` is an array, all members of it and its subarrays are counted as
 * classes. If `escaping` is an array, then whether or not the item in `val` is
 * escaped depends on the corresponding item in `escaping`. If `escaping` is
 * not an array, no escaping is done.
 *
 * If `val` is an object, all the keys whose value is truthy are counted as
 * classes. No escaping is done.
 *
 * If `val` is a string, it is counted as a class. No escaping is done.
 *
 * @param {(Array.<string>|Object.<string, boolean>|string)} val
 * @param {?Array.<string>} escaping
 * @return {String}
 */
exports.classes = pug_classes;
function pug_classes_array(val, escaping) {
  var classString = '', className, padding = '', escapeEnabled = Array.isArray(escaping);
  for (var i = 0; i < val.length; i++) {
    className = pug_classes(val[i]);
    if (!className) continue;
    escapeEnabled && escaping[i] && (className = pug_escape(className));
    classString = classString + padding + className;
    padding = ' ';
  }
  return classString;
}
function pug_classes_object(val) {
  var classString = '', padding = '';
  for (var key in val) {
    if (key && val[key] && pug_has_own_property.call(val, key)) {
      classString = classString + padding + key;
      padding = ' ';
    }
  }
  return classString;
}
function pug_classes(val, escaping) {
  if (Array.isArray(val)) {
    return pug_classes_array(val, escaping);
  } else if (val && typeof val === 'object') {
    return pug_classes_object(val);
  } else {
    return val || '';
  }
}

/**
 * Convert object or string to a string of CSS styles delimited by a semicolon.
 *
 * @param {(Object.<string, string>|string)} val
 * @return {String}
 */

exports.style = pug_style;
function pug_style(val) {
  if (!val) return '';
  if (typeof val === 'object') {
    var out = '';
    for (var style in val) {
      /* istanbul ignore else */
      if (pug_has_own_property.call(val, style)) {
        out = out + style + ':' + val[style] + ';';
      }
    }
    return out;
  } else {
    return val + '';
  }
};

/**
 * Render the given attribute.
 *
 * @param {String} key
 * @param {String} val
 * @param {Boolean} escaped
 * @param {Boolean} terse
 * @return {String}
 */
exports.attr = pug_attr;
function pug_attr(key, val, escaped, terse) {
  if (val === false || val == null || !val && (key === 'class' || key === 'style')) {
    return '';
  }
  if (val === true) {
    return ' ' + (terse ? key : key + '="' + key + '"');
  }
  var type = typeof val;
  if ((type === 'object' || type === 'function') && typeof val.toJSON === 'function') {
    val = val.toJSON();
  }
  if (typeof val !== 'string') {
    val = JSON.stringify(val);
    if (!escaped && val.indexOf('"') !== -1) {
      return ' ' + key + '=\'' + val.replace(/'/g, '&#39;') + '\'';
    }
  }
  if (escaped) val = pug_escape(val);
  return ' ' + key + '="' + val + '"';
};

/**
 * Render the given attributes object.
 *
 * @param {Object} obj
 * @param {Object} terse whether to use HTML5 terse boolean attributes
 * @return {String}
 */
exports.attrs = pug_attrs;
function pug_attrs(obj, terse){
  var attrs = '';

  for (var key in obj) {
    if (pug_has_own_property.call(obj, key)) {
      var val = obj[key];

      if ('class' === key) {
        val = pug_classes(val);
        attrs = pug_attr(key, val, false, terse) + attrs;
        continue;
      }
      if ('style' === key) {
        val = pug_style(val);
      }
      attrs += pug_attr(key, val, false, terse);
    }
  }

  return attrs;
};

/**
 * Escape the given string of `html`.
 *
 * @param {String} html
 * @return {String}
 * @api private
 */

var pug_match_html = /["&<>]/;
exports.escape = pug_escape;
function pug_escape(_html){
  var html = '' + _html;
  var regexResult = pug_match_html.exec(html);
  if (!regexResult) return _html;

  var result = '';
  var i, lastIndex, escape;
  for (i = regexResult.index, lastIndex = 0; i < html.length; i++) {
    switch (html.charCodeAt(i)) {
      case 34: escape = '&quot;'; break;
      case 38: escape = '&amp;'; break;
      case 60: escape = '&lt;'; break;
      case 62: escape = '&gt;'; break;
      default: continue;
    }
    if (lastIndex !== i) result += html.substring(lastIndex, i);
    lastIndex = i + 1;
    result += escape;
  }
  if (lastIndex !== i) return result + html.substring(lastIndex, i);
  else return result;
};

/**
 * Re-throw the given `err` in context to the
 * the pug in `filename` at the given `lineno`.
 *
 * @param {Error} err
 * @param {String} filename
 * @param {String} lineno
 * @param {String} str original source
 * @api private
 */

exports.rethrow = pug_rethrow;
function pug_rethrow(err, filename, lineno, str){
  if (!(err instanceof Error)) throw err;
  if ((typeof window != 'undefined' || !filename) && !str) {
    err.message += ' on line ' + lineno;
    throw err;
  }
  try {
    str = str || __webpack_require__(48).readFileSync(filename, 'utf8')
  } catch (ex) {
    pug_rethrow(err, null, lineno)
  }
  var context = 3
    , lines = str.split('\n')
    , start = Math.max(lineno - context, 0)
    , end = Math.min(lines.length, lineno + context);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? '  > ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'Pug') + ':' + lineno
    + '\n' + context + '\n\n' + err.message;
  throw err;
};


/***/ },
/* 1 */
/***/ function(module, exports) {

module.exports = {
	"numeric": "[0-9]*",
	"name": "[a-zA-Z-,\\.\\s]+",
	"license": "^[a-zA-Z0-9]*$",
	"email": "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
	"ein": "^(0[1-9]|[1-9]\\d)-\\d{7}$",
	"ssn": "(?!(000|666|9))\\d{3}-(?!00)\\d{2}-(?!0000)\\d{4}",
	"zipCode": "[0-9]{5}(?:-[0-9]{4})?",
	"routingNumber": "[0-9]{9}",
	"phone": "\\([0-9]{3}\\)\\s[0-9]{3}-[0-9]{4}"
};

/***/ },
/* 2 */
/***/ function(module, exports) {

module.exports = angular;

/***/ },
/* 3 */
/***/ function(module, exports) {

module.exports = {
	"AL": "Alabama",
	"AK": "Alaska",
	"AS": "American Samoa",
	"AZ": "Arizona",
	"AR": "Arkansas",
	"CA": "California",
	"CO": "Colorado",
	"CT": "Connecticut",
	"DE": "Delaware",
	"DC": "District Of Columbia",
	"FM": "Federated States Of Micronesia",
	"FL": "Florida",
	"GA": "Georgia",
	"GU": "Guam",
	"HI": "Hawaii",
	"ID": "Idaho",
	"IL": "Illinois",
	"IN": "Indiana",
	"IA": "Iowa",
	"KS": "Kansas",
	"KY": "Kentucky",
	"LA": "Louisiana",
	"ME": "Maine",
	"MH": "Marshall Islands",
	"MD": "Maryland",
	"MA": "Massachusetts",
	"MI": "Michigan",
	"MN": "Minnesota",
	"MS": "Mississippi",
	"MO": "Missouri",
	"MT": "Montana",
	"NE": "Nebraska",
	"NV": "Nevada",
	"NH": "New Hampshire",
	"NJ": "New Jersey",
	"NM": "New Mexico",
	"NY": "New York",
	"NC": "North Carolina",
	"ND": "North Dakota",
	"MP": "Northern Mariana Islands",
	"OH": "Ohio",
	"OK": "Oklahoma",
	"OR": "Oregon",
	"PW": "Palau",
	"PA": "Pennsylvania",
	"PR": "Puerto Rico",
	"RI": "Rhode Island",
	"SC": "South Carolina",
	"SD": "South Dakota",
	"TN": "Tennessee",
	"TX": "Texas",
	"UT": "Utah",
	"VT": "Vermont",
	"VI": "Virgin Islands",
	"VA": "Virginia",
	"WA": "Washington",
	"WV": "West Virginia",
	"WI": "Wisconsin",
	"WY": "Wyoming"
};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.14.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        return Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (utils_hooks__hooks.deprecationHandler != null) {
                utils_hooks__hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (utils_hooks__hooks.deprecationHandler != null) {
            utils_hooks__hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;
    utils_hooks__hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function get_set__set (mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function units_month__handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = create_utc__createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return units_month__handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (typeof value !== 'number') {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function day_of_week__handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = create_utc__createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = create_utc__createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    // treat as if there is no base config
                    deprecateSimple('parentLocaleUndefined',
                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function locale_locales__listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(utils_hooks__hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (isDate(input)) {
            config._d = input;
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!valid__isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(utils_hooks__hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = local__createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return valid__createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = ((string || '').match(matcher) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(matchOffset, this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : local__createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add               = add_subtract__add;
    momentPrototype__proto.calendar          = moment_calendar__calendar;
    momentPrototype__proto.clone             = clone;
    momentPrototype__proto.diff              = diff;
    momentPrototype__proto.endOf             = endOf;
    momentPrototype__proto.format            = format;
    momentPrototype__proto.from              = from;
    momentPrototype__proto.fromNow           = fromNow;
    momentPrototype__proto.to                = to;
    momentPrototype__proto.toNow             = toNow;
    momentPrototype__proto.get               = stringGet;
    momentPrototype__proto.invalidAt         = invalidAt;
    momentPrototype__proto.isAfter           = isAfter;
    momentPrototype__proto.isBefore          = isBefore;
    momentPrototype__proto.isBetween         = isBetween;
    momentPrototype__proto.isSame            = isSame;
    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
    momentPrototype__proto.isValid           = moment_valid__isValid;
    momentPrototype__proto.lang              = lang;
    momentPrototype__proto.locale            = locale;
    momentPrototype__proto.localeData        = localeData;
    momentPrototype__proto.max               = prototypeMax;
    momentPrototype__proto.min               = prototypeMin;
    momentPrototype__proto.parsingFlags      = parsingFlags;
    momentPrototype__proto.set               = stringSet;
    momentPrototype__proto.startOf           = startOf;
    momentPrototype__proto.subtract          = add_subtract__subtract;
    momentPrototype__proto.toArray           = toArray;
    momentPrototype__proto.toObject          = toObject;
    momentPrototype__proto.toDate            = toDate;
    momentPrototype__proto.toISOString       = moment_format__toISOString;
    momentPrototype__proto.toJSON            = toJSON;
    momentPrototype__proto.toString          = toString;
    momentPrototype__proto.unix              = unix;
    momentPrototype__proto.valueOf           = to_type__valueOf;
    momentPrototype__proto.creationData      = creationData;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var prototype__proto = Locale.prototype;

    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto.ordinal         = ordinal;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months            =        localeMonths;
    prototype__proto.monthsShort       =        localeMonthsShort;
    prototype__proto.monthsParse       =        localeMonthsParse;
    prototype__proto.monthsRegex       = monthsRegex;
    prototype__proto.monthsShortRegex  = monthsShortRegex;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    prototype__proto.weekdaysRegex       =        weekdaysRegex;
    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = lists__get(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = locale_locales__getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return lists__get(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function lists__listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function lists__listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function lists__listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function lists__listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes <= 1           && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   <= 1           && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    <= 1           && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  <= 1           && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   <= 1           && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.14.1';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.now                   = now;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.updateLocale          = updateLocale;
    utils_hooks__hooks.locales               = locale_locales__listLocales;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
    utils_hooks__hooks.prototype             = momentPrototype;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module)))

/***/ },
/* 5 */
/***/ function(module, exports) {

module.exports = {
	"indiv": "Individual/sole proprietor or single-member LLC",
	"c_corp": "C Corporation",
	"s_corp": "S Corporation",
	"partner": "Partnership",
	"trust": "Trust/estate",
	"llc": "Limited liability company"
};

/***/ },
/* 6 */
/***/ function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(35);
module.exports = 'ngMessages';


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(36);
module.exports = 'ngRoute';


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports
exports.i(__webpack_require__(37), "");

// module
exports.push([module.i, "header{position:relative;top:0;left:0;right:0;z-index:2;background:#43b02a;height:48px;padding:12px;text-align:center}@media only screen and (min-width:992px){header{height:64px;padding:20px;text-align:left}}header svg{width:160px;height:20px}@media only screen and (min-width:992px){header svg{width:210px;height:26px}}header svg path{fill:#fff}header .header__logo{display:inline-block}body{font-family:HCo Gotham,Gotham A,Gotham B;background-color:#000}.footer-spacer,footer{display:none}app .text-center,main .text-center{text-align:center}app .alert.alert-danger,main .alert.alert-danger{background:#c35500;color:#fff}app .alert.alert-danger a,main .alert.alert-danger a{color:#fff}app .btn,main .btn{color:#fff;font-family:HCo Gotham,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:800}app .btn:focus,app .btn:hover,main .btn:focus,main .btn:hover{box-shadow:0 10px 30px 0 rgba(0,0,0,.1),0 10px 10px 0 rgba(0,0,0,.1)}app .btn-info,main .btn-info{background-color:#00aec7;border-color:#00aec7}app .btn-secondary,main .btn-secondary{background-color:#ccc;color:#fff}app .ng-submitted .ng-invalid,main .ng-submitted .ng-invalid{border-bottom:1px solid #c35500}app fieldset,main fieldset{margin:0 0 1.6rem;border:none}app legend,main legend{margin:0;padding:0 0 .8rem;color:#666;font-family:HCo Gotham,Gotham A,Gotham B;font-size:12px;font-weight:500}app .field,main .field{position:relative;margin-bottom:.8rem}app .label-text,app label,main .label-text,main label{padding:.53333rem 0 0;color:#666;font-family:HCo Gotham,Gotham A,Gotham B;font-size:14px;font-weight:500;display:inline-block}app .label-text,main .label-text{margin:0 0 10px}app fieldset,main fieldset{margin:0;padding:0}app .input,app .readonly-text,app input[type=date],app input[type=email],app input[type=number],app input[type=tel],app input[type=text],app select,app textarea,main .input,main .readonly-text,main input[type=date],main input[type=email],main input[type=number],main input[type=tel],main input[type=text],main select,main textarea{display:block;width:100%;vertical-align:middle;margin:0;padding:.5rem 0;border:1px solid #ccc;border-width:0 0 2px;font-size:19.6px;color:#43b02a;transition:all .3s;border-radius:0;appearance:none;-webkit-appearance:none;-moz-appearance:none;min-height:30.8px;font-family:HCo Gotham,Gotham SSm A,Gotham SSm B,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:200}@media only screen and (min-width:992px){app .input,app .readonly-text,app input[type=date],app input[type=email],app input[type=number],app input[type=tel],app input[type=text],app select,app textarea,main .input,main .readonly-text,main input[type=date],main input[type=email],main input[type=number],main input[type=tel],main input[type=text],main select,main textarea{font-size:23.8px;height:3.2rem}}app .input::-moz-placeholder,app .readonly-text::-moz-placeholder,app input[type=date]::-moz-placeholder,app input[type=email]::-moz-placeholder,app input[type=number]::-moz-placeholder,app input[type=tel]::-moz-placeholder,app input[type=text]::-moz-placeholder,app select::-moz-placeholder,app textarea::-moz-placeholder,main .input::-moz-placeholder,main .readonly-text::-moz-placeholder,main input[type=date]::-moz-placeholder,main input[type=email]::-moz-placeholder,main input[type=number]::-moz-placeholder,main input[type=tel]::-moz-placeholder,main input[type=text]::-moz-placeholder,main select::-moz-placeholder,main textarea::-moz-placeholder{color:#bfbfbf;text-transform:none;font-family:HCo Gotham,Gotham SSm A,Gotham SSm B,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:200}app .input:-ms-input-placeholder,app .readonly-text:-ms-input-placeholder,app input[type=date]:-ms-input-placeholder,app input[type=email]:-ms-input-placeholder,app input[type=number]:-ms-input-placeholder,app input[type=tel]:-ms-input-placeholder,app input[type=text]:-ms-input-placeholder,app select:-ms-input-placeholder,app textarea:-ms-input-placeholder,main .input:-ms-input-placeholder,main .readonly-text:-ms-input-placeholder,main input[type=date]:-ms-input-placeholder,main input[type=email]:-ms-input-placeholder,main input[type=number]:-ms-input-placeholder,main input[type=tel]:-ms-input-placeholder,main input[type=text]:-ms-input-placeholder,main select:-ms-input-placeholder,main textarea:-ms-input-placeholder{color:#bfbfbf;text-transform:none;font-family:HCo Gotham,Gotham SSm A,Gotham SSm B,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:200}app .input::placeholder,app .readonly-text::placeholder,app input[type=date]::placeholder,app input[type=email]::placeholder,app input[type=number]::placeholder,app input[type=tel]::placeholder,app input[type=text]::placeholder,app select::placeholder,app textarea::placeholder,main .input::placeholder,main .readonly-text::placeholder,main input[type=date]::placeholder,main input[type=email]::placeholder,main input[type=number]::placeholder,main input[type=tel]::placeholder,main input[type=text]::placeholder,main select::placeholder,main textarea::placeholder{color:#bfbfbf;text-transform:none;font-family:HCo Gotham,Gotham SSm A,Gotham SSm B,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:200}app .input:active,app .input:focus,app .readonly-text:active,app .readonly-text:focus,app input[type=date]:active,app input[type=date]:focus,app input[type=email]:active,app input[type=email]:focus,app input[type=number]:active,app input[type=number]:focus,app input[type=tel]:active,app input[type=tel]:focus,app input[type=text]:active,app input[type=text]:focus,app select:active,app select:focus,app textarea:active,app textarea:focus,main .input:active,main .input:focus,main .readonly-text:active,main .readonly-text:focus,main input[type=date]:active,main input[type=date]:focus,main input[type=email]:active,main input[type=email]:focus,main input[type=number]:active,main input[type=number]:focus,main input[type=tel]:active,main input[type=tel]:focus,main input[type=text]:active,main input[type=text]:focus,main select:active,main select:focus,main textarea:active,main textarea:focus{outline:none;border-bottom-color:#43b02a}app .input[disabled],app .input[readonly],app .readonly-text[disabled],app .readonly-text[readonly],app input[type=date][disabled],app input[type=date][readonly],app input[type=email][disabled],app input[type=email][readonly],app input[type=number][disabled],app input[type=number][readonly],app input[type=tel][disabled],app input[type=tel][readonly],app input[type=text][disabled],app input[type=text][readonly],app select[disabled],app select[readonly],app textarea[disabled],app textarea[readonly],main .input[disabled],main .input[readonly],main .readonly-text[disabled],main .readonly-text[readonly],main input[type=date][disabled],main input[type=date][readonly],main input[type=email][disabled],main input[type=email][readonly],main input[type=number][disabled],main input[type=number][readonly],main input[type=tel][disabled],main input[type=tel][readonly],main input[type=text][disabled],main input[type=text][readonly],main select[disabled],main select[readonly],main textarea[disabled],main textarea[readonly]{background:#f3f3f3;padding-left:.4rem;padding-right:.4rem}app .input.ng-pristine.ng-invalid,app .input.ng-pristine.ng-invalid-required,app .readonly-text.ng-pristine.ng-invalid,app .readonly-text.ng-pristine.ng-invalid-required,app input[type=date].ng-pristine.ng-invalid,app input[type=date].ng-pristine.ng-invalid-required,app input[type=email].ng-pristine.ng-invalid,app input[type=email].ng-pristine.ng-invalid-required,app input[type=number].ng-pristine.ng-invalid,app input[type=number].ng-pristine.ng-invalid-required,app input[type=tel].ng-pristine.ng-invalid,app input[type=tel].ng-pristine.ng-invalid-required,app input[type=text].ng-pristine.ng-invalid,app input[type=text].ng-pristine.ng-invalid-required,app select.ng-pristine.ng-invalid,app select.ng-pristine.ng-invalid-required,app textarea.ng-pristine.ng-invalid,app textarea.ng-pristine.ng-invalid-required,main .input.ng-pristine.ng-invalid,main .input.ng-pristine.ng-invalid-required,main .readonly-text.ng-pristine.ng-invalid,main .readonly-text.ng-pristine.ng-invalid-required,main input[type=date].ng-pristine.ng-invalid,main input[type=date].ng-pristine.ng-invalid-required,main input[type=email].ng-pristine.ng-invalid,main input[type=email].ng-pristine.ng-invalid-required,main input[type=number].ng-pristine.ng-invalid,main input[type=number].ng-pristine.ng-invalid-required,main input[type=tel].ng-pristine.ng-invalid,main input[type=tel].ng-pristine.ng-invalid-required,main input[type=text].ng-pristine.ng-invalid,main input[type=text].ng-pristine.ng-invalid-required,main select.ng-pristine.ng-invalid,main select.ng-pristine.ng-invalid-required,main textarea.ng-pristine.ng-invalid,main textarea.ng-pristine.ng-invalid-required{color:#ccc}app .input:required+label:after,app .readonly-text:required+label:after,app input[type=date]:required+label:after,app input[type=email]:required+label:after,app input[type=number]:required+label:after,app input[type=tel]:required+label:after,app input[type=text]:required+label:after,app select:required+label:after,app textarea:required+label:after,main .input:required+label:after,main .readonly-text:required+label:after,main input[type=date]:required+label:after,main input[type=email]:required+label:after,main input[type=number]:required+label:after,main input[type=tel]:required+label:after,main input[type=text]:required+label:after,main select:required+label:after,main textarea:required+label:after{content:\"*\"}app .input::-ms-expand,app .readonly-text::-ms-expand,app input[type=date]::-ms-expand,app input[type=email]::-ms-expand,app input[type=number]::-ms-expand,app input[type=tel]::-ms-expand,app input[type=text]::-ms-expand,app select::-ms-expand,app textarea::-ms-expand,main .input::-ms-expand,main .readonly-text::-ms-expand,main input[type=date]::-ms-expand,main input[type=email]::-ms-expand,main input[type=number]::-ms-expand,main input[type=tel]::-ms-expand,main input[type=text]::-ms-expand,main select::-ms-expand,main textarea::-ms-expand{display:none}app input:-webkit-autofill,main input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset}app input[type=date]::-webkit-inner-spin-button,app input[type=date]::-webkit-outer-spin-button,app input[type=number]::-webkit-inner-spin-button,app input[type=number]::-webkit-outer-spin-button,main input[type=date]::-webkit-inner-spin-button,main input[type=date]::-webkit-outer-spin-button,main input[type=number]::-webkit-inner-spin-button,main input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}app input[type=number],main input[type=number]{-moz-appearance:textfield}app .readonly-text,main .readonly-text{cursor:not-allowed;background-color:#f3f3f3;padding-left:10px;padding-right:10px}app select,main select{-moz-appearance:none;appearance:none;-webkit-appearance:none;border-radius:0;background:none}@media only screen and (min-width:768px){app select,main select{padding-right:1rem;background:url(\"/src/img/bg-dropdown-arrow.svg\") 100% no-repeat;background-size:10px 5px}}app textarea,main textarea{font-size:1rem;height:5rem}app input[type=checkbox],app input[type=radio],main input[type=checkbox],main input[type=radio]{display:inline-block;height:18px;width:18px;opacity:0;vertical-align:middle}app input[type=checkbox]+label,app input[type=radio]+label,main input[type=checkbox]+label,main input[type=radio]+label{display:inline;padding-left:1rem;font-family:HCo Gotham,Gotham A,Gotham B;font-size:14px;color:inherit;box-sizing:content-box;cursor:pointer}app input[type=checkbox]+label:before,app input[type=radio]+label:before,main input[type=checkbox]+label:before,main input[type=radio]+label:before{content:\"\";position:absolute;background:#fff 50% no-repeat;border:2px solid #43b02a;height:18px;width:18px;border-radius:4px;transition:all .3s;box-sizing:content-box}app input[type=checkbox]:focus+label:before,app input[type=radio]:focus+label:before,main input[type=checkbox]:focus+label:before,main input[type=radio]:focus+label:before{box-shadow:0 0 10px #919496}app input[type=checkbox]:checked+label:before,main input[type=checkbox]:checked+label:before{background-color:#43b02a;background-image:url(\"/src/img/icons/check.svg\")}app input[type=date]::-webkit-clear-button,main input[type=date]::-webkit-clear-button{-webkit-appearance:none;-webkit-appearance-display:none}app input[type=checkbox],app input[type=radio],main input[type=checkbox],main input[type=radio]{position:absolute;height:0;width:0}app input[type=checkbox]+label,app input[type=radio]+label,main input[type=checkbox]+label,main input[type=radio]+label{padding:0 0 0 35px;width:100%;min-height:22px;line-height:22px;box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;position:relative}app input[type=checkbox]+label>*,app input[type=radio]+label>*,main input[type=checkbox]+label>*,main input[type=radio]+label>*{display:block;max-width:100%;-ms-flex-negative:1;flex-shrink:1}app input[type=checkbox]+label:after,app input[type=checkbox]+label:before,app input[type=radio]+label:after,app input[type=radio]+label:before,main input[type=checkbox]+label:after,main input[type=checkbox]+label:before,main input[type=radio]+label:after,main input[type=radio]+label:before{top:0;left:0}app input[type=radio]+label:before,main input[type=radio]+label:before{border-radius:50%}app input[type=radio]+label:after,main input[type=radio]+label:after{content:\"\";position:absolute;left:0;height:12px;width:12px;margin:5px 0 0 5px;background:#43b02a;border-radius:50%;transition:transform .3s;transform:scale(0);top:0}app input[type=radio]:checked+label:after,main input[type=radio]:checked+label:after{transform:scale(1)}form.ng-submitted .ng-invalid,form.ng-submitted .ng-required{border-bottom-color:#c35500}form.ng-submitted .ng-invalid+label,form.ng-submitted .ng-required+label{color:#c35500}form.ng-submitted .ng-invalid input,form.ng-submitted .ng-invalid select,form.ng-submitted .ng-invalid textarea,form.ng-submitted .ng-required input,form.ng-submitted .ng-required select,form.ng-submitted .ng-required textarea{border-color:#c35500}form.ng-submitted .ng-invalid label,form.ng-submitted .ng-required label{color:#c35500}.page-spinner-container{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center;-ms-flex-pack:center;justify-content:center;text-align:center;width:100%;min-height:100vh;min-height:calc(100vh - 48px)}@media only screen and (min-width:992px){.page-spinner-container{min-height:calc(100vh - 64px)}}body.embedded .page-spinner-container{min-height:100vh}@media only screen and (min-width:992px){body.embedded .page-spinner-container{min-height:100vh}}@media only screen and (min-width:992px){.page-spinner-container{padding-bottom:64px}}.page-spinner-container .spinner{margin:0;text-align:center}input::-webkit-contacts-auto-fill-button{visibility:hidden;display:none!important;pointer-events:none;position:absolute;right:0}input::-ms-clear{display:none}.footer-spacer{width:1140px;height:1px;background-color:#ddd;margin:0 auto 30px}h1{font-size:28px;margin:0 0 15px;padding:0}h1,h2,h3,h4,h5{color:#333;font-family:HCo Gotham,Gotham SSm A,Gotham SSm B,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:200}@keyframes spinner-anim{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.spinner-container{min-height:300px;display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center}.spinner{background:none;position:relative;width:100px;height:100px;margin:5rem auto;text-indent:-9999px;display:inline-block}.spinner:before{content:\"\";border-radius:50%;box-shadow:0 .4rem 0 0 #43b02a;animation:spinner-anim 1s linear infinite;display:block;position:absolute;width:100%;height:100%}body,html{background:#fff}.page-title{margin:0 0 20px}.appointment-app-container{font-size:14px}.appointment-app-container h1{font-size:20px;line-height:30px;margin-bottom:20px;font-family:HCo Gotham,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:800}@media only screen and (min-width:992px){.appointment-app-container h1{font-size:32px}}.appointment-app-container h3{font-size:1.5rem;margin:0 0 15px;padding:0}.appointment-app-container p{margin:0;padding:0;font-weight:400}.appointment-app-container a:not(.btn){color:#00aec7;text-decoration:underline;font-weight:700}.appointment-app-container strong{font-weight:700}.appointment-app-container .application-link{color:#00aec7;text-decoration:underline}.appointment-app-container .alert a{color:#c35500;text-decoration:underline;font-weight:400}.appointment-app-container .alert .alert-message{padding:10px 0 0;font-size:13px;font-weight:400}.appointment-app-container .btn-link{cursor:pointer;margin:0;padding:0;border:0;background:transparent;color:#00aec7;text-decoration:underline}.appointment-app-container label{font-size:14px}.appointment-app-container label.no-after:after{content:\"\"!important}.appointment-app-container label .label-disclaimer{font-weight:400;margin-left:.5rem}.appointment-app-container .uppercase-first:first-letter{text-transform:capitalize}.appointment-app-container .appointment-get-started{margin:30px 0}.appointment-app-container .appointment-app-top{background:#43b02a;color:#fff;text-align:left;text-shadow:0 1px 2px rgba(55,145,34,.4);font-family:HCo Gotham,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:400}.appointment-app-container .appointment-app-top h1,.appointment-app-container .appointment-app-top h2,.appointment-app-container .appointment-app-top h3,.appointment-app-container .appointment-app-top h4,.appointment-app-container .appointment-app-top h5{color:#fff;margin:0;padding:0 0 25px;font-family:HCo Gotham,Gotham SSm A,Gotham SSm B,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:200}.appointment-app-container .appointment-app-top a{color:#fff}.appointment-app-container .appointment-app-content{max-width:920px;margin:0 auto;padding:30px 15px}.appointment-app-container .application-get-started{margin-bottom:0;padding-bottom:.8rem}.appointment-app-container .application-npn-container{padding:18px 0}.appointment-app-container .application-subsection{padding:30px 0 0}.appointment-app-container .application-section{margin:0 0 1.6rem}.appointment-app-container .application-form-section{padding:30px 0;margin-top:15px;border-bottom:1px solid #ddd}.appointment-app-container .application-form-section:last-child{border-bottom:0}.appointment-app-container .application-form-section--top{padding-top:0}.appointment-app-container .application-paragraph{margin-bottom:15px}.appointment-app-container .application-actions__previous{text-align:left;float:left}.appointment-app-container .application-actions__next{text-align:right;float:right}.appointment-app-container .application-action-title{margin:0 0 1rem;padding:0;color:#4c4c4f;text-transform:uppercase;font-size:20px;font-weight:900}.appointment-app-container .application-subtitle{margin:0 0 1rem;padding:0;text-transform:none;font-size:24px;font-family:HCo Gotham,Gotham SSm A,Gotham SSm B,Gotham A,Gotham B,Calibri,Meta,Open Sans Condensed,sans-serif;font-style:normal;font-weight:200}.appointment-app-container .application-pretext-list{margin:15px 0;padding-left:2rem;font-size:14px}.appointment-app-container .application-pdf-container{width:720px;height:720px;background:#f3f3f3;border:1px solid #ddd;margin:0 auto 50px;position:relative;overflow:scroll;-webkit-overflow-scrolling:touch;overflow-y:scroll}@media only screen and (min-width:768px){.appointment-app-container .application-pdf-container{height:50rem}}.appointment-app-container .application-pdf-container iframe{height:100%;width:100%;position:absolute;top:1rem;left:1rem;right:1rem;bottom:1rem;border:1px solid #ccc}@media only screen and (min-width:768px){.appointment-app-container .application-pdf-container iframe{top:0;left:0;right:0;bottom:0;border:0}}.appointment-app-container .application-previous-btn.btn{background:transparent;border:0;text-align:left;color:#919496;padding-left:0}.appointment-app-container .application-npn-link{display:inline-block;margin-bottom:1rem}@media (min-width:768px){.appointment-app-container .application-npn-link{margin-top:32px}}.appointment-app-container .application-gender-group,.appointment-app-container .application-radio-group{padding:0 0 .75rem}.appointment-app-container .application-gender-group span,.appointment-app-container .application-radio-group span{padding:0 .75rem 0 .5rem}.appointment-app-container .application-questions-list{list-style-type:none;margin:0 0 30px;padding:0}.appointment-app-container .application-questions-list li{padding:1rem 0;border-bottom:1px solid #ccc;margin-bottom:-1px}.appointment-app-container .application-questions-list li:last-child{padding-bottom:0;border-bottom:0}.appointment-app-container .application-radio-option{width:auto;display:inline-block;padding-right:.3rem}.appointment-app-container .application-radio-option input{margin:0 .3rem 0 0}.appointment-app-container .application-acknowledgement .field{min-height:35px}.appointment-app-container .application-questions-field label{padding-left:35px}.appointment-app-container .application-acknowledgement-label{font-weight:400;min-height:1rem;float:left;padding-left:35px;margin-bottom:1rem}.appointment-app-container .application-acknowledgement-label input{position:absolute}.appointment-app-container birthday-picker legend{display:none}.appointment-app-container birthday-picker label:after{content:\"*\"}.appointment-app-container .application-subquestions-list{list-style-type:none;margin:0;padding:0}.appointment-app-container .application-subquestions-list:not(:empty){margin:1rem 0;border-top:1px solid #ccc}.appointment-app-container .application-subquestions-list li{padding:1rem;padding-right:0}.appointment-app-container .application-question-response{background:#f3f3f3;padding:1rem;margin:1rem 0;position:relative;background:#fff;border:2px solid #f3f3f3;max-width:400px;width:100%;margin:2rem auto}.appointment-app-container .application-questions-field{display:inline-block;margin:1rem;vertical-align:top;min-height:1.8rem;padding-top:.1rem;margin-top:1rem}@media only screen and (min-width:768px){.appointment-app-container .application-questions-field{margin-top:0;margin-right:0;margin-bottom:0;float:right}}.appointment-app-container .application-questions-field label:after,.appointment-app-container .application-questions-field label:before{top:0}.appointment-app-container .application-questions-field input{opacity:0;position:absolute;top:0;left:0;width:0;height:0}.appointment-app-container .application-update__submit{width:175px}.appointment-app-container .address-validator-message{margin-bottom:10px}.appointment-app-container .address-validator-coverage-address{margin-bottom:.4rem}.appointment-app-container .address-validator-address,.appointment-app-container .address-validator-entered-address{margin-bottom:1.6rem}.appointment-app-container .address-validator-address__content{padding-bottom:1.6rem}@media only screen and (min-width:768px){.appointment-app-container .address-validator-address__content{padding-bottom:0}}.appointment-app-container .address-validator-address__action .btn{width:100%}@media only screen and (min-width:768px){.appointment-app-container .address-validator-address__action .btn{width:auto}}@media only screen and (min-width:768px){.appointment-app-container .address-validator-address__action{text-align:right}}@media only screen and (max-width:767px){.appointment-app-container .address-validator-verify-address__title{font-size:1.4rem}}@media only screen and (max-width:767px){.appointment-app-container .address-validator-verify-address__sub-title{font-size:1.2rem;margin:0 0 .7rem;padding:0}}.appointment-app-container .address-validator-verify-address__paragraph{margin:0 0 1.6rem;padding:0}.appointment-app-container .application-thank-you{padding:0;margin:15px 0;text-align:center}", ""]);

// exports


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-top\"\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Ch1 class=\"page-title\"\u003EAgency Information\u003C\u002Fh1\u003E\u003Cp\u003EIf you are working with an agency, please enter your agency information\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Caddress-validator ng-model=\"addressErrorDetails\" edit-address=\"editAddress\" select-address=\"selectAddress\" ng-if=\"addressErrorDetails\"\u003E\u003C\u002Faddress-validator\u003E\u003Cdiv class=\"spinner-container\" ng-if=\"loading\"\u003E\u003Cdiv class=\"spinner\"\u003ELoading\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container\" ng-if=\"!loading\"\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\" ng-show=\"!addressErrorDetails.addresses.length\"\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"agentForm.$submitted &amp;&amp; !agentForm.$valid\"\u003E\u003Cdiv ng-messages=\"agentForm.agencyName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an agency name.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid agency name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.businessAddress.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a street address.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid street address.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.businessCity.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a city.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.businessState.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a state.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.businessZipCode.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a zip code.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid zip code.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.businessPhone.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a phone number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid 10 digit phone number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.businessFax.$error\"\u003E\u003Cspan ng-message=\"pattern\"\u003EFax number is not valid 10 digit fax number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.businessEmail.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an email address.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"email\"\u003EYou must enter a valid email.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid email address.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.businessFedTaxID.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a tax id.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid tax id.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.taxClassification.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must select a tax classification.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"agencyLicense in agencyInformation.agencyLicenses\"\u003E\u003Cdiv ng-messages=\"agentForm[&quot;agencyLicenseNumber&quot; + $index].$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an agency license number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid agency license number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"min\"\u003EYour agency license expiration date must be in the future.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"max\"\u003EYour agency license expiration date must be in the near future.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm[&quot;agencyLicenseExpiration&quot; + $index].$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an agency license expiration date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"invalid\"\u003EYou must enter a valid agency license expiration date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"date\"\u003EYou must enter a valid agency license expiration date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"min\"\u003EYour agency license expiration date must be in the future.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"max\"\u003EYour agency license expiration date must be in the near future.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-section\"\u003E\u003Ch3\u003EAgency Information\u003C\u002Fh3\u003E\u003Cfieldset\u003E\u003Clegend\u003EAre you currently working with an agency?\u003C\u002Flegend\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"radio\" value=\"true\" ng-value=\"true\" name=\"agencyInformation.usingAgency\" id=\"usingAgencyYes\" ng-model=\"agencyInformation.usingAgency\"\u003E\u003Clabel class=\"radio-label\" for=\"usingAgencyYes\"\u003EYes\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"radio\" value=\"false\" ng-value=\"false\" name=\"agencyInformation.usingAgency\" id=\"usingAgencyNo\" ng-model=\"agencyInformation.usingAgency\"\u003E\u003Clabel class=\"radio-label\" for=\"usingAgencyNo\"\u003ENo\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003Cdiv ng-if=\"agencyInformation.usingAgency\"\u003E\u003Cdiv class=\"application-section\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"agencyName\" id=\"agencyName\" ng-model=\"agencyInformation.name\" required maxlength=\"255\"\u003E\u003Clabel for=\"agencyName\"\u003EAgency Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"businessAddress\" id=\"businessAddress\" ng-model=\"agencyInformation.businessAddress\" required maxlength=\"255\"\u003E\u003Clabel class=\"no-after\" for=\"businessAddress\"\u003EAddress Line 1*\u003Cspan class=\"label-disclaimer\"\u003E(Street Address or PO Box)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"businessAddress2\" id=\"businessAddress2\" ng-model=\"agencyInformation.businessAddress2\" maxlength=\"255\"\u003E\u003Clabel for=\"businessAddress2\"\u003EAddress Line 2\u003Cspan class=\"label-disclaimer\"\u003E(Apartment, unit, suite, etc.)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"businessCity\" id=\"businessCity\" ng-model=\"agencyInformation.businessCity\" required maxlength=\"40\"\u003E\u003Clabel for=\"businessCity\"\u003ECity\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cselect name=\"businessState\" id=\"businessState\" ng-model=\"agencyInformation.businessState\" ng-options=\"key as value for (key, value) in statesOptions\" required maxlength=\"80\"\u003E\u003Coption value=\"\"\u003EState\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"businessState\"\u003EState\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"businessZipCode\" id=\"businessZipCode\" ng-model=\"agencyInformation.businessZipCode\" pattern=\"{{ validations.zipCode }}\" maxlength=\"10\" required\u003E\u003Clabel for=\"businessZipCode\"\u003EZip Code\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"tel\" value=\"\" placeholder=\"\" name=\"businessPhone\" id=\"businessPhone\" ng-model=\"agencyInformation.businessPhone\" angular-mask=\"(999) 999-9999\" pattern=\"{{ validations.phone }}\" maxlength=\"14\" required\u003E\u003Clabel for=\"businessPhone\"\u003EAgency Phone Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"businessFax\" id=\"businessFax\" ng-model=\"agencyInformation.businessFax\" angular-mask=\"(999) 999-9999\" pattern=\"{{ validations.phone }}\" maxlength=\"14\" restrict=\"reject\"\u003E\u003Clabel for=\"businessFax\"\u003EAgency Fax Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"email\" value=\"\" placeholder=\"\" name=\"businessEmail\" id=\"businessEmail\" ng-model=\"agencyInformation.businessEmail\" pattern=\"{{ validations.email }}\" required maxlength=\"80\"\u003E\u003Clabel for=\"businessEmail\"\u003EAgency Email\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"businessFedTaxID\" id=\"businessFedTaxID\" ng-model=\"agencyInformation.businessFedTaxID\" angular-mask=\"99-9999999\" maxlength=\"10\" pattern=\"{{ validations.ein }}\" required\u003E\u003Clabel for=\"businessFedTaxID\"\u003EFederal Tax ID\u003C\u002Flabel\u003E\u003Cp style=\"display: inline-block\"\u003E* If Appointed Agent is unable to sign Agency W9, please use 99-9999999 and provide a copy of the company's signed W9 to \u003Ca href=\"mailto:ddmnbroker@deltadentalmn.org\"\u003Eddmnbroker@deltadentalmn.org\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cselect name=\"taxClassification\" id=\"taxClassification\" ng-model=\"agencyInformation.taxClassification\" ng-options=\"key as value for (key, value) in taxClassifications\" required\u003E\u003Coption value=\"\"\u003ETax Classification\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"taxClassification\"\u003ETax Classification\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-section\" ng-if=\"!previouslyAppointed\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3 class=\"page-title\"\u003EAgency Licenses\u003C\u002Fh3\u003E\u003Cp ng-if=\"agencyInformation.agencyLicenses.length === 1\"\u003EProvide agency license for the state you wish to sell.\u003C\u002Fp\u003E\u003Cp ng-if=\"agencyInformation.agencyLicenses.length &gt; 1\"\u003EProvide agency licenses for the states you wish to sell.\u003C\u002Fp\u003E\u003Cdiv class=\"row\" ng-repeat=\"agencyLicense in agencyInformation.agencyLicenses\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-7\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"agencyLicenseNumber{{ $index }}\" id=\"agencyLicenseNumber{{ $index }}\" ng-model=\"agencyLicense.number\" pattern=\"{{ validations.license }}\" required\u003E\u003Clabel for=\"agencyLicenseNumber{{ $index }}\"\u003E{{ agencyLicense.state }} Agency License Number\u003C\u002Flabel\u003E\u003Cp style=\"display: inline-block\"\u003E* If Agency License number is unknown, please use 9999 and provide a copy of the company's insurance license(s) to \u003Ca href=\"mailto:ddmnbroker@deltadentalmn.org\"\u003Eddmnbroker@deltadentalmn.org\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-5\"\u003E\u003Cinput placeholder=\"\" name=\"agencyLicenseExpiration{{ $index }}\" id=\"agencyLicenseExpiration{{ $index }}\" ng-model=\"agencyLicense.expirationDate\" max-date=\"agencyLicense.maxExpirationDate\" date-required=\"agencyLicense.dateRequired\" autocomplete=\"off\" date-picker\u003E\u003Clabel for=\"agencyLicenseExpiration{{ $index }}\"\u003EExpiration Date\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!previouslyAppointed\"\u003E\u003Cdiv class=\"application-section\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3 class=\"page-title\"\u003EGeneral Agency \u003C\u002Fh3\u003E\u003Cp class=\"label-text\"\u003EIf you work with a general agency, please provide the name below.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"generalAgencyName\" id=\"generalAgencyName\" ng-model=\"agencyInformation.generalAgencyName\" ng-readonly=\"agencyInformation.autoCompletedGeneralAgencyName\"\u003E\u003Clabel for=\"generalAgencyName\"\u003EGeneral Agency Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cactions\u003E\u003C\u002Factions\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-top\"\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Ch1\u003EBroker Information\u003C\u002Fh1\u003E\u003Cp\u003ETo complete your application, please tell us a bit about yourself\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Caddress-validator ng-model=\"addressErrorDetails\" edit-address=\"editAddress\" select-address=\"selectAddress\" ng-if=\"addressErrorDetails\"\u003E\u003C\u002Faddress-validator\u003E\u003Cdiv class=\"spinner-container\" ng-if=\"loading\"\u003E\u003Cdiv class=\"spinner\"\u003ELoading\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container\" ng-if=\"!loading\"\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\" ng-show=\"!addressErrorDetails.addresses.length\"\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"agentForm.$submitted &amp;&amp; !agentForm.$valid\"\u003E\u003Cdiv ng-messages=\"agentForm.firstName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a first name.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid first name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.middleName.$error\"\u003E\u003Cspan ng-message=\"pattern\"\u003EMiddle name is not a valid name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.lastName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a last name.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid last name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.email.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an email.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"email\"\u003EYou must enter a valid email.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid email.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.birthday.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a birth date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"invalid\"\u003EYou must enter a valid birth date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid birth date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"max\"\u003EYou must be at least 18 years old.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"min\"\u003EYou must enter a valid birth date.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.gender.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must select a gender.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.nickname.$error\"\u003E\u003Cspan ng-message=\"pattern\"\u003ENot a valid name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.streetAddress.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a street address.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid street address.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.city.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a city.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.state.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a state.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.zipCode.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a zip code.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid zip code.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.resTelephone.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a residential phone number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid 10 digit phone number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.ssn.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a social security number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid social security number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-repeat=\"brokerLicense in brokerInformation.brokerLicenses\"\u003E\u003Cdiv ng-messages=\"agentForm[&quot;brokerLicenseNumber&quot; + $index].$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a broker license number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid broker license number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm[&quot;brokerLicenseExpiration&quot; + $index].$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a broker license expiration date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid broker license expiration date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"date\"\u003EYou must enter a valid broker license expiration date.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"min\"\u003EYour broker license expiration date must be in the future.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"max\"\u003EYour broker license expiration date must be in the near future.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-section\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3\u003EPersonal Information\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"firstName\" id=\"firstName\" ng-model=\"brokerInformation.firstName\" pattern=\"{{ validations.name }}\" required maxlength=\"40\"\u003E\u003Clabel for=\"firstName\"\u003EFirst Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"middleName\" id=\"middleName\" ng-model=\"brokerInformation.middleName\" pattern=\"{{ validations.name }}\" maxlength=\"20\"\u003E\u003Clabel for=\"middleName\"\u003EMiddle Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"lastName\" id=\"lastName\" ng-model=\"brokerInformation.lastName\" pattern=\"{{ validations.name }}\" required maxlength=\"80\"\u003E\u003Clabel for=\"lastName\"\u003ELast Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"nickname\" id=\"nickname\" ng-model=\"brokerInformation.nickname\" maxlength=\"30\"\u003E\u003Clabel for=\"nickname\"\u003ENickname\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cselect name=\"gender\" ng-model=\"brokerInformation.gender\" id=\"gender\" required\u003E\u003Coption value=\"\"\u003EGender\u003C\u002Foption\u003E\u003Coption value=\"F\"\u003EFemale\u003C\u002Foption\u003E\u003Coption value=\"M\"\u003EMale\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"gender\"\u003EGender\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cbirthday-picker name=\"birthday\" ng-model=\"brokerInformation.birthday\" min=\"hundredYearsAgo\" max=\"eighteenYearsAgo\"\u003E\u003C\u002Fbirthday-picker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"email\" value=\"\" name=\"email\" id=\"email\" ng-model=\"brokerInformation.email\" pattern=\"{{ validations.email }}\" required maxlength=\"80\"\u003E\u003Clabel for=\"email\"\u003EEmail\u003C\u002Flabel\u003E\u003Cp\u003ENote: Renewal Notices will be delivered electronically, so please ensure the email address provided is accurate.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"streetAddress\" id=\"streetAddress\" ng-model=\"brokerInformation.streetAddress\" required maxlength=\"255\"\u003E\u003Clabel class=\"no-after\" for=\"streetAddress\"\u003EAddress Line 1*\u003Cspan class=\"label-disclaimer\"\u003E(Street Address)\u003C\u002Fspan\u003E\u003Cp\u003ENote: Address will be used to run background checks, so please no PO Boxes.\u003C\u002Fp\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"streetAddress2\" id=\"streetAddress2\" ng-model=\"brokerInformation.streetAddress2\" maxlength=\"255\"\u003E\u003Clabel for=\"streetAddress2\"\u003EAddress Line 2\u003Cspan class=\"label-disclaimer\"\u003E(Apartment, unit, suite, etc.)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"city\" id=\"city\" ng-model=\"brokerInformation.city\" required maxlength=\"40\"\u003E\u003Clabel for=\"city\"\u003ECity\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cselect name=\"state\" id=\"state\" ng-model=\"brokerInformation.state\" ng-options=\"key as value for (key, value) in statesOptions\" required maxlength=\"80\"\u003E\u003Coption value=\"\"\u003ESelect\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"state\"\u003EState\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"zipCode\" id=\"zipCode\" ng-model=\"brokerInformation.zipCode\" pattern=\"{{ validations.zipCode }}\" maxlength=\"10\" required\u003E\u003Clabel for=\"zipCode\"\u003EZip Code\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"tel\" value=\"\" name=\"resTelephone\" id=\"resTelephone\" ng-model=\"brokerInformation.resTelephone\" angular-mask=\"(999) 999-9999\" pattern=\"{{ validations.phone }}\" maxlength=\"14\" required\u003E\u003Clabel for=\"resTelephone\"\u003EPreferred Phone Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" id=\"ssn\" name=\"ssn\" ng-model=\"brokerInformation.ssn\" ssn maxlength=\"11\" required\u003E\u003Clabel for=\"ssn\"\u003ESocial Security Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-section\" ng-if=\"!previouslyAppointed\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3\u003EBroker Licenses\u003C\u002Fh3\u003E\u003Cp class=\"label-text\" ng-if=\"brokerInformation.brokerLicenses.length === 1\"\u003EProvide your broker license for the state you wish to sell.\u003C\u002Fp\u003E\u003Cp class=\"label-text\" ng-if=\"brokerInformation.brokerLicenses.length &gt; 1\"\u003EProvide your broker licenses for the states you wish to sell.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"brokerLicense in brokerInformation.brokerLicenses\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" name=\"brokerLicenseNumber{{ $index }}\" id=\"brokerLicenseNumber{{$index}}\" ng-model=\"brokerLicense.number\" pattern=\"{{ validations.license }}\" required maxlength=\"50\"\u003E\u003Clabel for=\"brokerLicenseNumber{{$index}}\"\u003E{{ brokerLicense.state }} Broker License Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput name=\"brokerLicenseExpiration{{ $index }}\" id=\"brokerLicenseExpiration{{$index}}\" ng-model=\"brokerLicense.expirationDate\" min-date=\"brokerLicense.minExpirationDate\" max-date=\"brokerLicense.maxExpirationDate\" date-required=\"brokerLicense.dateRequired\" date-picker\u003E\u003Clabel for=\"brokerLicenseExpiration{{ $index }}\"\u003EExpiration Date\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cactions\u003E\u003C\u002Factions\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-top\"\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Ch1 class=\"page-title\"\u003ECommission Assignment\u003C\u002Fh1\u003E\u003Cp\u003EEnter your commission payment information\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Caddress-validator ng-model=\"addressErrorDetails\" edit-address=\"editAddress\" select-address=\"selectAddress\" ng-if=\"addressErrorDetails\"\u003E\u003C\u002Faddress-validator\u003E\u003Cdiv class=\"spinner-container\" ng-if=\"loading\"\u003E\u003Cdiv class=\"spinner\"\u003ELoading\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"!loading &amp;&amp; failure\"\u003ECould not submit data. Please try again later.\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container\" ng-if=\"!loading\"\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\" ng-show=\"!addressErrorDetails.addresses.length\"\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"agentForm.$submitted &amp;&amp; !agentForm.$valid\"\u003E\u003Cdiv ng-messages=\"agentForm.assigneeName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an agency name.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeAddress.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a street address.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid street address.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeCity.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a city.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeState.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must select a state.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeZipCode.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a zip code.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid zip code.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneePhone.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a phone number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid 10 digit phone number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeEmail.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an assignee email.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"email\"\u003EYou must enter a valid assignee email.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid assignee email.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeTaxID.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a tax id number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid tax id.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.taxClassification.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must select a tax classification.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.accountOwner.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter the account owner's name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.financialInstitutionName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a financial institution name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finEmailAddress.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an email for direct deposit statements.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"email\"\u003EYou must enter a valid email for direct deposit statements.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid email for direct deposit statements.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finInstStreetAddress.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a street address.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finInstCity.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a city.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finInstState.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must select a state.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finInstZipCode.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a zip code.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid zip code.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.routingNumber.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a routing number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid routing number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.accountNumber.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an account number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid account number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section-container\"\u003E\u003Cdiv class=\"application-form-section application-form-section--top\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3\u003ECommission Assignment\u003C\u002Fh3\u003E\u003Cfieldset\u003E\u003Clegend\u003EWho do you want to receive your commission payments?\u003C\u002Flegend\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"radio\" value=\"myself\" name=\"assignee\" ng-model=\"commissionInformation.assignee\" id=\"myself\"\u003E\u003Clabel class=\"radio-label\" for=\"myself\"\u003EMe\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field\" ng-if=\"agencyInformation.usingAgency\"\u003E\u003Cinput type=\"radio\" value=\"agency\" name=\"assignee\" ng-model=\"commissionInformation.assignee\" id=\"agency\"\u003E\u003Clabel class=\"radio-label\" for=\"agency\"\u003EMy agency\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"radio\" value=\"third_party\" name=\"assignee\" ng-model=\"commissionInformation.assignee\" id=\"third_party\"\u003E\u003Clabel class=\"radio-label\" for=\"third_party\"\u003EA different agency or business entitity\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\" ng-if=\"commissionInformation.assignee === &quot;myself&quot;\"\u003E\u003Cp\u003E\u003Ch3\u003EAssignee Information\u003C\u002Fh3\u003E\u003Cdiv\u003E\u003Cstrong\u003E{{brokerInformation.firstName}} {{brokerInformation.lastName}} \u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E{{brokerInformation.streetAddress}}\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"brokerInformation.streetAddress\"\u003E{{brokerInformation.streetAddress2}}\u003C\u002Fdiv\u003E\u003Cdiv\u003E{{brokerInformation.city}}, {{brokerInformation.state}}, {{brokerInformation.zipCode}}\u003C\u002Fdiv\u003E\u003Cdiv\u003ESSN: *** - ** - {{brokerInformation.ssn | limitTo : 4 : 5}}\u003C\u002Fdiv\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\" ng-if=\"commissionInformation.assignee === &quot;agency&quot;\"\u003E\u003Cp\u003E\u003Ch3\u003EAssignee Information\u003C\u002Fh3\u003E\u003Cdiv\u003E\u003Cstrong\u003E{{agencyInformation.name}}\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E{{agencyInformation.businessAddress}}\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"agencyInformation.businessAddress2\"\u003E{{agencyInformation.businessAddress2}}\u003C\u002Fdiv\u003E\u003Cdiv\u003E{{agencyInformation.businessCity}}, {{agencyInformation.businessState}}, {{agencyInformation.businessZipCode}}\u003C\u002Fdiv\u003E\u003Cdiv\u003ETax ID: {{agencyInformation.businessFedTaxID}}\u003C\u002Fdiv\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\" ng-if=\"commissionInformation.assignee === &quot;third_party&quot;\"\u003E\u003Ch3\u003EAssignee Information\u003C\u002Fh3\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeName\" id=\"assigneeName\" ng-model=\"commissionInformation.assigneeName\" required maxlength=\"255\"\u003E\u003Clabel for=\"assigneeName\"\u003EAgency Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeAddress\" id=\"assigneeAddress\" ng-model=\"commissionInformation.assigneeAddress\" required maxlength=\"255\"\u003E\u003Clabel class=\"no-after\" for=\"assigneeAddress\"\u003EAddress Line 1*\u003Cspan class=\"label-disclaimer\"\u003E(Street Address or PO Box)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeAddress2\" id=\"assigneeAddress2\" ng-model=\"commissionInformation.assigneeAddress2\" maxlength=\"255\"\u003E\u003Clabel for=\"assigneeAddress2\"\u003EAddress Line 2\u003Cspan class=\"label-disclaimer\"\u003E(Apartment, unit, suite, etc.)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeCity\" id=\"assigneeCity\" ng-model=\"commissionInformation.assigneeCity\" required maxlength=\"40\"\u003E\u003Clabel for=\"assigneeCity\"\u003ECity\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cselect name=\"assigneeState\" id=\"assigneeState\" ng-model=\"commissionInformation.assigneeState\" ng-options=\"key as value for (key, value) in statesOptions\" ng-disabled=\"commissionInformation.sameAsAgency\" required\u003E\u003Coption value=\"\"\u003ESelect\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"assigneeState\"\u003EState\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeZipCode\" id=\"assigneeZipCode\" ng-model=\"commissionInformation.assigneeZipCode\" pattern=\"{{ validations.zipCode }}\" required\u003E\u003Clabel for=\"assigneeZipCode\"\u003EZip Code\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneePhone\" id=\"assigneePhone\" ng-model=\"commissionInformation.assigneePhone\" angular-mask=\"(999) 999-9999\" maxlength=\"14\" pattern=\"{{ validations.phone }}\" restrict=\"reject\" required\u003E\u003Clabel for=\"assigneePhone\"\u003EPhone Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"email\" value=\"\" name=\"assigneeEmail\" id=\"assigneeEmail\" ng-model=\"commissionInformation.assigneeEmail\" pattern=\"{{ validations.email }}\" required maxlength=\"80\"\u003E\u003Clabel for=\"assigneeEmail\"\u003E Assignee Email Address\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeTaxID\" id=\"assigneeTaxID\" ng-model=\"commissionInformation.assigneeTaxID\" angular-mask=\"99-9999999\" maxlength=\"10\" pattern=\"{{ validations.ein }}\" required\u003E\u003Clabel for=\"assigneeTaxID\"\u003EFederal Tax ID\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cselect name=\"taxClassification\" id=\"taxClassification\" ng-model=\"commissionInformation.taxClassification\" ng-options=\"key as value for (key, value) in taxClassifications\" required\u003E\u003Coption value=\"\"\u003ESelect\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"taxClassification\"\u003ETax Classification\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3 class=\"page-title\"\u003EDirect Deposit Setup\u003C\u002Fh3\u003E\u003Cp class=\"application-paragraph\"\u003ETo assign commissions to your agency, you are required to provide your agency's checking account information.\u003C\u002Fp\u003E\u003Cdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!commissionInformation.payViaCheck\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"accountOwner\" id=\"accountOwner\" ng-model=\"commissionInformation.accountOwner\" required maxlength=\"255\"\u003E\u003Clabel for=\"accountOwner\"\u003EAccount Owner\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"email\" value=\"\" name=\"finEmailAddress\" id=\"finEmailAddress\" ng-model=\"commissionInformation.finEmailAddress\" pattern=\"{{ validations.email }}\" required maxlength=\"80\"\u003E\u003Clabel for=\"finEmailAddress\"\u003EEmail for direct deposit statements\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"financialInstitutionName\" id=\"financialInstitutionName\" ng-model=\"commissionInformation.financialInstitutionName\" required maxlength=\"255\"\u003E\u003Clabel for=\"financialInstitutionName\"\u003EFinancial Institution Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"finInstStreetAddress\" id=\"finInstStreetAddress\" ng-model=\"commissionInformation.finInstStreetAddress\" required maxlength=\"255\"\u003E\u003Clabel class=\"no-after\" for=\"finInstStreetAddress\"\u003EAddress Line 1*\u003Cspan class=\"label-disclaimer\"\u003E(Street Address or PO Box)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"finInstStreetAddress2\" id=\"finInstStreetAddress2\" ng-model=\"commissionInformation.finInstStreetAddress2\" maxlength=\"255\"\u003E\u003Clabel for=\"finInstStreetAddress2\"\u003EAddress Line 2\u003Cspan class=\"label-disclaimer\"\u003E(Apartment, unit, suite, etc.)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"finInstCity\" id=\"finInstCity\" ng-model=\"commissionInformation.finInstCity\" required maxlength=\"40\"\u003E\u003Clabel for=\"finInstCity\"\u003ECity\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cselect name=\"finInstState\" id=\"finInstState\" ng-model=\"commissionInformation.finInstState\" ng-options=\"key as value for (key, value) in statesOptions\" required\u003E\u003Coption value=\"\"\u003ESelect \u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"finInstState\"\u003EState\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"finInstZipCode\" id=\"finInstZipCode\" ng-model=\"commissionInformation.finInstZipCode\" pattern=\"{{ validations.zipCode }}\" required\u003E\u003Clabel for=\"finInstZipCode\"\u003EZip Code\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"routingNumber\" id=\"routingNumber\" ng-model=\"commissionInformation.routingNumber\" pattern=\"{{ validations.routingNumber }}\" required maxlength=\"9\"\u003E\u003Clabel for=\"routingNumber\"\u003ERouting Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"accountNumber\" id=\"accountNumber\" ng-model=\"commissionInformation.accountNumber\" required maxlength=\"20\"\u003E\u003Clabel for=\"accountNumber\"\u003EAccount Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput class=\"checkbox\" type=\"checkbox\" name=\"payViaCheck\" id=\"payViaCheck\" ng-model=\"commissionInformation.payViaCheck\" ng-false-value=\"false\" ng-true-value=\"true\"\u003E\u003Clabel for=\"payViaCheck\"\u003EPay commissions via check instead of direct deposit.\u003C\u002Flabel\u003E\u003Cspan class=\"label-disclaimer\"\u003E*Check this box if Agency ACH information is unknown\u002Fnot provided. This will allow Appointed Agent to bypass the ACH section.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"application-paragraph\" ng-if=\"commissionInformation.payViaCheck\"\u003EChecks will be mailed to the Broker or the designated assignee.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cactions\u003E\u003C\u002Factions\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-content\"\u003E\u003Cdiv class=\"form-container\"\u003E\u003Ch1 class=\"page-title\"\u003EAgent Appointment Application\u003C\u002Fh1\u003E\u003Cp class=\"application-pretext-paragraph\"\u003EThis application is for brokers interested in applying to sell Delta Dental insurance.\u003Cbr\u003ETo complete this application, be ready to provide the following information:\u003C\u002Fp\u003E\u003Cul class=\"application-pretext-list\"\u003E\u003Cli\u003EPersonal information, including SSN.\u003C\u002Fli\u003E\u003Cli\u003EAgency information, including Federal Tax ID and business licenses.\u003C\u002Fli\u003E\u003Cli\u003EBroker license information for both your resident state and the state you wish to be appointed in.\u003C\u002Fli\u003E\u003Cli\u003EChecking account information for Direct Deposit setup.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp class=\"application-pretext-paragraph\"\u003EAfter you complete the application, you will be asked to e-sign several digital forms. Estimated time to complete the application is 20 minutes.\u003Cbr\u003E\u003Cbr\u003EIf you have previously applied to sell Delta Dental insurance in \u003Cspan ng-if=\"currentSite == &quot;mn&quot;\"\u003EMinnesota or North Dakota\u003C\u002Fspan\u003E\u003Cspan ng-if=\"currentSite == &quot;ne&quot;\"\u003ENebraska\u003C\u002Fspan\u003E and wish to update your appointments, \u003Cstrong\u003Edo not \u003C\u002Fstrong\u003Euse this form. Rather, contact us via email at \u003Ca href=\"mailto:{{ contactEmail }}\"\u003E{{ contactEmail }}\u003C\u002Fa\u003E or through the phone at 1-855-648-1409.\u003C\u002Fp\u003E\u003Cdiv class=\"appointment-get-started\"\u003E\u003Cdiv class=\"spinner-container\" ng-if=\"loading\"\u003E\u003Cdiv class=\"spinner\"\u003ELoading\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\" ng-if=\"!loading\"\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"npnError || agentForm.$submitted &amp;&amp; !agentForm.$valid\"\u003E\u003Cdiv ng-if=\"npnError\"\u003EWe've found a matching record in our system. \u003Cbr\u003EPlease contact us at \u003Ca href=\"mailto:{{ contactEmail }}\"\u003E{{ contactEmail }}\u003C\u002Fa\u003E or 1-855-648-1409 to continue the appointment process.\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!npnError\"\u003EPlease correct the errors below.\u003Cdiv ng-messages=\"agentForm.brokerInformation_npn.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an NPN number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid NPN number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"agentForm.$submitted &amp;&amp; agentForm.selectedStates.$error.required\"\u003EYou must select a state.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch2 class=\"application-get-started\"\u003EGet Started\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-5\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"12345678\" name=\"npnNumber\" id=\"npnNumber\" ng-model=\"brokerInformation.npn\" required pattern=\"{{ validations.numeric }}\" maxlength=\"12\"\u003E\u003Clabel for=\"npnNumber\"\u003ENPN Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-4\"\u003E\u003Cdiv class=\"application-npn-container\"\u003E\u003Ca href=\"http:\u002F\u002Fwww.nipr.com\u002FPacNpnSearch.htm\" target=\"_BLANK\"\u003EFind your NPN\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12 clearfix\"\u003E\u003Cfieldset\u003E\u003Clegend\u003EYour Requested Appointment State(s):\u003C\u002Flegend\u003E\u003Cdiv ng-if=\"currentSite == &quot;mn&quot;\"\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"checkbox\" name=\"selectedStates\" ng-model=\"selectedStates.MN\" ng-required=\"!selectedOneState()\" ng-true-value=\"true\" ng-false-value=\"false\" id=\"stateMN\"\u003E\u003Clabel for=\"stateMN\"\u003EMinnesota\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"checkbox\" name=\"selectedStates\" ng-model=\"selectedStates.ND\" ng-required=\"!selectedOneState()\" ng-true-value=\"true\" ng-false-value=\"false\" id=\"stateND\"\u003E\u003Clabel for=\"stateND\"\u003ENorth Dakota\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"currentSite == &quot;ne&quot;\"\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"checkbox\" name=\"selectedStates\" ng-model=\"selectedStates.NE\" ng-required=\"!selectedOneState()\" ng-true-value=\"true\" ng-false-value=\"false\" id=\"stateNE\"\u003E\u003Clabel for=\"stateNE\"\u003ENebraska\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"selectedStates.MN\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12 clearfix\"\u003E\u003Cfieldset\u003E\u003Clegend\u003E Are you interested in selling Delta Dental plans at the same time as Medica Individual and Family Medical Plans?\u003Cbr\u003ENote: Select yes ONLY if you are currently appointed to sell Medica insurance plans\u003C\u002Flegend\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput id=\"medicaQualifiedYes\" type=\"radio\" name=\"brokerInformationMedica\" ng-model=\"brokerInformation.medicaQualified\" ng-value=\"true\" required\u003E\u003Clabel for=\"medicaQualifiedYes\"\u003EYes\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput id=\"medicaQualifiedNo\" type=\"radio\" name=\"brokerInformationMedica\" ng-model=\"brokerInformation.medicaQualified\" ng-value=\"false\" required\u003E\u003Clabel for=\"medicaQualifiedNo\"\u003ENo\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"application-actions col-xs-12\"\u003E\u003Cbutton class=\"btn btn-info\" type=\"submit\"\u003ECONTINUE\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-top\"\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Ch1 class=\"page-title page-title--show\"\u003EProducer Declaration\u003C\u002Fh1\u003E\u003Cp\u003EIf you answer \"yes\" to any of the questions below, you will be required to provide specific documentation and full disclosure of the incidents or situation (i.e. legal documentation, etc.)\u003C\u002Fp\u003E\u003Cp style=\"display: inline\"\u003E*Send any documentation\u002Fdisclosures to \u003Ca href=\"mailto:ddmnbroker@deltadentalmn.org\"\u003Eddmnbroker@deltadentalmn.org\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Cdiv class=\"spinner-container\" ng-if=\"loading\"\u003E\u003Cdiv class=\"spinner\"\u003ELoading\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"!loading &amp;&amp; failure\"\u003ECould not submit data. Please try again later.\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container\" ng-if=\"!loading\"\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\"\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"agentForm.$submitted &amp;&amp; !agentForm.$valid\"\u003EPlease correct the errors below.\u003C\u002Fdiv\u003E\u003Cul class=\"application-questions-list\"\u003E\u003Cli ng-repeat=\"(declarationKey, declaration) in declarations.questionsAndResponses\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-8\"\u003E{{ declarationKey }}.\n{{ declaration.question }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-4 text-center\" ng-if=\"declaration.subQuestions == null\"\u003E\u003Cdiv class=\"field application-questions-field\"\u003E\u003Cinput class=\"radio\" type=\"radio\" id=\"declarations[{{ declarationKey }}][0]\" ng-value=\"true\" ng-model=\"declaration.response\"\u003E\u003Clabel for=\"declarations[{{ declarationKey }}][0]\"\u003EYes\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field application-questions-field\"\u003E\u003Cinput class=\"radio\" id=\"declarations[{{ declarationKey }}][1]\" type=\"radio\" ng-value=\"false\" ng-model=\"declaration.response\"\u003E\u003Clabel for=\"declarations[{{ declarationKey }}][1]\"\u003ENo\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"declaration.response\"\u003E\u003Cdiv class=\"application-question-response\"\u003E\u003Ctextarea id=\"declarations[{{ declarationKey }}][2]\" placeholder=\"Enter Text Here\" ng-model=\"declaration.explanation\" required\u003E\u003C\u002Ftextarea\u003E\u003Clabel for=\"declarations[{{ declarationKey }}][2]\"\u003EPlease Enter Explanation\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-12\"\u003E\u003Cul class=\"application-subquestions-list\"\u003E\u003Cli ng-repeat=\"(subQuestionKey, subQuestion) in declaration.subQuestions\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-8\"\u003E{{ subQuestion.question }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-4 text-center\"\u003E\u003Cdiv class=\"field application-questions-field\"\u003E\u003Cinput class=\"radio\" type=\"radio\" name=\"declarations[{{ declarationKey }}][{{ subQuestionKey }}]\" id=\"declarations[{{ declarationKey }}][{{ subQuestionKey }}][0]\" ng-value=\"true\" ng-model=\"subQuestion.response\"\u003E\u003Clabel for=\"declarations[{{ declarationKey }}][{{ subQuestionKey }}][0]\"\u003EYes\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field application-questions-field\"\u003E\u003Cinput class=\"radio\" id=\"declarations[{{ declarationKey }}][{{ subQuestionKey }}][1]\" type=\"radio\" ng-value=\"false\" ng-model=\"subQuestion.response\"\u003E\u003Clabel for=\"declarations[{{ declarationKey }}][{{ subQuestionKey }}][1]\"\u003ENo\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-12\" ng-if=\"subQuestion.response\"\u003E\u003Cdiv class=\"application-question-response\"\u003E\u003Ctextarea id=\"declarations[{{ declarationKey }}][{{ subQuestionKey }}][2]\" placeholder=\"Enter Text Here\" ng-model=\"subQuestion.explanation\" required\u003E\u003C\u002Ftextarea\u003E\u003Clabel for=\"declarations[{{ declarationKey }}][{{ subQuestionKey }}][2]\"\u003EPlease Enter Explanation\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cactions\u003E\u003C\u002Factions\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-top\"\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Ch1 class=\"page-title page-title--show application-pretext-title\" ng-if=\"previouslyAppointed\"\u003EReview Payment Documents\u003C\u002Fh1\u003E\u003Ch1 class=\"page-title page-title--show application-pretext-title\" ng-if=\"!previouslyAppointed\"\u003EReview Application\u003C\u002Fh1\u003E\u003Cp\u003EPlease review the documents below\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Cdiv class=\"form-container\"\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\"\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"agentForm.$submitted &amp;&amp; !agentForm.$valid\"\u003E\u003Cdiv ng-messages=\"agentForm.trueAndComplete.$error\" ng-if=\"agentForm.$submitted\" role=\"alert\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must agree to this condition.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.IMSA.$error\" ng-if=\"agentForm.$submitted\" role=\"alert\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must agree to this condition.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.eAuthorization.$error\" ng-if=\"agentForm.$submitted\" role=\"alert\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must agree to this condition.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"spinner-container\" ng-show=\"loading\"\u003E\u003Cdiv class=\"spinner\" ng-show=\"true\"\u003ELoading\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-show=\"!loading\"\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"failure\"\u003ECould not submit application. Please try again later.\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-pdf-container\"\u003E\u003Ciframe ng-src=\"{{ trustSrc(htmlUrl) }}\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-acknowledgement\"\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"checkbox\" name=\"trueAndComplete\" id=\"trueAndComplete\" ng-model=\"acceptance.trueAndComplete\" ng-true-value=\"true\" ng-false-value=\"false\" required\u003E\u003Clabel class=\"application-acknowledgement-label\" for=\"trueAndComplete\"\u003E\u003Cspan\u003EI, \u003Cb\u003E{{ brokerInformation.firstName }} {{ brokerInformation.lastName }}\u003C\u002Fb\u003E\u003Cspan ng-if=\"page !== &quot;GENERAL_INFORMATION&quot;\"\u003E, hereby agree to and digitally sign the {{ pageName }}.\u003C\u002Fspan\u003E\u003Cspan ng-if=\"page === &quot;GENERAL_INFORMATION&quot;\"\u003E, hereby agree to and digitally sign the PRODUCER APPOINTMENT DATA. I certify that my answers to the questions appearing in this Application are true and complete. I agree to adhere to the IMSA standards of business conduct.\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cactions\u003E\u003C\u002Factions\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-top\"\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Ch1 class=\"page-title application-pretext-title\" ng-if=\"previouslyAppointed\"\u003EYour Updates Were Sent\u003C\u002Fh1\u003E\u003Ch1 class=\"page-title application-pretext-title\" ng-if=\"!previouslyAppointed\"\u003EYour Application Was Sent\u003C\u002Fh1\u003E\u003Cp ng-if=\"previouslyAppointed\"\u003EThank you for submitting your payment document updates\u003C\u002Fp\u003E\u003Cp ng-if=\"!previouslyAppointed\"\u003EThank you for submitting your agent appointment application\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Cdiv class=\"form-container\"\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"application-pdf-container\"\u003E\u003Ciframe ng-src=\"{{ trustSrc(pdfUrl) }}\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ca class=\"btn btn-info\" href=\"{{ pdfUrl }}\" target=\"_blank\"\u003EOpen PDF In New Window\u003C\u002Fa\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-thank-you\"\u003E\u003Cdiv ng-if=\"previouslyAppointed\"\u003E\u003Cp\u003EThank you for submitting your payment document updates with Delta Dental of \u003Cspan ng-if=\"currentSite === &quot;mn&quot;\"\u003EMinnesota. \u003C\u002Fspan\u003E\u003Cspan ng-if=\"currentSite === &quot;ne&quot;\"\u003ENebraska.\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!previouslyAppointed\"\u003E\u003Cp\u003EThank you for submitting your agent appointment application with Delta Dental of \u003Cspan ng-if=\"currentSite === &quot;mn&quot;\"\u003EMinnesota \u003C\u002Fspan\u003E\u003Cspan ng-if=\"currentSite === &quot;ne&quot;\"\u003ENebraska \u003C\u002Fspan\u003E\u003Cspan\u003Eto sell dental plans in \u003C\u002Fspan\u003E\u003Cspan ng-if=\"selectedStates.MN &amp;&amp; selectedStates.ND\"\u003EMinnesota and North Dakota.\u003C\u002Fspan\u003E\u003Cspan ng-if=\"selectedStates.MN &amp;&amp; !selectedStates.ND\"\u003EMinnesota.\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!selectedStates.MN &amp;&amp; selectedStates.ND\"\u003ENorth Dakota.\u003C\u002Fspan\u003E\u003Cspan ng-if=\"selectedStates.NE\"\u003ENebraska.\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cp\u003EWhen your application is approved, we will send you a personalized broker sales link. This link will allow you to track your commission for Delta Dental of \u003Cspan ng-if=\"currentSite === &quot;mn&quot;\"\u003EMinnesota \u003C\u002Fspan\u003E\u003Cspan ng-if=\"currentSite === &quot;ne&quot;\"\u003ENebraska \u003C\u002Fspan\u003EIndividual and Family plan sales. If you did not receive this email, please be sure to check your spam folder.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cp\u003EIf you have any questions or concerns give us a call at 1-855-648-1409.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-top\"\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Ch1 class=\"page-title\"\u003EBroker Information\u003C\u002Fh1\u003E\u003Cp\u003EThis information includes your broker, agency, and direct deposit information\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"appointment-app-content\"\u003E\u003Caddress-validator ng-model=\"addressErrorDetails\" edit-address=\"editAddress\" select-address=\"selectAddress\" ng-if=\"addressErrorDetails &amp;&amp; !loading\"\u003E\u003C\u002Faddress-validator\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"failure\"\u003ECould not submit application. Please try again later.\u003C\u002Fdiv\u003E\u003Cdiv class=\"spinner-container\" ng-if=\"loading\"\u003E\u003Cdiv class=\"spinner\"\u003ELoading\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-container\" ng-if=\"!loading\"\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\" ng-show=\"!addressErrorDetails.addresses.length\"\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"agentForm.$submitted &amp;&amp; !agentForm.$valid\"\u003E\u003Cdiv ng-messages=\"agentForm.firstName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a first name.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid first name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.middleName.$error\"\u003E\u003Cspan ng-message=\"pattern\"\u003EMiddle name is not a valid name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.lastName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a last name.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid last name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.agencyName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an agency name.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid agency name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an agency name.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeAddress.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a street address.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid street address.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeCity.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a city.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeState.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must select a state.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeZipCode.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a zip code.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid zip code.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneePhone.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a phone number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid 10 digit phone number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeEmail.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an assignee email.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"email\"\u003EYou must enter a valid assignee email.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid assignee email.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.ssn.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a social security number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid social security number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.assigneeTaxID.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a tax id number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid tax id.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.taxClassification.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must select a tax classification.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.accountOwner.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter the account owner's name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.financialInstitutionName.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a financial institution name.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finEmailAddress.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an email for direct deposit statements.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"email\"\u003EYou must enter a valid email for direct deposit statements.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid email for direct deposit statements.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finInstStreetAddress.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a street address.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finInstCity.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a city.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finInstState.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must select a state.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.finInstZipCode.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a zip code.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid zip code.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.routingNumber.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter a routing number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid routing number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-messages=\"agentForm.accountNumber.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an account number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid account number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-update-paypacket\"\u003E\u003Cdiv class=\"application-form-section application-form-section--top\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3\u003EAgent Name\u003C\u002Fh3\u003E\u003Cdiv class=\"label-text\"\u003EPlease update this information if your name is not correct or has been legally changed\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"firstName\" id=\"firstName\" ng-model=\"brokerInformation.firstName\" pattern=\"{{ validations.name }}\" required maxlength=\"40\"\u003E\u003Clabel for=\"firstName\"\u003EFirst Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"middleName\" id=\"middleName\" ng-model=\"brokerInformation.middleName\" pattern=\"{{ validations.name }}\" maxlength=\"20\"\u003E\u003Clabel for=\"middleName\"\u003EMiddle Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"lastName\" id=\"lastName\" ng-model=\"brokerInformation.lastName\" pattern=\"{{ validations.name }}\" required maxlength=\"80\"\u003E\u003Clabel for=\"lastName\"\u003ELast Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch2 class=\"page-title application-pretext-title\"\u003ECommission Assignment\u003C\u002Fh2\u003E\u003Cfieldset\u003E\u003Clegend\u003EWho do you want to receive your commission payments?\u003C\u002Flegend\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"radio\" value=\"myself\" name=\"assignee\" ng-model=\"commissionInformation.assignee\" id=\"myself\"\u003E\u003Clabel class=\"radio-label\" for=\"myself\"\u003EMe\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"radio\" value=\"agency\" name=\"assignee\" ng-model=\"commissionInformation.assignee\" id=\"agency\"\u003E\u003Clabel class=\"radio-label\" for=\"agency\"\u003EMy agency\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput type=\"radio\" value=\"third_party\" name=\"assignee\" ng-model=\"commissionInformation.assignee\" id=\"third_party\"\u003E\u003Clabel class=\"radio-label\" for=\"third_party\"\u003EA different agency or business entitity\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003Cdiv ng-if=\"commissionInformation.assignee !== &quot;myself&quot;\"\u003E\u003Cdiv class=\"application-section\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"\" name=\"agencyName\" id=\"agencyName\" ng-model=\"agencyInformation.name\" required maxlength=\"255\"\u003E\u003Clabel for=\"agencyName\"\u003EAgency Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\"\u003E\u003Ch3\u003EPayee Information\u003C\u002Fh3\u003E\u003Cdiv class=\"label-text\"\u003EEnter information for the person or business entity that will receive your commission payments\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cspan class=\"readonly-text\"\u003E{{ commissionInformation.assigneeName }}\u003C\u002Fspan\u003E\u003Clabel\u003EPayee Name*\u003Cspan class=\"label-disclaimer\"\u003E (as shown on your income tax return)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeAddress\" id=\"assigneeAddress\" ng-model=\"generalInformation.assigneeAddress\" required maxlength=\"255\"\u003E\u003Clabel class=\"no-after\" for=\"assigneeAddress\"\u003EAddress Line 1*\u003Cspan class=\"label-disclaimer\"\u003E(Street Address or PO Box)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeAddress2\" id=\"assigneeAddress2\" ng-model=\"generalInformation.assigneeAddress2\" maxlength=\"255\"\u003E\u003Clabel for=\"assigneeAddress2\"\u003EAddress Line 2\u003Cspan class=\"label-disclaimer\"\u003E(Apartment, unit, suite, etc.)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeCity\" id=\"assigneeCity\" ng-model=\"generalInformation.assigneeCity\" required maxlength=\"40\"\u003E\u003Clabel for=\"assigneeCity\"\u003ECity\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cselect name=\"assigneeState\" id=\"assigneeState\" ng-model=\"generalInformation.assigneeState\" ng-options=\"key as value for (key, value) in statesOptions\" ng-disabled=\"generalInformation.sameAsAgency\" required\u003E\u003Coption value=\"\"\u003ESelect\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"assigneeState\"\u003EState\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeZipCode\" id=\"assigneeZipCode\" ng-model=\"generalInformation.assigneeZipCode\" pattern=\"{{ validations.zipCode }}\" required\u003E\u003Clabel for=\"assigneeZipCode\"\u003EZip Code\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneePhone\" id=\"assigneePhone\" ng-model=\"generalInformation.assigneePhone\" angular-mask=\"(999) 999-9999\" maxlength=\"14\" pattern=\"{{ validations.phone }}\" restrict=\"reject\" required\u003E\u003Clabel for=\"assigneePhone\"\u003EPhone Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"email\" value=\"\" name=\"assigneeEmail\" id=\"assigneeEmail\" ng-model=\"generalInformation.assigneeEmail\" pattern=\"{{ validations.email }}\" required maxlength=\"80\"\u003E\u003Clabel for=\"assigneeEmail\"\u003E Assignee Email Address\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\" ng-if=\"commissionInformation.assignee === &quot;myself&quot;\"\u003E\u003Cinput type=\"text\" id=\"ssn\" name=\"ssn\" ng-model=\"generalInformation.ssn\" ssn maxlength=\"11\" required\u003E\u003Clabel for=\"ssn\"\u003ESocial Security Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\" ng-if=\"commissionInformation.assignee !== &quot;myself&quot;\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"assigneeTaxID\" id=\"assigneeTaxID\" ng-model=\"generalInformation.assigneeTaxID\" angular-mask=\"99-9999999\" maxlength=\"10\" pattern=\"{{ validations.ein }}\" required\u003E\u003Clabel for=\"assigneeTaxID\"\u003EFederal Tax ID\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\" ng-if=\"commissionInformation.assignee !== &quot;myself&quot;\"\u003E\u003Cselect name=\"taxClassification\" id=\"taxClassification\" ng-model=\"generalInformation.taxClassification\" ng-options=\"key as value for (key, value) in taxClassifications\" required\u003E\u003Coption value=\"\"\u003ESelect\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"taxClassification\"\u003ETax Classification\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3\u003EDirect Deposit\u003C\u002Fh3\u003E\u003Cdiv class=\"field\"\u003E\u003Cinput class=\"checkbox\" type=\"checkbox\" name=\"updateCommissionInformation\" id=\"updateCommissionInformation\" ng-model=\"commissionInformation.updateCommissionInformation\" ng-false-value=\"false\" ng-true-value=\"true\"\u003E\u003Clabel for=\"updateCommissionInformation\"\u003EI would like to update direct deposit information\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"label-text\" ng-if=\"commissionInformation.updateCommissionInformation\"\u003EEnter updated bank account information for the entity that is receiving commission payments.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"commissionInformation.updateCommissionInformation\"\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"accountOwner\" id=\"accountOwner\" ng-model=\"commissionInformation.accountOwner\" required maxlength=\"255\"\u003E\u003Clabel for=\"accountOwner\"\u003EAccount Owner\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"email\" value=\"\" name=\"finEmailAddress\" id=\"finEmailAddress\" ng-model=\"commissionInformation.finEmailAddress\" pattern=\"{{ validations.email }}\" required maxlength=\"80\"\u003E\u003Clabel for=\"finEmailAddress\"\u003EEmail for direct deposit statements\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"financialInstitutionName\" id=\"financialInstitutionName\" ng-model=\"commissionInformation.financialInstitutionName\" required maxlength=\"255\"\u003E\u003Clabel for=\"financialInstitutionName\"\u003EFinancial Institution Name\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"finInstStreetAddress\" id=\"finInstStreetAddress\" ng-model=\"commissionInformation.finInstStreetAddress\" required maxlength=\"255\"\u003E\u003Clabel class=\"no-after\" for=\"finInstStreetAddress\"\u003EAddress Line 1*\u003Cspan class=\"label-disclaimer\"\u003E(Street Address or PO Box)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-12\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"finInstStreetAddress2\" id=\"finInstStreetAddress2\" ng-model=\"commissionInformation.finInstStreetAddress2\" maxlength=\"255\"\u003E\u003Clabel for=\"finInstStreetAddress2\"\u003EAddress Line 2\u003Cspan class=\"label-disclaimer\"\u003E(Apartment, unit, suite, etc.)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"finInstCity\" id=\"finInstCity\" ng-model=\"commissionInformation.finInstCity\" required maxlength=\"40\"\u003E\u003Clabel for=\"finInstCity\"\u003ECity\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cselect name=\"finInstState\" id=\"finInstState\" ng-model=\"commissionInformation.finInstState\" ng-options=\"key as value for (key, value) in statesOptions\" required\u003E\u003Coption value=\"\"\u003ESelect \u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"finInstState\"\u003EState\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-4\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"finInstZipCode\" id=\"finInstZipCode\" ng-model=\"commissionInformation.finInstZipCode\" pattern=\"{{ validations.zipCode }}\" required\u003E\u003Clabel for=\"finInstZipCode\"\u003EZip Code\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"routingNumber\" id=\"routingNumber\" ng-model=\"commissionInformation.routingNumber\" pattern=\"{{ validations.routingNumber }}\" required maxlength=\"9\"\u003E\u003Clabel for=\"routingNumber\"\u003ERouting Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"field col-xs-12 col-md-6\"\u003E\u003Cinput type=\"text\" value=\"\" name=\"accountNumber\" id=\"accountNumber\" ng-model=\"commissionInformation.accountNumber\" required maxlength=\"20\"\u003E\u003Clabel for=\"accountNumber\"\u003EAccount Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cactions\u003E\u003C\u002Factions\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"appointment-app-content\"\u003E\u003Cdiv class=\"form-container\"\u003E\u003Ch1 class=\"page-title\"\u003EUpdate Broker Payment Information \u003Cspan\u003E(W-9 and ACH)\u003C\u002Fspan\u003E\u003C\u002Fh1\u003E\u003Cdiv class=\"application-pretext\"\u003E\u003Cp class=\"application-pretext-paragraph\"\u003EIf you are \u003Cstrong\u003Ecurrently appointed \u003C\u002Fstrong\u003Eto sell Delta Dental insurance in \u003Cspan ng-if=\"currentSite == &quot;mn&quot;\"\u003EMinnesota or North Dakota \u003C\u002Fspan\u003E\u003Cspan ng-if=\"currentSite == &quot;ne&quot;\"\u003ENebraska \u003C\u002Fspan\u003Euse this form to update the following payment information:\u003Cul class=\"application-pretext-list\"\u003E\u003Cli\u003ECreate a new W-9 form\u003C\u002Fli\u003E\u003Cli\u003EChange who gets paid your commissions (commission assignment)\u003C\u002Fli\u003E\u003Cli\u003ETurn on ACH (Direct Deposit) for commission payment\u003C\u002Fli\u003E\u003Cli\u003EChange bank account information\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003Cp class=\"application-pretext-paragraph\"\u003EFor \u003Cstrong\u003Eall other updates,\u003C\u002Fstrong\u003E please contact us via email at \u003Ca href=\"mailto:{{ contactEmail }}\"\u003E{{ contactEmail }}\u003C\u002Fa\u003E or through the phone at 1-855-648-1409.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cp class=\"application-pretext-paragraph\"\u003EIf you are \u003Cstrong\u003Enot currently appointed \u003C\u002Fstrong\u003Eto sell Delta Dental insurance in \u003Cspan ng-if=\"currentSite == &quot;mn&quot;\"\u003EMinnesota or North Dakota\u003C\u002Fspan\u003E\u003Cspan ng-if=\"currentSite == &quot;ne&quot;\"\u003ENebraska\u003C\u002Fspan\u003E, please get started by completing the \u003Ca class=\"application-link\" href=\"#\u002Fapplication\u002Fget-started\"\u003EBroker Appointment Application.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"appointment-get-started\"\u003E\u003Cdiv class=\"spinner-container\" ng-if=\"loading\"\u003E\u003Cdiv class=\"spinner\"\u003ELoading\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"alert alert-danger\" ng-if=\"error\"\u003EWe were not able to locate a broker associated with this NPN.\u003Cdiv class=\"alert-message\"\u003EPlease contact us for assistance at \u003Ca href=\"mailto:{{ contactEmail }}\"\u003E{{ contactEmail }}\u003C\u002Fa\u003E or 1-855-648-1409.\u003Cdiv\u003ETo apply to sell Delta Dental insurance, please complete a \u003Ca class=\"application-link\" href=\"#\u002Fapplication\u002Fget-started\"\u003EBroker Appointment Application\u003C\u002Fa\u003E.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"alert alert-danger\" role=\"alert\" ng-if=\"!loading &amp;&amp; failure\"\u003ECould not submit data. Please try again later.\u003C\u002Fdiv\u003E\u003Cform class=\"agent-application-form\" novalidate name=\"agentForm\" ng-submit=\"submitForm(agentForm)\" ng-if=\"!loading\"\u003E\u003Ch3\u003EGet Started\u003C\u002Fh3\u003E\u003Cdiv role=\"alert\" aria-atomic=\"true\"\u003E\u003Cdiv class=\"alert alert-danger\" ng-if=\"npnError || agentForm.$submitted &amp;&amp; !agentForm.$valid\"\u003E\u003Cdiv ng-if=\"npnError\"\u003EWe've found a matching record in our system. \nPlease contact us at \u003Ca href=\"mailto:{{ contactEmail }}\"\u003E{{ contactEmail }}\u003C\u002Fa\u003E or 1-855-648-1409 to continue the appointment process.\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"!npnError\"\u003EPlease correct the errors below.\u003Cdiv ng-messages=\"agentForm.npnNumber.$error\"\u003E\u003Cspan ng-message=\"required\"\u003EYou must enter an NPN number.\u003C\u002Fspan\u003E\u003Cspan ng-message=\"pattern\"\u003EYou must enter a valid NPN number.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"agentForm.$submitted &amp;&amp; agentForm.selectedStates.$error.required\"\u003EYou must select a state.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-8 col-md-5\"\u003E\u003Cinput type=\"text\" value=\"\" placeholder=\"12345678\" name=\"npnNumber\" id=\"npnNumber\" ng-model=\"brokerInformation.npn\" required pattern=\"{{ validations.numeric }}\" maxlength=\"12\"\u003E\u003Clabel for=\"npnNumber\"\u003ENPN Number\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-4 col-md-4\"\u003E\u003Cdiv class=\"application-npn-container\"\u003E\u003Ca href=\"http:\u002F\u002Fwww.nipr.com\u002FPacNpnSearch.htm\" target=\"_BLANK\"\u003EFind your NPN\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-update\"\u003E\u003Cbutton class=\"btn btn-info application-update__submit\" type=\"submit\"\u003ECONTINUE\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_states_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_states_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_states_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_taxClassifications_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_taxClassifications_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_taxClassifications_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_validations_json__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_validations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_validations_json__);




AgencyController.$inject = [
  'ApplicationService',
  '$scope',
  '$location',
  '$window',
  '$q'
];

function AgencyController (ApplicationService, $scope, $location, $window, $q) {
  function init () {
    var formData = ApplicationService.getData();
    $scope.previouslyAppointed = formData.previouslyAppointed;
    $scope.agencyInformation = formData.agencyInformation;
    $scope.today = new Date();
    $scope.futureDate = new Date().setFullYear($scope.today.getFullYear() + 20);
    $scope.taxClassifications = __WEBPACK_IMPORTED_MODULE_1__data_taxClassifications_json___default.a;
    $scope.validations = __WEBPACK_IMPORTED_MODULE_2__data_validations_json___default.a;
    $scope.statesOptions = __WEBPACK_IMPORTED_MODULE_0__data_states_json___default.a;
    $scope.submitForm = submitForm;
    $scope.previousStep = previousStep;
    $scope.$watch('agencyInformation.businessState', updateLicenses);
  }

  $scope.editAddress = function () {
    $scope.addressErrorDetails = null;
    $window.scrollTo(0, 0);
  };

  $scope.selectAddress = function (address) {
    var agencyInformation = ApplicationService.getData().agencyInformation;
    agencyInformation.businessAddress = address.address;
    agencyInformation.businessAddress2 = address.address2;
    agencyInformation.businessCity = address.city;
    agencyInformation.businessState = address.state;
    agencyInformation.businessZipCode = address.zipCode;
    $scope.agencyInformation = agencyInformation;
    ApplicationService.setData({
      agencyInformation: agencyInformation
    });
    nextPage();
  };

  function updateLicenses () {
    var existingLicenses = $scope.agencyInformation.agencyLicenses;
    var residencyState = $scope.agencyInformation.businessState;
    $scope.agencyInformation.agencyLicenses = ApplicationService.generateLicenses(existingLicenses, residencyState, true);
  }

  function previousStep () {
    $location.path('/application/broker-information');
  }

  function submitForm (form) {
    $window.scrollTo(0, 0);
    if (form.$valid) {
      nextStep();
    }
  }

  function nextStep () {
    // if user hits "no" - lets not keep any entered data
    var data = {
      agencyInformation: $scope.agencyInformation
    };
    if ($scope.agencyInformation.usingAgency) {
      data.agencyInformation.businessAddress2 = (data.agencyInformation.businessAddress2 || '');
    } else {
      data = {
        agencyInformation: {
          generalAgencyName: $scope.agencyInformation.generalAgencyName,
          usingAgency: false
        }
      };
    }

    ApplicationService.setData(data);

    $scope.loading = true;

    var promises = [];

    if (data.agencyInformation.usingAgency) {
      promises.push(validateAddress(data));
    }

    $q.all(promises).then(function () {
      nextPage();
    }).catch(function () {
      $scope.loading = false;
    });
  }

  function validateAddress (data) {
    return $q(function (resolve, reject) {
      ApplicationService.validateAddress({
        address: data.agencyInformation.businessAddress,
        address2: data.agencyInformation.businessAddress2,
        city: data.agencyInformation.businessCity,
        state: data.agencyInformation.businessState,
        zipCode: data.agencyInformation.businessZipCode
      })
      .then(function () {
        $scope.addressErrorDetails = null;
        resolve();
      }, function (response) {
        $scope.addressErrorDetails = response;
        reject();
      });
    });
  }

  function nextPage () {
    $location.path('/application/commission-assignment');
  }

  init();
}

/* harmony default export */ exports["a"] = AgencyController;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_states_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_states_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_states_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_validations_json__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_validations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_validations_json__);



BrokerInformationController.$inject = [
  'ApplicationService',
  '$scope',
  '$location',
  '$window'
];

function BrokerInformationController (ApplicationService, $scope, $location, $window) {
  function init () {
    var formData = ApplicationService.getData();
    $scope.brokerInformation = formData.brokerInformation;
    $scope.today = new Date();
    $scope.futureDate = new Date().setFullYear($scope.today.getFullYear() + 20);
    $scope.validations = __WEBPACK_IMPORTED_MODULE_1__data_validations_json___default.a;
    $scope.statesOptions = __WEBPACK_IMPORTED_MODULE_0__data_states_json___default.a;
    $scope.submitForm = submitForm;
    $scope.previousStep = previousStep;
    $scope.previouslyAppointed = formData.previouslyAppointed;

    var eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    eighteenYearsAgo.setHours(0, 0, 0, 0);
    $scope.eighteenYearsAgo = eighteenYearsAgo;

    var hundredYearsAgo = new Date();
    hundredYearsAgo.setFullYear(hundredYearsAgo.getFullYear() - 100);
    hundredYearsAgo.setHours(0, 0, 0, 0);
    $scope.hundredYearsAgo = hundredYearsAgo;

    $scope.$watch('brokerInformation.state', updateLicenses);
  }

  $scope.editAddress = function () {
    $scope.addressErrorDetails = null;
    $window.scrollTo(0, 0);
  };

  $scope.selectAddress = function (address) {
    var brokerInformation = ApplicationService.getData().brokerInformation;
    brokerInformation.streetAddress = address.address;
    brokerInformation.streetAddress2 = address.address2;
    brokerInformation.city = address.city;
    brokerInformation.state = address.state;
    brokerInformation.zipCode = address.zipCode;
    $scope.brokerInformation = brokerInformation;
    ApplicationService.setData({
      brokerInformation: brokerInformation
    });
    nextStep();
  };

  function updateLicenses () {
    var existingLicenses = $scope.brokerInformation.brokerLicenses;
    var residencyState = $scope.brokerInformation.state;
    $scope.brokerInformation.brokerLicenses = ApplicationService.generateLicenses(existingLicenses, residencyState, false);
  }

  function previousStep () {
    $location.path('/application/get-started');
  }

  function submitForm (form) {
    $window.scrollTo(0, 0);
    if (form.$valid) {
      nextStep();
    }
  }

  function nextStep () {
    $scope.addressErrorDetails = null;

    var data = {
      brokerInformation: $scope.brokerInformation
    };
    data.brokerInformation.streetAddress2 = (data.brokerInformation.streetAddress2 || '');

    ApplicationService.setData(data);
    $scope.loading = true;
    ApplicationService.validateAddress({
      address: data.brokerInformation.streetAddress,
      address2: data.brokerInformation.streetAddress2,
      city: data.brokerInformation.city,
      state: data.brokerInformation.state,
      zipCode: data.brokerInformation.zipCode
    }).then(function () {
      nextPage();
    }, function (response) {
      $scope.loading = false;
      $scope.addressErrorDetails = response;
    });
  }

  function nextPage () {
    $location.path('/application/agency-information');
  }

  init();
}

/* harmony default export */ exports["a"] = BrokerInformationController;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_states_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_states_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_states_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_taxClassifications_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_taxClassifications_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_taxClassifications_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_validations_json__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_validations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_validations_json__);




CommissionAssignmentController.$inject = [
  'ApplicationService',
  '$scope',
  '$location',
  '$window',
  '$q'
];

function CommissionAssignmentController (ApplicationService, $scope, $location, $window, $q) {
  function init () {
    var formData = ApplicationService.getData();
    $scope.agencyInformation = formData.agencyInformation;
    $scope.brokerInformation = formData.brokerInformation;
    $scope.commissionInformation = formData.commissionInformation;
    $scope.taxClassifications = __WEBPACK_IMPORTED_MODULE_1__data_taxClassifications_json___default.a;
    $scope.validations = __WEBPACK_IMPORTED_MODULE_2__data_validations_json___default.a;
    $scope.statesOptions = __WEBPACK_IMPORTED_MODULE_0__data_states_json___default.a;
    $scope.submitForm = submitForm;
    $scope.previousStep = previousStep;
    $scope.addressErrorDetails = null;
  }

  $scope.editAddress = function () {
    $scope.addressErrorDetails = null;
    $window.scrollTo(0, 0);
  };

  $scope.selectAddress = function (address) {
    var commissionInformation = ApplicationService.getData().commissionInformation;
    if ($scope.addressErrorDetails.type === 'agency') {
      commissionInformation.assigneeAddress = address.address;
      commissionInformation.assigneeAddress2 = address.address2;
      commissionInformation.assigneeCity = address.city;
      commissionInformation.assigneeState = address.state;
      commissionInformation.assigneeZipCode = address.zipCode;
      $scope.skipAgencyValidation = true;
    } else {
      commissionInformation.finInstStreetAddress = address.address;
      commissionInformation.finInstStreetAddress2 = address.address2;
      commissionInformation.finInstCity = address.city;
      commissionInformation.finInstState = address.state;
      commissionInformation.finInstZipCode = address.zipCode;
      $scope.skipFinancialValidation = true;
    }
    $scope.commissionInformation = commissionInformation;
    nextStep();
  };

  function previousStep () {
    $location.path('/application/agency-information');
  }

  function submitForm (form) {
    $window.scrollTo(0, 0);
    if (form.$valid) {
      $scope.addressError = false;
      nextStep();
    }
  }

  function nextStep () {
    var data = {
      commissionInformation: $scope.commissionInformation
    };

    if (data.commissionInformation.assignee !== 'third_party') {
      // we don't want to save any of this data
      delete data.commissionInformation.assigneeName;
      delete data.commissionInformation.assigneeAddress;
      delete data.commissionInformation.assigneeAddress2;
      delete data.commissionInformation.assigneeCity;
      delete data.commissionInformation.assigneeState;
      delete data.commissionInformation.assigneeZipCode;
      delete data.commissionInformation.assigneePhone;
      delete data.commissionInformation.assigneeEmail;
      delete data.commissionInformation.assigneeTaxID;
      delete data.commissionInformation.taxClassification;
    } else {
      data.commissionInformation.assigneeAddress2 = (data.commissionInformation.assigneeAddress2 || '');
    }

    if (data.commissionInformation.payViaCheck) {
      delete data.commissionInformation.accountOwner;
      delete data.commissionInformation.finEmailAddress;
      delete data.commissionInformation.financialInstitutionName;
      delete data.commissionInformation.finInstStreetAddress;
      delete data.commissionInformation.finInstStreetAddress2;
      delete data.commissionInformation.finInstCity;
      delete data.commissionInformation.finInstState;
      delete data.commissionInformation.finInstZipCode;
      delete data.commissionInformation.routingNumber;
      delete data.commissionInformation.accountNumber;
    } else {
      data.commissionInformation.finInstStreetAddress2 = (data.commissionInformation.finInstStreetAddress2 || '');
    }

    // There used to be a value called "useDirectDeposit"
    // This value was the inverse of what it should have been
    data.commissionInformation.useDirectDeposit = data.commissionInformation.payViaCheck;

    ApplicationService.setData(data);

    $scope.loading = true;
    validateFinancialAddress()
      .then(validateAgencyAddress)
      .then(function () {
        $scope.loading = false;
        nextPage();
      }).catch(function () {
        $scope.loading = false;
      });
  }

  function validateAgencyAddress () {
    return $q(function (resolve, reject) {
      if ($scope.commissionInformation.assignee !== 'third_party' || $scope.skipAgencyValidation) {
        resolve();
      } else {
        ApplicationService.validateAddress({
          address: $scope.commissionInformation.assigneeAddress,
          address2: $scope.commissionInformation.assigneeAddress2,
          city: $scope.commissionInformation.assigneeCity,
          state: $scope.commissionInformation.assigneeState,
          zipCode: $scope.commissionInformation.assigneeZipCode
        }).then(function (response) {
          $scope.addressErrorDetails = null;
          resolve();
        }, function (response) {
          $scope.addressErrorDetails = response;
          $scope.addressErrorDetails.type = 'agency';
          reject();
        });
      }
    });
  }

  function validateFinancialAddress () {
    $scope.addressExplanation = '';
    return $q(function (resolve, reject) {
      // badly named:
      if ($scope.commissionInformation.payViaCheck || $scope.skipFinancialValidation) {
        resolve();
      } else {
        ApplicationService.validateAddress({
          address: $scope.commissionInformation.finInstStreetAddress,
          address2: $scope.commissionInformation.finInstStreetAddress2,
          city: $scope.commissionInformation.finInstCity,
          state: $scope.commissionInformation.finInstState,
          zipCode: $scope.commissionInformation.finInstZipCode
        }).then(function (response) {
          $scope.addressErrorDetails = null;
          resolve();
        }, function (response) {
          $scope.addressErrorDetails = response;
          $scope.addressErrorDetails.type = 'financial';
          reject();
        });
      }
    });
  }

  function nextPage () {
    $location.path('/application/producer-declaration');
  }

  init();
}

/* harmony default export */ exports["a"] = CommissionAssignmentController;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_states_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_states_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_states_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_validations_json__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_validations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_validations_json__);



GetStartedController.$inject = [
  'ApplicationService',
  '$document',
  '$routeParams',
  '$scope',
  '$rootScope',
  '$location',
  '$window'
];

function GetStartedController (ApplicationService, $document, $routeParams, $scope, $rootScope, $location, $window) {
  function init () {
    $document[0].title = 'Delta Dental - Agent Appointment Application';
    $rootScope.previouslyAppointed = false;
    var formData = ApplicationService.getBaseData(false);
    $scope.brokerInformation = formData.brokerInformation;
    $scope.selectedStates = formData.selectedStates || {};
    $scope.validations = __WEBPACK_IMPORTED_MODULE_1__data_validations_json___default.a;
    $scope.statesOptions = __WEBPACK_IMPORTED_MODULE_0__data_states_json___default.a;
    $scope.submitForm = submitForm;
    $scope.selectedOneState = selectedOneState;
    $scope.currentSite = ApplicationService.getCurrentSite();
    $scope.contactEmail = 'DDMNBroker@DeltaDentalMN.org';
    if ($scope.currentSite === 'ne') {
      $scope.contactEmail = 'DDNEBroker@DeltaDentalNE.org';
    }
  }

  function selectedStatesNum () {
    var state;
    for (state in $scope.selectedStates) {
      if ($scope.selectedStates[state]) {
        return true;
      }
    }
    return false;
  }

  function selectedOneState () {
    return selectedStatesNum() > 0;
  }

  function submitForm (form) {
    var formData = ApplicationService.getBaseData(false);
    var agencyInformation = formData.agencyInformation;
    switch ($routeParams.agency) {
      case 'directbenefits':
        agencyInformation.generalAgencyName = 'Direct Benefits';
        agencyInformation.autoCompletedGeneralAgencyName = true;
        break;
      case 'ociinsurance':
        agencyInformation.generalAgencyName = 'OCI Insurance';
        agencyInformation.autoCompletedGeneralAgencyName = true;
        break;
      case 'financialservicesinc':
        agencyInformation.generalAgencyName = 'Financial Services, Inc';
        agencyInformation.autoCompletedGeneralAgencyName = true;
        break;
    
      default:
        break;
    }
    
    var npnNumber = $scope.brokerInformation.npn;
    if (form.$valid) {
      $scope.npnError = false;
      $scope.loading = true;
      var data = {
        'brokerInformation': $scope.brokerInformation,
        'selectedStates': $scope.selectedStates,
        'agencyInformation': agencyInformation,
        'previouslyAppointed': false
      };
      ApplicationService.setData(data, true);
      ApplicationService.validateNpn(npnNumber).then(function () {
        $location.path('/application/broker-information'); 
      }, function () {
        $scope.loading = false;
        $scope.npnError = true;
        $window.scrollTo(0, 0);
      });
    }
  }

  init();
}

/* harmony default export */ exports["a"] = GetStartedController;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);


ProducerDeclarationsController.$inject = [
  'ApplicationService',
  '$scope',
  '$location',
  '$window'
];

function ProducerDeclarationsController (ApplicationService, $scope, $location, $window) {
  function init () {
    var formData = ApplicationService.getData();
    $scope.declarations = formData.declarations;
    $scope.previousStep = previousStep;
    $scope.submitForm = submitForm;
  }

  function previousStep () {
    $location.path('/application/commission-assignment');
  }

  // recursively clear out explanations if "no" was selected

  function cleanDeclarations (questionsAndResponses) {
    Object.keys(questionsAndResponses).forEach(function (key) {
      var question = questionsAndResponses[key];
      if (!question.response) {
        question.explanation = '';
      }
      if (question.subQuestions) {
        cleanDeclarations(question.subQuestions);
      }
    });
  }

  function submitForm (form) {
    if (form.$valid) {
      var declarations = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy($scope.declarations);
      cleanDeclarations(declarations.questionsAndResponses);

      var data = {
        declarations: declarations
      };
      ApplicationService.setData(data);
      $scope.loading = true;
      $window.scrollTo(0, 0);
      ApplicationService.submit(false).then(function () {
        $scope.failure = false;
        $scope.loading = false;
        $location.path('/application/review');
      }, function () {
        $scope.failure = true;
        $scope.loading = false;
      });
    }
  }

  init();
}

/* harmony default export */ exports["a"] = ProducerDeclarationsController;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
ReviewController.$inject = [
  'ApplicationService',
  '$scope',
  '$routeParams',
  '$location',
  '$sce',
  '$window'
];

function ReviewController (ApplicationService, $scope, $routeParams, $location, $sce, $window) {
  var orderedPagesDefault = [
    'GENERAL_INFORMATION',
    'INDEPENDENT_PRODUCER_AGREEMENT',
    'BUSINESS_ASSOCIATE_AGREEMENT',
    'COMMISSION_AGREEMENT',
    'EXHIBIT_A',
    'W9',
    'ASSIGNMENT_OF_COMMISSIONS',
    'ACH_DIRECT_PAYMENT_AUTHORIZATION',
    'E-VERIFY_CERTIFICATION'
  ];
  var orderedPagesForAppointed = [
    'W9',
    'ASSIGNMENT_OF_COMMISSIONS',
    'ACH_DIRECT_PAYMENT_AUTHORIZATION',
    'E-VERIFY_CERTIFICATION'
  ];
  var pageNames = {
    'GENERAL_INFORMATION': {
      name: 'General Information'
    },
    'INDEPENDENT_PRODUCER_AGREEMENT': {
      name: 'Independent Producer Agreement'
    },
    'BUSINESS_ASSOCIATE_AGREEMENT': {
      name: 'Business Associate Agreement'
    },
    'COMMISSION_AGREEMENT': {
      name: 'Commission Agreement'
    },
    'EXHIBIT_A': {
      name: 'Exhibit A'
    },
    'W9': {
      name: 'W9'
    },
    'ASSIGNMENT_OF_COMMISSIONS': {
      name: 'Assignment Of Commissions'
    },
    'ACH_DIRECT_PAYMENT_AUTHORIZATION': {
      name: 'ACH Direct Payment Authorization'
    },
    'E-VERIFY_CERTIFICATION': {
      name: 'E-Verify Certification'
    }
  };
  function init () {
    var data = ApplicationService.getData();
    var currentPage = $routeParams.subRoute;
    $scope.orderedPages = orderedPagesDefault;
    $scope.previouslyAppointed = data.previouslyAppointed;
    if (data.previouslyAppointed) {
      $scope.orderedPages = orderedPagesForAppointed;
    }
    $scope.urlPrefix = '/application';
    var skipAch = false;
    if (data.previouslyAppointed) {
      $scope.urlPrefix += '/update-pay-packet';
      // skip ach assertion if there are no updates to be made
      skipAch = !data.commissionInformation.updateCommissionInformation;
    } else {
      // skip ach if paying via check
      skipAch = data.commissionInformation.payViaCheck;
    }

    if (skipAch) {
      $scope.orderedPages = $scope.orderedPages.filter(function (page) {
        return (page !== 'ACH_DIRECT_PAYMENT_AUTHORIZATION');
      });
    }

    if (!currentPage) {
      currentPage = $scope.orderedPages[0];
      $location.path($scope.urlPrefix + '/review/' + currentPage);
      $location.replace();
      return;
    }
    $scope.page = currentPage;
    $scope.pageName = pageNames[currentPage].name;
    $scope.isLastStep = (($scope.orderedPages.indexOf(currentPage) + 1) === $scope.orderedPages.length);
    $scope.brokerInformation = data.brokerInformation;
    $scope.agreed = false;
    $scope.failure = false;
    $scope.previousStep = previousStep;
    $scope.submitForm = submitForm;
    $scope.htmlUrl = ApplicationService.getHtmlUrl({
      pageName: currentPage
    });
    $scope.pdfUrl = ApplicationService.getPdfUrl({
      pageName: currentPage
    });
    $scope.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    };
  }

  function previousStep () {
    var index = $scope.orderedPages.indexOf($scope.page);
    if (index) {
      var previousStep = $scope.orderedPages[index - 1];
      $location.path($scope.urlPrefix + '/review/' + previousStep);
    } else {
      if ($scope.previouslyAppointed) {
        $location.path($scope.urlPrefix + '/information');
      } else {
        $location.path($scope.urlPrefix + '/producer-declaration');
      }
    }
  }

  function submitForm (form) {
    var data = ApplicationService.getData();
    $scope.failure = false;
    if (form.$valid) {
      if ($scope.isLastStep) {
        $scope.loading = true;
        $window.scrollTo(0, 0);
        ApplicationService.submit(true).then(applicationSuccess, applicationFailure);
      } else {
        var index = $scope.orderedPages.indexOf($scope.page);
        var nextStep = $scope.orderedPages[index + 1];
        if (data.previouslyAppointed) {
          $location.path($scope.urlPrefix + '/review/' + nextStep);
        } else {
          $location.path($scope.urlPrefix + '/review/' + nextStep);
        }
      }
    }
  }

  function applicationSuccess () {
    $location.path($scope.urlPrefix + '/thank-you');
  }

  function applicationFailure () {
    $scope.loading = false;
    $scope.failure = true;
  }

  init();
}

/* harmony default export */ exports["a"] = ReviewController;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
ThankYouController.$inject = [
  'ApplicationService',
  '$scope',
  '$sce'
];

function ThankYouController (ApplicationService, $scope, $sce) {
  var data = ApplicationService.getData();
  $scope.previouslyAppointed = data.previouslyAppointed;
  $scope.selectedStates = data.selectedStates;
  $scope.currentSite = ApplicationService.getCurrentSite();
  $scope.pdfUrl = ApplicationService.getPdfUrl();
  $scope.trustSrc = function (src) {
    return $sce.trustAsResourceUrl(src);
  };
}

/* harmony default export */ exports["a"] = ThankYouController;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_validations_json__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_validations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_validations_json__);



UpdatePayPacketController.$inject = [
  'ApplicationService',
  '$document',
  '$scope',
  '$rootScope',
  '$location',
  '$window'
];

function UpdatePayPacketController (ApplicationService, $document, $scope, $rootScope, $location, $window) {
  function init () {
    $document[0].title = 'Delta Dental - Update Broker Payment Information';
    $rootScope.previouslyAppointed = true;
    $scope.brokerInformation = {};
    $scope.validations = __WEBPACK_IMPORTED_MODULE_1__data_validations_json___default.a;
    $scope.submitForm = submitForm;
    $scope.currentSite = ApplicationService.getCurrentSite();
    $scope.contactEmail = 'DDMNBroker@DeltaDentalMN.org';
    if ($scope.currentSite === 'ne') {
      $scope.contactEmail = 'DDNEBroker@DeltaDentalNE.org';
    }
  }
  function submitForm (form) {
    var npnNumber = $scope.brokerInformation.npn;
    if (form.$valid) {
      $window.scrollTo(0, 0);
      $scope.error = false;
      $scope.loading = true;
      $scope.failure = false;
      var defaultBrokerInformation = ApplicationService.getBaseData().brokerInformation;
      var brokerInformation = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.merge(defaultBrokerInformation, $scope.brokerInformation);
      var data = {
        'brokerInformation': brokerInformation,
        'previouslyAppointed': true
      };
      ApplicationService.setData(data, true);
      ApplicationService.npnInSalesforce(npnNumber).then(function (response) {
        $scope.loading = false;
        if (response && response.records) {
          var record = response.records[0];
          data.brokerInformation.firstName = record.FirstName;
          data.brokerInformation.middleName = record.Middle_name__c;
          data.brokerInformation.lastName = record.LastName;
          data.brokerExternalID = record.Broker_External_ID__c;
          ApplicationService.setData(data, true);
          $location.path('/application/update-pay-packet/information');
        } else {
          $scope.failure = true;
        }
      }, function () {
        $scope.loading = false;
        $scope.error = true;
        $window.scrollTo(0, 0);
      });
    }
  }
  init();
}

/* harmony default export */ exports["a"] = UpdatePayPacketController;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_validations_json__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_validations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_validations_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_states_json__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_states_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_states_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_taxClassifications_json__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_taxClassifications_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_taxClassifications_json__);





UpdatePayPacketInformationController.$inject = [
  'ApplicationService',
  '$document',
  '$scope',
  '$rootScope',
  '$location',
  '$window',
  '$q'
];

function UpdatePayPacketInformationController (ApplicationService, $document, $scope, $rootScope, $location, $window, $q) {
  function init () {
    /**
      Note: generalInformation is never sent to the server-side, which means
      it is not there if we perform a GET for the data.

      It simply holds data that'll go under either commissionInformation,
      agencyInformation, or brokerInformation.
    **/

    var formData = ApplicationService.getData();
    $scope.generalInformation = formData.generalInformation;
    $scope.agencyInformation = formData.agencyInformation;
    $scope.brokerInformation = formData.brokerInformation;
    $scope.commissionInformation = formData.commissionInformation;

    $scope.validations = __WEBPACK_IMPORTED_MODULE_1__data_validations_json___default.a;
    $scope.submitForm = submitForm;
    $scope.addressErrorDetails = null;
    $scope.statesOptions = __WEBPACK_IMPORTED_MODULE_2__data_states_json___default.a;
    $scope.taxClassifications = __WEBPACK_IMPORTED_MODULE_3__data_taxClassifications_json___default.a;
    $scope.previousStep = previousStep;
    $scope.selectAddress = selectAddress;

    var itemsToWatch = [
      'commissionInformation.assignee',
      'agencyInformation.name',
      'brokerInformation.firstName',
      'brokerInformation.middleName',
      'brokerInformation.lastName'
    ];

    $scope.$watchGroup(itemsToWatch, function () {
      if ($scope.commissionInformation.assignee === 'myself') {
        var names = [];
        names.push($scope.brokerInformation.firstName);
        if ($scope.brokerInformation.middleName) {
          names.push($scope.brokerInformation.middleName);
        }
        names.push($scope.brokerInformation.lastName);
        $scope.commissionInformation.assigneeName = (names.join(' '));
      } else {
        $scope.commissionInformation.assigneeName = $scope.agencyInformation.name;
      }
    });

    $rootScope.previouslyAppointed = true;
  }

  $scope.editAddress = function () {
    $scope.addressErrorDetails = null;
    $window.scrollTo(0, 0);
  };

  function selectAddress (address) {
    if ($scope.addressErrorDetails.type === 'payee') {
      $scope.generalInformation.assigneeAddress = address.address;
      $scope.generalInformation.assigneeAddress2 = address.address2;
      $scope.generalInformation.assigneeCity = address.city;
      $scope.generalInformation.assigneeState = address.state;
      $scope.generalInformation.assigneeZipCode = address.zipCode;
      $scope.skipPayeeAddress = true;
    } else {
      $scope.commissionInformation.finInstStreetAddress = address.address;
      $scope.commissionInformation.finInstStreetAddress2 = address.address2;
      $scope.commissionInformation.finInstCity = address.city;
      $scope.commissionInformation.finInstState = address.state;
      $scope.commissionInformation.finInstZipCode = address.zipCode;
      $scope.skipFinancialValidation = true;
    }
    nextStep();
  }

  function previousStep () {
    $location.path('/application/update-pay-packet');
  }

  function submitForm (form) {
    $window.scrollTo(0, 0);
    if (form.$valid) {
      $scope.addressError = false;
      $scope.skipPayeeAddress = false;
      $scope.skipFinancialValidation = false;
      nextStep();
    }
  }

  function nextStep () {
    $window.scrollTo(0, 0);

    var data = {
      brokerInformation: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy($scope.brokerInformation),
      commissionInformation: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy($scope.commissionInformation),
      agencyInformation: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy($scope.agencyInformation),
      generalInformation: __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy($scope.generalInformation)
    };

    if ($scope.commissionInformation.assignee === 'myself') {
      data.brokerInformation.ssn = $scope.generalInformation.ssn;
      data.brokerInformation.streetAddress = $scope.generalInformation.assigneeAddress;
      data.brokerInformation.streetAddress2 = $scope.generalInformation.assigneeAddress2;
      data.brokerInformation.city = $scope.generalInformation.assigneeCity;
      data.brokerInformation.state = $scope.generalInformation.assigneeState;
      data.brokerInformation.zipCode = $scope.generalInformation.assigneeZipCode;
      data.brokerInformation.resTelephone = $scope.generalInformation.assigneePhone;
      data.brokerInformation.email = $scope.generalInformation.assigneeEmail;
    }

    if ($scope.commissionInformation.assignee === 'agency') {
      data.agencyInformation.usingAgency = true;
      data.agencyInformation.businessFedTaxID = $scope.generalInformation.assigneeTaxID;
      data.agencyInformation.taxClassification = $scope.generalInformation.taxClassification;
      data.agencyInformation.businessAddress = $scope.generalInformation.assigneeAddress;
      data.agencyInformation.businessAddress2 = $scope.generalInformation.assigneeAddress2;
      data.agencyInformation.businessCity = $scope.generalInformation.assigneeCity;
      data.agencyInformation.businessState = $scope.generalInformation.assigneeState;
      data.agencyInformation.businessZipCode = $scope.generalInformation.assigneeZipCode;
      data.agencyInformation.businessPhone = $scope.generalInformation.assigneePhone;
      data.agencyInformation.businessEmail = $scope.generalInformation.assigneeEmail;
    }

    if ($scope.commissionInformation.assignee === 'third_party') {
      data.commissionInformation.usingAgency = true;
      data.commissionInformation.assigneeTaxID = $scope.generalInformation.assigneeTaxID;
      data.commissionInformation.taxClassification = $scope.generalInformation.taxClassification;
      data.commissionInformation.assigneeAddress = $scope.generalInformation.assigneeAddress;
      data.commissionInformation.assigneeAddress2 = $scope.generalInformation.assigneeAddress2;
      data.commissionInformation.assigneeCity = $scope.generalInformation.assigneeCity;
      data.commissionInformation.assigneeState = $scope.generalInformation.assigneeState;
      data.commissionInformation.assigneeZipCode = $scope.generalInformation.assigneeZipCode;
      data.commissionInformation.assigneePhone = $scope.generalInformation.assigneePhone;
      data.commissionInformation.assigneeEmail = $scope.generalInformation.assigneeEmail;
    }

    if ($scope.commissionInformation.updateCommissionInformation) {
      data.commissionInformation.payViaCheck = false;
      data.commissionInformation.useDirectDeposit = false;
    } else {
      data.commissionInformation.payViaCheck = true;
      data.commissionInformation.useDirectDeposit = true;
    }

    ApplicationService.setData(data);

    $scope.loading = true;

    validatePayeeAddress()
      .then(validateFinancialAddress)
      .then(submitAllData)
      .then(function () {
        $scope.loading = false;
        nextPage();
      }).catch(function () {
        $scope.loading = false;
      });
  }

  function submitAllData () {
    return ApplicationService.submit(false).catch(function () {
      $scope.failure = true;
    });
  }

  function validatePayeeAddress () {
    return $q(function (resolve, reject) {
      if ($scope.skipPayeeAddress) {
        resolve();
        return;
      }
      ApplicationService.validateAddress({
        address: $scope.generalInformation.assigneeAddress,
        address2: $scope.generalInformation.assigneeAddress2,
        city: $scope.generalInformation.assigneeCity,
        state: $scope.generalInformation.assigneeState,
        zipCode: $scope.generalInformation.assigneeZipCode
      }).then(function (response) {
        $scope.addressErrorDetails = null;
        resolve();
      }, function (response) {
        $scope.addressErrorDetails = response;
        $scope.addressErrorDetails.type = 'payee';
        reject();
      });
    });
  }

  function validateFinancialAddress () {
    $scope.addressExplanation = '';
    return $q(function (resolve, reject) {
      if ($scope.skipFinancialValidation) {
        resolve();
        return;
      }
      if ($scope.commissionInformation.updateCommissionInformation) {
        ApplicationService.validateAddress({
          address: $scope.commissionInformation.finInstStreetAddress,
          address2: $scope.commissionInformation.finInstStreetAddress2,
          city: $scope.commissionInformation.finInstCity,
          state: $scope.commissionInformation.finInstState,
          zipCode: $scope.commissionInformation.finInstZipCode
        }).then(function (response) {
          $scope.addressErrorDetails = null;
          resolve();
        }, function (response) {
          $scope.addressErrorDetails = response;
          $scope.addressErrorDetails.type = 'financial';
          reject();
        });
      } else {
        resolve();
      }
    });
  }

  function nextPage () {
    $location.path('/application/update-pay-packet/review');
  }

  init();
}

/* harmony default export */ exports["a"] = UpdatePayPacketInformationController;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_actions_pug__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_actions_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_actions_pug__);

var actionsDirective = function (config) {
  return {
    restrict: 'E',
    template: __WEBPACK_IMPORTED_MODULE_0__partials_actions_pug___default.a,
    scope: false // this directive is always used in the context of parent directive
  };
};
/* harmony default export */ exports["a"] = actionsDirective;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_address_validator_pug__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_address_validator_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__partials_address_validator_pug__);

var addressValidatorDirective = function (config) {
  return {
    restrict: 'E',
    template: __WEBPACK_IMPORTED_MODULE_0__partials_address_validator_pug___default.a,
    require: 'ngModel',
    scope: {
      'model': '=ngModel',
      'editAddress': '=',
      'selectAddress': '='
    },
    link: function (scope) {
      scope.returnText = null;
      if (scope.model.returnText) {
        scope.returnText = scope.model.returnText.replace('Default address: ', '');
      }
    }
  };
};
/* harmony default export */ exports["a"] = addressValidatorDirective;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/*eslint-disable */
/**
 Taken from https://github.com/wender/angular-simple-input-mask
**/

var angularMaskDirective = function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      isModelValueEqualViewValues: '='
    },
    link: function ($scope, el, attrs, model) {
      $scope.$watch(function(){return attrs.angularMask;}, function(value) {
        if (model.$viewValue != null){
          model.$viewValue = mask(String(model.$viewValue).replace(/\D/g, ''));
          el.val(model.$viewValue);
        }
      });

      model.$formatters.push(function (value) {
        return value === null ? '' : mask(String(value).replace(/\D/g, ''));
      });

      model.$parsers.push(function (value) {
        model.$viewValue = mask(value);
        var modelValue = $scope.isModelValueEqualViewValues ? model.$viewValue : String(value).replace(/\D/g, '');
        el.val(model.$viewValue);
        return modelValue;
      });

      function mask(val) {
        var format = attrs.angularMask,
        arrFormat = format.split('|');

        if (arrFormat.length > 1) {
          arrFormat.sort(function (a, b) {
            return a.length - b.length;
          });
        }

        if (val === null || val == '') {
          return '';
        }
        var value = String(val).replace(/\D/g, '');
        if (arrFormat.length > 1) {
          for (var a in arrFormat) {
            if (value.replace(/\D/g, '').length <= arrFormat[a].replace(/\D/g, '').length) {
              format = arrFormat[a];
              break;
            }
          }
        }
        var newValue = '';
        for (var nmI = 0, mI = 0; mI < format.length;) {
          if (!value[nmI]) {
            break;
          }
          if (format[mI].match(/\D/)) {
            newValue += format[mI];
          } else {
            newValue += value[nmI];
            nmI++;
          }
          mI++;
        }
        return newValue;
      }
    }
  };
};
/* harmony default export */ exports["a"] = angularMaskDirective;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_birthday_picker_pug__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_birthday_picker_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_birthday_picker_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_monthsOfTheYear_json__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_monthsOfTheYear_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_monthsOfTheYear_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var birthdayDirective = function (config) {
  return {
    restrict: 'E',
    scope: {
      min: '=',
      max: '=',
      required: '='
    },
    require: '?ngModel',
    template: __WEBPACK_IMPORTED_MODULE_0__angular_birthday_picker_pug___default.a,
    link: function (scope, elem, attrs, ngModel) {
      var birthday = null;
      function init () {
        scope.birthday = {
          year: null,
          month: null,
          date: null
        };
        scope.monthsOfTheYear = __WEBPACK_IMPORTED_MODULE_1__data_monthsOfTheYear_json___default.a;
        scope.$watchCollection('birthday', checkBirthday);
      }

      function checkBirthday () {
        var missingFields = false;
        if (scope.birthday.year === null || scope.birthday.month === null || scope.birthday.day === null) {
          missingFields = true;
        }

        ngModel.$setValidity('required', !missingFields);

        if (!missingFields) {
          var year = parseInt(scope.birthday.year, 10);
          var month = parseInt(scope.birthday.month, 10);
          var date = parseInt(scope.birthday.date, 10);

          if (scope.birthday.year && scope.birthday.year.length === 2) {
            year = 1900 + year;
          }

          var dateObj = __WEBPACK_IMPORTED_MODULE_2_moment___default()([year, month, date]).startOf('day');
          var isValidDate = (
            dateObj.year() === year &&
            dateObj.month() === month &&
            dateObj.date() === date
          );

          ngModel.$setValidity('invalid', isValidDate);

          if (scope.min && isValidDate) {
            var minDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(scope.min).startOf('day');
            ngModel.$setValidity('min', minDate.diff(dateObj) <= 0);
          }

          if (scope.max && isValidDate) {
            var maxDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(scope.max).startOf('day');
            ngModel.$setValidity('max', maxDate.diff(dateObj) >= 0);
          }

          ngModel.$setViewValue(dateObj.format('YYYY-MM-DD'));
        }
      }

      ngModel.$render = function () {
        if (ngModel.$modelValue) {
          birthday = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ngModel.$modelValue);
          scope.birthday = {
            year: birthday.year(),
            month: birthday.month(),
            date: birthday.date()
          };
        }
        checkBirthday();
      };

      init();
    }
  };
};

/* harmony default export */ exports["a"] = birthdayDirective;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/**
  On mobile devices: uses native date picker
  On desktop browsers: uses specific version of Pikaday that is accessible


  This should be changed so that the button to trigger the calendar comes afterwards.
  This does not match other accessible inputs like:
  http://www.oaa-accessibility.org/examplep/datepicker1/
  AND
  https://www.ssa.gov/accessibility/bpl/bps/forms/calendar/default.htm
**/




var datepickerDirective = function (config) {
  return {
    scope: {
      'ngModel': '=',
      'minDate': '=',
      'maxDate': '=',
      'dateRequired': '='
    },
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, elem, attrs, ctrl) {
      var dateFormat = 'YYYY-MM-DD';
      var el = document.createElement('input');
      var notADateValue = 'not-a-date';
      el.setAttribute('type', 'date');
      el.setAttribute('value', notADateValue);
      var supportsDate = !(el.value === notADateValue);
      var isTouchDevice = ('ontouchstart' in window || navigator.msMaxTouchPoints);
      var usingDateInput = (supportsDate && isTouchDevice);
      if (usingDateInput) {
        elem.attr('type', 'date');
        scope.$watch('model', function (value) {
          if (value) {
            elem.val(value);
          }
        });
        scope.$watch('minDate', function (value) {
          if (value) {
            elem.attr('min', value);
          }
        });
        scope.$watch('maxDate', function (value) {
          if (value) {
            elem.attr('max', value);
          }
        });
      } else {
        var userFriendlyFormat = 'MM/DD/YYYY';
        elem.attr('type', 'text');
        elem.attr('autocomplete', 'off');
        elem.attr('placeholder', 'mm/dd/yyyy');
        var options = {
          field: elem[0]
        };
        options.format = userFriendlyFormat;
        options.onSelect = function (date) {
          var formattedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(dateFormat);
          ctrl.$setViewValue(formattedDate);
        };
        var picker = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a(options);
        scope.$on('$destroy', function () {
          picker.destroy();
        });
        scope.$watch('model', function (value) {
          if (value) {
            picker.setDate(__WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format(dateFormat));
          }
        });
        // not using these for now as disabling entry altogether can be very confusing
        // scope.$watch('minDate', function (value) {
        //   if (value) {
        //     picker.setMinDate(moment(value).startOf('day').toDate());
        //   }
        // });
        // scope.$watch('maxDate', function (value) {
        //   if (value) {
        //     picker.setMaxDate(moment(value).startOf('day').toDate());
        //   }
        // });
      }

      ctrl.$render = function () {
        if (scope.ngModel) {
          if (usingDateInput) {
            elem.val(scope.ngModel);
          } else {
            var formattedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(scope.ngModel).format(userFriendlyFormat);
            elem.val(formattedDate);
            picker.setDate(formattedDate);
          }
        }
      };

      ctrl.$validators.required = function (modelValue) {
        if (!scope.dateRequired) {
          return true;
        }        
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(modelValue, dateFormat).isValid();
      };

      ctrl.$validators.min = function (modelValue) {
        if (!scope.minDate) {
          return true;
        }
        var dateObj = __WEBPACK_IMPORTED_MODULE_1_moment___default()(modelValue, dateFormat).startOf('day').toDate();
        if (modelValue || scope.dateRequired) {
          var minDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(scope.minDate, dateFormat).startOf('day').toDate();
          return minDate <= dateObj;
        }
        return true;
      };

      ctrl.$validators.max = function (modelValue) {
        if (!scope.maxDate) {
          return true;
        }
        var dateObj = __WEBPACK_IMPORTED_MODULE_1_moment___default()(modelValue, dateFormat).startOf('day').toDate();
        var maxDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(scope.maxDate, dateFormat).startOf('day').toDate();
        if (modelValue || scope.dateRequired) {
          return maxDate >= dateObj;
        }
        return true;
      };

      scope.$watch('minDate', function() {
        ctrl.$validate();
      });

      scope.$watch('maxDate', function() {
        ctrl.$validate();
      });

    }
  };
};
/* harmony default export */ exports["a"] = datepickerDirective;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
// has one main drawback, caret has to be at end of input
function ssnDirective () {
  return {
    require: 'ngModel',
    link: function (scope, elem, attr, ctrl) {
      var chars = [];
      elem.bind('click', function () {
      /**
       * Hack to prevent caret from being anywhere else other than the end
       * Could be good or bad from UX side, but helps prevent a lot of possible edge cases.
       * TODO: run this through voiceover just in case
       */
        elem.val(elem.val());
      });
      function formatString (text) {
        var unSeparatedString = text.replace(/-/g, ''); // this string has no dashes
        var lastChar = unSeparatedString[unSeparatedString.length - 1];
        chars.length = unSeparatedString.length; // truncate array if necessary
        if (lastChar !== '*') { // dont update array if the latest character was a *
          chars[unSeparatedString.length - 1] = lastChar; // update last value
        }
        var string = '';
        if (chars.length > 3) {
          string = '***-';
        } else {
          string += chars.slice(0, 3).join('');
        }
        if (chars.length > 5) {
          string += '**-';
        } else {
          string += chars.slice(3, 5).join('');
        }
        string += chars.slice(5, 9).join('');
        return string;
      }
      function parseSSN (text) {
        if (typeof text === 'string') {
          var formattedString = formatString(text);
          var rawString = chars.join('');
          ctrl.$setViewValue(formattedString);
          ctrl.$setValidity('pattern', chars.length === 9 && !isNaN(rawString));
          ctrl.$render();
          return rawString;
        }
        chars = [];
        return '';
      }
      function formatSSN (text) {
        if (typeof text !== 'string') {
          return;
        }
        chars = text.split('');
        return formatString(text);
      }
      ctrl.$parsers.push(parseSSN);
      ctrl.$formatters.push(formatSSN);
    }
  };
}

/* harmony default export */ exports["a"] = ssnDirective;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_formStarterData_json__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_formStarterData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_formStarterData_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_formStarterDataMinimal_json__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_formStarterDataMinimal_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_formStarterDataMinimal_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);






ApplicationService.$inject = ['$http', '$q', '$window'];

function ApplicationService ($http, $q, $window) {
  var servicesUrl = $window._env.services;
  var servicesPrefix = $window._env.servicesPrefix;
  // var currentSite = $window._env.state;
  var currentSite = 'mn';
  if (window.location.host.indexOf('deltadentalne') > -1) {
    currentSite = 'ne';
  }

  this.data = __WEBPACK_IMPORTED_MODULE_2__data_formStarterData_json___default.a;

  this.getCurrentSite = function () {
    return currentSite;
  };

  this.getData = function () {
    return __WEBPACK_IMPORTED_MODULE_1_angular___default.a.copy(this.data);
  }.bind(this);

  this.getBaseData = function (previouslyAppointed) {
    var starterData = previouslyAppointed ? __WEBPACK_IMPORTED_MODULE_3__data_formStarterDataMinimal_json___default.a : __WEBPACK_IMPORTED_MODULE_2__data_formStarterData_json___default.a;
    return __WEBPACK_IMPORTED_MODULE_1_angular___default.a.copy(starterData);
  };

  this.setData = function (data, shouldSetBaseData) {
    if (shouldSetBaseData) {
      this.data = this.getBaseData(data.previouslyAppointed);
    }
    __WEBPACK_IMPORTED_MODULE_1_angular___default.a.extend(this.data, data);
  }.bind(this);

  this.submit = function (finalized) {
    var url = servicesUrl + servicesPrefix + '/appointment/application';
    if (this.data.previouslyAppointed) {
      url = servicesUrl + servicesPrefix + '/appointment/payPacket';
    }
    if (this.data.transactionID) {
      url += '/' + encodeURIComponent(this.data.transactionID);
    }
    var method = 'POST';
    var data = {};
    data.transactionID = this.data.transactionID;
    data.brokerExternalID = this.data.brokerExternalID;
    data.generalAgencyName = this.data.agencyInformation.generalAgencyName;
    data.agencyInformation = this.data.agencyInformation;
    data.brokerInformation = this.data.brokerInformation;
    data.commissionInformation = this.data.commissionInformation;
    data.declarations = this.data.declarations;
    data.selectedStates = this.data.selectedStates;
    data.createdDate = this.data.createdDate;
    data.modifiedDate = this.data.modifiedDate;
    data.finalized = finalized;
    return $http({
      url: url,
      method: method,
      data: data
    }).then(function (response) {
      if (response.data.transactionID) {
        this.data.transactionID = response.data.transactionID;
        this.data.createdDate = response.data.createdDate;
        this.data.modifiedDate = response.data.modifiedDate;
      }
    }.bind(this));
  }.bind(this);

  this.validateNpn = function (npn) {
    // for testing only
    //var url = 'http://localhost:3005/appointment/validateNPN';
    var url = servicesUrl + '/svc3005/appointment/validateNPN';
    return $q(function (resolve, reject) {
      $http({
        url: url,
        method: 'GET',
        params: {
          'npn': npn
        }
      }).then(function (response) {
        if (response.data && response.data.status === 'NOT-IN-SALESFORCE') {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      }, function (response) {
        reject(response.data);
      });
    });
  };

  this.npnInSalesforce = function (npn) {
    // for testing only
    var url = servicesUrl + '/svc3005/appointment/npnInSalesforce';
    return $q(function (resolve, reject) {
      $http({
        url: url,
        method: 'GET',
        params: {
          'npn': npn
        }
      }).then(function (response) {
        if (response.data && response.data.status === 'IN-SALESFORCE') {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      }, function (response) {
        reject(response.data);
      });
    });
  };

  /*
  * Generates new array of licenses based on selected states + state of residence if it wasn't selected,
  * while also keeping existing license data
  */
  this.generateLicenses = function (existingLicenses, stateOfResidence, isAgency) {
    existingLicenses = existingLicenses || []; // hacky
    var today = new Date();
    var selectedStates = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.copy(this.data.selectedStates);
    if (stateOfResidence) {
      selectedStates[stateOfResidence] = stateOfResidence;
    }
    var selectedStatesArray = [];
    Object.keys(selectedStates).forEach(function (state) {
      if (selectedStates[state] !== false) {
        selectedStatesArray.push(state);
      }
    });
    var updatedLicenses = [];
    var licensesMap = {};
    existingLicenses.forEach(function (license) {
      licensesMap[license.state] = license;
    });
    selectedStatesArray.forEach(function (selectedState) {
      // var minExpirationDate = moment(today).format('YYYY-MM-DD');
      var maxExpirationDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add('30', 'months').format('YYYY-MM-DD');
      var dateRequired = true;

      if (selectedState === stateOfResidence && !existingLicenses[selectedState]) {
        // minExpirationDate = '1969-12-31';
        maxExpirationDate = '2099-01-01';
      }
      var license = licensesMap[selectedState];
      if (!license) {
        license = {
          'number': '',
          'expirationDate': null,
          'minExpirationDate': today,
          'maxExpirationDate': maxExpirationDate,
          'state': selectedState,
          'dateRequired': dateRequired
        };
      }
      updatedLicenses.push(license);
    });
    return updatedLicenses;
  }.bind(this);

  this.getHtmlUrl = function (options) {
    var url = servicesUrl + '/svc9000/finder/pdf/applicationAsHTML';
    url += '?transactionId=' + encodeURIComponent(this.data.transactionID);
    if (options) {
      url += '&pageName=' + encodeURIComponent(options.pageName);
    }
    return url;
  }.bind(this);

  this.getPdfUrl = function (options) {
    var url = servicesUrl;

    if (this.data.previouslyAppointed) {
      url += '/svc9000/finder/pdf/payPacketAsPDF';
    } else {
      url += '/svc9000/finder/pdf/applicationAsPDF';
    }

    url += '?transactionId=' + encodeURIComponent(this.data.transactionID);
    if (options) {
      url += '&pageName=' + encodeURIComponent(options.pageName);
    }
    return url;
  }.bind(this);

  /**
  * Resolves successfully if exact match is found
  * Rejects if address is not an exact match (sometimes with a list of addresses).
  **/

  this.validateAddress = function (enteredAddress) {
    var address = __WEBPACK_IMPORTED_MODULE_1_angular___default.a.copy(enteredAddress);
    if (typeof address.address2 === 'undefined') {
      address.address2 = '';
    }
    return $q(function (resolve, reject) {
      var url = servicesUrl + '/svc3007/validate/address';
      return $http({
        url: url,
        params: {
          addressLine1: address.address,
          addressLine2: address.address2,
          city: address.city,
          state: address.state,
          zip: address.zipCode
        }
      }).then(function (response) {
        var addressMatches = false;
        var addresses = [];
        var uspsAddresses = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(response, 'data.validatedAddress');
        if (!uspsAddresses.length) {
          addressMatches = false;
        }
        var returnText = '';
        if (uspsAddresses) {
          if (addressMatches) {
            return;
          }
          var address1 = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(uspsAddresses, 'Address1') || '';
          var address2 = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(uspsAddresses, 'Address2') || '';
          var city = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(uspsAddresses, 'City') || '';
          var state = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(uspsAddresses, 'State') || '';
          var zipCode = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(uspsAddresses, 'Zip5') || '';
          returnText = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(uspsAddresses, 'ReturnText') || '';
          addressMatches = (
            address.address.toUpperCase() === address1 &&
            address.address2.toUpperCase() === address2 &&
            address.city.toUpperCase() === city &&
            address.state.toUpperCase() === state &&
            address.zipCode === zipCode
          );
          addresses.push({
            address: address,
            address2: address2,
            city: city,
            state: state,
            zipCode: zipCode
          });
        }
        if (!addresses) {
          reject({
            enteredAddress: address,
            addresses: addresses,
            addressMatches: false,
            returnText: returnText
          });
        } else {
          resolve({
            enteredAddress: address,
            addresses: addresses,
            addressMatches: true,
            returnText: ''
          });
        }
      }, function (response) {
        reject({
          enteredAddress: address,
          addresses: [],
          addressMatches: false,
          returnText: ''
        });
      });
    });
  };
}

/* harmony default export */ exports["a"] = ApplicationService;


/***/ },
/* 35 */
/***/ function(module, exports) {

/**
 * @license AngularJS v1.5.7
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* jshint ignore:start */
// this code is in the core, but not in angular-messages.js
var isArray = angular.isArray;
var forEach = angular.forEach;
var isString = angular.isString;
var jqLite = angular.element;
/* jshint ignore:end */

/**
 * @ngdoc module
 * @name ngMessages
 * @description
 *
 * The `ngMessages` module provides enhanced support for displaying messages within templates
 * (typically within forms or when rendering message objects that return key/value data).
 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
 * show and hide error messages specific to the state of an input field, the `ngMessages` and
 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
 * sequencing based on the order of how the messages are defined in the template.
 *
 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
 * `ngMessage` and `ngMessageExp` directives.
 *
 * # Usage
 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
 * {@link ngModel ngModel} directive.
 *
 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
 * the `ngMessages` directive.
 *
 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
 * directive.
 *
 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Enter text:
 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
 *   </label>
 *   <div ng-messages="myForm.myField.$error" role="alert">
 *     <div ng-message="required">Please enter a value for this field.</div>
 *     <div ng-message="email">This field must be a valid email address.</div>
 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
 *   </div>
 * </form>
 * ```
 *
 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
 * set to the `$error` object owned by the `myField` input in our `myForm` form.
 *
 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
 * setting `ng-message="required"` specifies that this particular element should be displayed when there
 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
 * `myForm.myField.$error`).
 *
 * ### Message order
 *
 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
 * to prioritise messages using custom JavaScript code.
 *
 * Given the following error object for our example (which informs us that the field `myField` currently has both the
 * `required` and `email` errors):
 *
 * ```javascript
 * <!-- keep in mind that ngModel automatically sets these error flags -->
 * myField.$error = { required : true, email: true, maxlength: false };
 * ```
 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
 * but the `email` message will be visible because it is still applicable.
 *
 * ### Displaying multiple messages at the same time
 *
 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
 *
 * ```html
 * <!-- attribute-style usage -->
 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
 *
 * <!-- element-style usage -->
 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
 * ```
 *
 * ## Reusing and Overriding Messages
 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
 * template. This allows for generic collection of messages to be reused across multiple parts of an
 * application.
 *
 * ```html
 * <script type="text/ng-template" id="error-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-messages-include="error-messages"></div>
 * </div>
 * ```
 *
 * However, including generic messages may not be useful enough to match all input fields, therefore,
 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
 * them within the directive container.
 *
 * ```html
 * <!-- a generic template of error messages known as "my-custom-messages" -->
 * <script type="text/ng-template" id="my-custom-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            id="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
 *        override the messages present in the ng-messages-include template -->
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <!-- this required message has overridden the template message -->
 *     <div ng-message="required">You did not enter your email address</div>
 *
 *     <!-- this is a brand new message and will appear last in the prioritization -->
 *     <div ng-message="email">Your email address is invalid</div>
 *
 *     <!-- and here are the generic error messages -->
 *     <div ng-messages-include="my-custom-messages"></div>
 *   </div>
 * </form>
 * ```
 *
 * In the example HTML code above the message that is set on required will override the corresponding
 * required message defined within the remote template. Therefore, with particular input fields (such
 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
 * while more generic messages can be used to handle other, more general input errors.
 *
 * ## Dynamic Messaging
 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
 * repeaters to list messages is also supported. This means that the code below will be able to
 * fully adapt itself and display the appropriate message when any of the expression data changes:
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message="required">You did not enter your email address</div>
 *     <div ng-repeat="errorMessage in errorMessages">
 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
 *     </div>
 *   </div>
 * </form>
 * ```
 *
 * The `errorMessage.type` expression can be a string value or it can be an array so
 * that multiple errors can be associated with a single error message:
 *
 * ```html
 *   <label>
 *     Email address
 *     <input type="email"
 *            ng-model="data.email"
 *            name="myEmail"
 *            ng-minlength="5"
 *            ng-maxlength="100"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message-exp="'required'">You did not enter your email address</div>
 *     <div ng-message-exp="['minlength', 'maxlength']">
 *       Your email must be between 5 and 100 characters long
 *     </div>
 *   </div>
 * ```
 *
 * Feel free to use other structural directives such as ng-if and ng-switch to further control
 * what messages are active and when. Be careful, if you place ng-message on the same element
 * as these structural directives, Angular may not be able to determine if a message is active
 * or not. Therefore it is best to place the ng-message on a child element of the structural
 * directive.
 *
 * ```html
 * <div ng-messages="myForm.myEmail.$error" role="alert">
 *   <div ng-if="showRequiredError">
 *     <div ng-message="required">Please enter something</div>
 *   </div>
 * </div>
 * ```
 *
 * ## Animations
 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
 * the DOM by the `ngMessages` directive.
 *
 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
 * hook into the animations whenever these classes are added/removed.
 *
 * Let's say that our HTML code for our messages container looks like so:
 *
 * ```html
 * <div ng-messages="myMessages" class="my-messages" role="alert">
 *   <div ng-message="alert" class="some-message">...</div>
 *   <div ng-message="fail" class="some-message">...</div>
 * </div>
 * ```
 *
 * Then the CSS animation code for the message container looks like so:
 *
 * ```css
 * .my-messages {
 *   transition:1s linear all;
 * }
 * .my-messages.ng-active {
 *   // messages are visible
 * }
 * .my-messages.ng-inactive {
 *   // messages are hidden
 * }
 * ```
 *
 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
 *
 * Therefore, the CSS code for the inner messages looks like so:
 *
 * ```css
 * .some-message {
 *   transition:1s linear all;
 * }
 *
 * .some-message.ng-enter {}
 * .some-message.ng-enter.ng-enter-active {}
 *
 * .some-message.ng-leave {}
 * .some-message.ng-leave.ng-leave-active {}
 * ```
 *
 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
 */
angular.module('ngMessages', [])

  /**
   * @ngdoc directive
   * @module ngMessages
   * @name ngMessages
   * @restrict AE
   *
   * @description
   * `ngMessages` is a directive that is designed to show and hide messages based on the state
   * of a key/value object that it listens on. The directive itself complements error message
   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
   *
   * `ngMessages` manages the state of internal messages within its container element. The internal
   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
   * on if they're present within the key/value object. By default, only one message will be displayed
   * at a time and this depends on the prioritization of the messages within the template. (This can
   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
   *
   * A remote template can also be used to promote message reusability and messages can also be
   * overridden.
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {string} ngMessages an angular expression evaluating to a key/value object
   *                 (this is typically the $error object on an ngModel instance).
   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
   *
   * @example
   * <example name="ngMessages-directive" module="ngMessagesExample"
   *          deps="angular-messages.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <form name="myForm">
   *       <label>
   *         Enter your name:
   *         <input type="text"
   *                name="myName"
   *                ng-model="name"
   *                ng-minlength="5"
   *                ng-maxlength="20"
   *                required />
   *       </label>
   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
   *
   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
   *         <div ng-message="required">You did not enter a field</div>
   *         <div ng-message="minlength">Your field is too short</div>
   *         <div ng-message="maxlength">Your field is too long</div>
   *       </div>
   *     </form>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngMessagesExample', ['ngMessages']);
   *   </file>
   * </example>
   */
  .directive('ngMessages', ['$animate', function($animate) {
    var ACTIVE_CLASS = 'ng-active';
    var INACTIVE_CLASS = 'ng-inactive';

    return {
      require: 'ngMessages',
      restrict: 'AE',
      controller: ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {
        var ctrl = this;
        var latestKey = 0;
        var nextAttachId = 0;

        this.getAttachId = function getAttachId() { return nextAttachId++; };

        var messages = this.messages = {};
        var renderLater, cachedCollection;

        this.render = function(collection) {
          collection = collection || {};

          renderLater = false;
          cachedCollection = collection;

          // this is true if the attribute is empty or if the attribute value is truthy
          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
                         isAttrTruthy($scope, $attrs.multiple);

          var unmatchedMessages = [];
          var matchedKeys = {};
          var messageItem = ctrl.head;
          var messageFound = false;
          var totalMessages = 0;

          // we use != instead of !== to allow for both undefined and null values
          while (messageItem != null) {
            totalMessages++;
            var messageCtrl = messageItem.message;

            var messageUsed = false;
            if (!messageFound) {
              forEach(collection, function(value, key) {
                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
                  // this is to prevent the same error name from showing up twice
                  if (matchedKeys[key]) return;
                  matchedKeys[key] = true;

                  messageUsed = true;
                  messageCtrl.attach();
                }
              });
            }

            if (messageUsed) {
              // unless we want to display multiple messages then we should
              // set a flag here to avoid displaying the next message in the list
              messageFound = !multiple;
            } else {
              unmatchedMessages.push(messageCtrl);
            }

            messageItem = messageItem.next;
          }

          forEach(unmatchedMessages, function(messageCtrl) {
            messageCtrl.detach();
          });

          unmatchedMessages.length !== totalMessages
              ? $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS)
              : $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
        };

        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);

        // If the element is destroyed, proactively destroy all the currently visible messages
        $element.on('$destroy', function() {
          forEach(messages, function(item) {
            item.message.detach();
          });
        });

        this.reRender = function() {
          if (!renderLater) {
            renderLater = true;
            $scope.$evalAsync(function() {
              if (renderLater) {
                cachedCollection && ctrl.render(cachedCollection);
              }
            });
          }
        };

        this.register = function(comment, messageCtrl) {
          var nextKey = latestKey.toString();
          messages[nextKey] = {
            message: messageCtrl
          };
          insertMessageNode($element[0], comment, nextKey);
          comment.$$ngMessageNode = nextKey;
          latestKey++;

          ctrl.reRender();
        };

        this.deregister = function(comment) {
          var key = comment.$$ngMessageNode;
          delete comment.$$ngMessageNode;
          removeMessageNode($element[0], comment, key);
          delete messages[key];
          ctrl.reRender();
        };

        function findPreviousMessage(parent, comment) {
          var prevNode = comment;
          var parentLookup = [];

          while (prevNode && prevNode !== parent) {
            var prevKey = prevNode.$$ngMessageNode;
            if (prevKey && prevKey.length) {
              return messages[prevKey];
            }

            // dive deeper into the DOM and examine its children for any ngMessage
            // comments that may be in an element that appears deeper in the list
            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
              parentLookup.push(prevNode);
              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
            } else if (prevNode.previousSibling) {
              prevNode = prevNode.previousSibling;
            } else {
              prevNode = prevNode.parentNode;
              parentLookup.push(prevNode);
            }
          }
        }

        function insertMessageNode(parent, comment, key) {
          var messageNode = messages[key];
          if (!ctrl.head) {
            ctrl.head = messageNode;
          } else {
            var match = findPreviousMessage(parent, comment);
            if (match) {
              messageNode.next = match.next;
              match.next = messageNode;
            } else {
              messageNode.next = ctrl.head;
              ctrl.head = messageNode;
            }
          }
        }

        function removeMessageNode(parent, comment, key) {
          var messageNode = messages[key];

          var match = findPreviousMessage(parent, comment);
          if (match) {
            match.next = messageNode.next;
          } else {
            ctrl.head = messageNode.next;
          }
        }
      }]
    };

    function isAttrTruthy(scope, attr) {
     return (isString(attr) && attr.length === 0) || //empty attribute
            truthy(scope.$eval(attr));
    }

    function truthy(val) {
      return isString(val) ? val.length : !!val;
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessagesInclude
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
   * code from a remote template and place the downloaded template code into the exact spot
   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
   * for a series of pre-defined messages to be reused and also allows for the developer to
   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-messages-include="remoteTplString">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
   */
  .directive('ngMessagesInclude',
    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {

    return {
      restrict: 'AE',
      require: '^^ngMessages', // we only require this for validation sake
      link: function($scope, element, attrs) {
        var src = attrs.ngMessagesInclude || attrs.src;
        $templateRequest(src).then(function(html) {
          if ($scope.$$destroyed) return;

          if (isString(html) && !html.trim()) {
            // Empty template - nothing to compile
            replaceElementWithMarker(element, src);
          } else {
            // Non-empty template - compile and link
            $compile(html)($scope, function(contents) {
              element.after(contents);
              replaceElementWithMarker(element, src);
            });
          }
        });
      }
    };

    // Helpers
    function replaceElementWithMarker(element, src) {
      // A comment marker is placed for debugging purposes
      var comment = $compile.$$createComment ?
          $compile.$$createComment('ngMessagesInclude', src) :
          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
      var marker = jqLite(comment);
      element.after(marker);

      // Don't pollute the DOM anymore by keeping an empty directive element
      element.remove();
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessage
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessage` is a directive with the purpose to show and hide a particular message.
   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * More information about using `ngMessage` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {expression} ngMessage|when a string value corresponding to the message key.
   */
  .directive('ngMessage', ngMessageDirectiveFactory())


  /**
   * @ngdoc directive
   * @name ngMessageExp
   * @restrict AE
   * @priority 1
   * @scope
   *
   * @description
   * `ngMessageExp` is a directive with the purpose to show and hide a particular message.
   * For `ngMessageExp` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression">
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression">
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
   */
  .directive('ngMessageExp', ngMessageDirectiveFactory());

function ngMessageDirectiveFactory() {
  return ['$animate', function($animate) {
    return {
      restrict: 'AE',
      transclude: 'element',
      priority: 1, // must run before ngBind, otherwise the text is set on the comment
      terminal: true,
      require: '^^ngMessages',
      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
        var commentNode = element[0];

        var records;
        var staticExp = attrs.ngMessage || attrs.when;
        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
        var assignRecords = function(items) {
          records = items
              ? (isArray(items)
                  ? items
                  : items.split(/[\s,]+/))
              : null;
          ngMessagesCtrl.reRender();
        };

        if (dynamicExp) {
          assignRecords(scope.$eval(dynamicExp));
          scope.$watchCollection(dynamicExp, assignRecords);
        } else {
          assignRecords(staticExp);
        }

        var currentElement, messageCtrl;
        ngMessagesCtrl.register(commentNode, messageCtrl = {
          test: function(name) {
            return contains(records, name);
          },
          attach: function() {
            if (!currentElement) {
              $transclude(function(elm, newScope) {
                $animate.enter(elm, null, element);
                currentElement = elm;

                // Each time we attach this node to a message we get a new id that we can match
                // when we are destroying the node later.
                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();

                // in the event that the element or a parent element is destroyed
                // by another structural directive then it's time
                // to deregister the message from the controller
                currentElement.on('$destroy', function() {
                  if (currentElement && currentElement.$$attachId === $$attachId) {
                    ngMessagesCtrl.deregister(commentNode);
                    messageCtrl.detach();
                  }
                  newScope.$destroy();
                });
              });
            }
          },
          detach: function() {
            if (currentElement) {
              var elm = currentElement;
              currentElement = null;
              $animate.leave(elm);
            }
          }
        });
      }
    };
  }];

  function contains(collection, key) {
    if (collection) {
      return isArray(collection)
          ? collection.indexOf(key) >= 0
          : collection.hasOwnProperty(key);
    }
  }
}


})(window, window.angular);


/***/ },
/* 36 */
/***/ function(module, exports) {

/**
 * @license AngularJS v1.5.8
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* global shallowCopy: false */

// There are necessary for `shallowCopy()` (included via `src/shallowCopy.js`).
// They are initialized inside the `$RouteProvider`, to ensure `window.angular` is available.
var isArray;
var isObject;

/**
 * @ngdoc module
 * @name ngRoute
 * @description
 *
 * # ngRoute
 *
 * The `ngRoute` module provides routing and deeplinking services and directives for angular apps.
 *
 * ## Example
 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
 *
 *
 * <div doc-module-components="ngRoute"></div>
 */
 /* global -ngRouteModule */
var ngRouteModule = angular.module('ngRoute', ['ng']).
                        provider('$route', $RouteProvider),
    $routeMinErr = angular.$$minErr('ngRoute');

/**
 * @ngdoc provider
 * @name $routeProvider
 *
 * @description
 *
 * Used for configuring routes.
 *
 * ## Example
 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
 *
 * ## Dependencies
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 */
function $RouteProvider() {
  isArray = angular.isArray;
  isObject = angular.isObject;

  function inherit(parent, extra) {
    return angular.extend(Object.create(parent), extra);
  }

  var routes = {};

  /**
   * @ngdoc method
   * @name $routeProvider#when
   *
   * @param {string} path Route path (matched against `$location.path`). If `$location.path`
   *    contains redundant trailing slash or is missing one, the route will still match and the
   *    `$location.path` will be updated to add or drop the trailing slash to exactly match the
   *    route definition.
   *
   *    * `path` can contain named groups starting with a colon: e.g. `:name`. All characters up
   *        to the next slash are matched and stored in `$routeParams` under the given `name`
   *        when the route matches.
   *    * `path` can contain named groups starting with a colon and ending with a star:
   *        e.g.`:name*`. All characters are eagerly stored in `$routeParams` under the given `name`
   *        when the route matches.
   *    * `path` can contain optional named groups with a question mark: e.g.`:name?`.
   *
   *    For example, routes like `/color/:color/largecode/:largecode*\/edit` will match
   *    `/color/brown/largecode/code/with/slashes/edit` and extract:
   *
   *    * `color: brown`
   *    * `largecode: code/with/slashes`.
   *
   *
   * @param {Object} route Mapping information to be assigned to `$route.current` on route
   *    match.
   *
   *    Object properties:
   *
   *    - `controller` – `{(string|function()=}` – Controller fn that should be associated with
   *      newly created scope or the name of a {@link angular.Module#controller registered
   *      controller} if passed as a string.
   *    - `controllerAs` – `{string=}` – An identifier name for a reference to the controller.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used by {@link
   *      ngRoute.directive:ngView ngView} or {@link ng.directive:ngInclude ngInclude} directives.
   *      This property takes precedence over `templateUrl`.
   *
   *      If `template` is a function, it will be called with the following parameters:
   *
   *      - `{Array.<Object>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used by {@link ngRoute.directive:ngView ngView}.
   *
   *      If `templateUrl` is a function, it will be called with the following parameters:
   *
   *      - `{Array.<Object>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route
   *
   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
   *      be injected into the controller. If any of these dependencies are promises, the router
   *      will wait for them all to be resolved or one to be rejected before the controller is
   *      instantiated.
   *      If all the promises are resolved successfully, the values of the resolved promises are
   *      injected and {@link ngRoute.$route#$routeChangeSuccess $routeChangeSuccess} event is
   *      fired. If any of the promises are rejected the
   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event is fired.
   *      For easier access to the resolved dependencies from the template, the `resolve` map will
   *      be available on the scope of the route, under `$resolve` (by default) or a custom name
   *      specified by the `resolveAs` property (see below). This can be particularly useful, when
   *      working with {@link angular.Module#component components} as route templates.<br />
   *      <div class="alert alert-warning">
   *        **Note:** If your scope already contains a property with this name, it will be hidden
   *        or overwritten. Make sure, you specify an appropriate name for this property, that
   *        does not collide with other properties on the scope.
   *      </div>
   *      The map object is:
   *
   *      - `key` – `{string}`: a name of a dependency to be injected into the controller.
   *      - `factory` - `{string|function}`: If `string` then it is an alias for a service.
   *        Otherwise if function, then it is {@link auto.$injector#invoke injected}
   *        and the return value is treated as the dependency. If the result is a promise, it is
   *        resolved before its value is injected into the controller. Be aware that
   *        `ngRoute.$routeParams` will still refer to the previous route within these resolve
   *        functions.  Use `$route.current.params` to access the new route parameters, instead.
   *
   *    - `resolveAs` - `{string=}` - The name under which the `resolve` map will be available on
   *      the scope of the route. If omitted, defaults to `$resolve`.
   *
   *    - `redirectTo` – `{(string|function())=}` – value to update
   *      {@link ng.$location $location} path with and trigger route redirection.
   *
   *      If `redirectTo` is a function, it will be called with the following parameters:
   *
   *      - `{Object.<string>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route templateUrl.
   *      - `{string}` - current `$location.path()`
   *      - `{Object}` - current `$location.search()`
   *
   *      The custom `redirectTo` function is expected to return a string which will be used
   *      to update `$location.path()` and `$location.search()`.
   *
   *    - `[reloadOnSearch=true]` - `{boolean=}` - reload route when only `$location.search()`
   *      or `$location.hash()` changes.
   *
   *      If the option is set to `false` and url in the browser changes, then
   *      `$routeUpdate` event is broadcasted on the root scope.
   *
   *    - `[caseInsensitiveMatch=false]` - `{boolean=}` - match routes without being case sensitive
   *
   *      If the option is set to `true`, then the particular route can be matched without being
   *      case sensitive
   *
   * @returns {Object} self
   *
   * @description
   * Adds a new route definition to the `$route` service.
   */
  this.when = function(path, route) {
    //copy original route object to preserve params inherited from proto chain
    var routeCopy = shallowCopy(route);
    if (angular.isUndefined(routeCopy.reloadOnSearch)) {
      routeCopy.reloadOnSearch = true;
    }
    if (angular.isUndefined(routeCopy.caseInsensitiveMatch)) {
      routeCopy.caseInsensitiveMatch = this.caseInsensitiveMatch;
    }
    routes[path] = angular.extend(
      routeCopy,
      path && pathRegExp(path, routeCopy)
    );

    // create redirection for trailing slashes
    if (path) {
      var redirectPath = (path[path.length - 1] == '/')
            ? path.substr(0, path.length - 1)
            : path + '/';

      routes[redirectPath] = angular.extend(
        {redirectTo: path},
        pathRegExp(redirectPath, routeCopy)
      );
    }

    return this;
  };

  /**
   * @ngdoc property
   * @name $routeProvider#caseInsensitiveMatch
   * @description
   *
   * A boolean property indicating if routes defined
   * using this provider should be matched using a case insensitive
   * algorithm. Defaults to `false`.
   */
  this.caseInsensitiveMatch = false;

   /**
    * @param path {string} path
    * @param opts {Object} options
    * @return {?Object}
    *
    * @description
    * Normalizes the given path, returning a regular expression
    * and the original path.
    *
    * Inspired by pathRexp in visionmedia/express/lib/utils.js.
    */
  function pathRegExp(path, opts) {
    var insensitive = opts.caseInsensitiveMatch,
        ret = {
          originalPath: path,
          regexp: path
        },
        keys = ret.keys = [];

    path = path
      .replace(/([().])/g, '\\$1')
      .replace(/(\/)?:(\w+)(\*\?|[\?\*])?/g, function(_, slash, key, option) {
        var optional = (option === '?' || option === '*?') ? '?' : null;
        var star = (option === '*' || option === '*?') ? '*' : null;
        keys.push({ name: key, optional: !!optional });
        slash = slash || '';
        return ''
          + (optional ? '' : slash)
          + '(?:'
          + (optional ? slash : '')
          + (star && '(.+?)' || '([^/]+)')
          + (optional || '')
          + ')'
          + (optional || '');
      })
      .replace(/([\/$\*])/g, '\\$1');

    ret.regexp = new RegExp('^' + path + '$', insensitive ? 'i' : '');
    return ret;
  }

  /**
   * @ngdoc method
   * @name $routeProvider#otherwise
   *
   * @description
   * Sets route definition that will be used on route change when no other route definition
   * is matched.
   *
   * @param {Object|string} params Mapping information to be assigned to `$route.current`.
   * If called with a string, the value maps to `redirectTo`.
   * @returns {Object} self
   */
  this.otherwise = function(params) {
    if (typeof params === 'string') {
      params = {redirectTo: params};
    }
    this.when(null, params);
    return this;
  };


  this.$get = ['$rootScope',
               '$location',
               '$routeParams',
               '$q',
               '$injector',
               '$templateRequest',
               '$sce',
      function($rootScope, $location, $routeParams, $q, $injector, $templateRequest, $sce) {

    /**
     * @ngdoc service
     * @name $route
     * @requires $location
     * @requires $routeParams
     *
     * @property {Object} current Reference to the current route definition.
     * The route definition contains:
     *
     *   - `controller`: The controller constructor as defined in the route definition.
     *   - `locals`: A map of locals which is used by {@link ng.$controller $controller} service for
     *     controller instantiation. The `locals` contain
     *     the resolved values of the `resolve` map. Additionally the `locals` also contain:
     *
     *     - `$scope` - The current route scope.
     *     - `$template` - The current route template HTML.
     *
     *     The `locals` will be assigned to the route scope's `$resolve` property. You can override
     *     the property name, using `resolveAs` in the route definition. See
     *     {@link ngRoute.$routeProvider $routeProvider} for more info.
     *
     * @property {Object} routes Object with all route configuration Objects as its properties.
     *
     * @description
     * `$route` is used for deep-linking URLs to controllers and views (HTML partials).
     * It watches `$location.url()` and tries to map the path to an existing route definition.
     *
     * Requires the {@link ngRoute `ngRoute`} module to be installed.
     *
     * You can define routes through {@link ngRoute.$routeProvider $routeProvider}'s API.
     *
     * The `$route` service is typically used in conjunction with the
     * {@link ngRoute.directive:ngView `ngView`} directive and the
     * {@link ngRoute.$routeParams `$routeParams`} service.
     *
     * @example
     * This example shows how changing the URL hash causes the `$route` to match a route against the
     * URL, and the `ngView` pulls in the partial.
     *
     * <example name="$route-service" module="ngRouteExample"
     *          deps="angular-route.js" fixBase="true">
     *   <file name="index.html">
     *     <div ng-controller="MainController">
     *       Choose:
     *       <a href="Book/Moby">Moby</a> |
     *       <a href="Book/Moby/ch/1">Moby: Ch1</a> |
     *       <a href="Book/Gatsby">Gatsby</a> |
     *       <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
     *       <a href="Book/Scarlet">Scarlet Letter</a><br/>
     *
     *       <div ng-view></div>
     *
     *       <hr />
     *
     *       <pre>$location.path() = {{$location.path()}}</pre>
     *       <pre>$route.current.templateUrl = {{$route.current.templateUrl}}</pre>
     *       <pre>$route.current.params = {{$route.current.params}}</pre>
     *       <pre>$route.current.scope.name = {{$route.current.scope.name}}</pre>
     *       <pre>$routeParams = {{$routeParams}}</pre>
     *     </div>
     *   </file>
     *
     *   <file name="book.html">
     *     controller: {{name}}<br />
     *     Book Id: {{params.bookId}}<br />
     *   </file>
     *
     *   <file name="chapter.html">
     *     controller: {{name}}<br />
     *     Book Id: {{params.bookId}}<br />
     *     Chapter Id: {{params.chapterId}}
     *   </file>
     *
     *   <file name="script.js">
     *     angular.module('ngRouteExample', ['ngRoute'])
     *
     *      .controller('MainController', function($scope, $route, $routeParams, $location) {
     *          $scope.$route = $route;
     *          $scope.$location = $location;
     *          $scope.$routeParams = $routeParams;
     *      })
     *
     *      .controller('BookController', function($scope, $routeParams) {
     *          $scope.name = "BookController";
     *          $scope.params = $routeParams;
     *      })
     *
     *      .controller('ChapterController', function($scope, $routeParams) {
     *          $scope.name = "ChapterController";
     *          $scope.params = $routeParams;
     *      })
     *
     *     .config(function($routeProvider, $locationProvider) {
     *       $routeProvider
     *        .when('/Book/:bookId', {
     *         templateUrl: 'book.html',
     *         controller: 'BookController',
     *         resolve: {
     *           // I will cause a 1 second delay
     *           delay: function($q, $timeout) {
     *             var delay = $q.defer();
     *             $timeout(delay.resolve, 1000);
     *             return delay.promise;
     *           }
     *         }
     *       })
     *       .when('/Book/:bookId/ch/:chapterId', {
     *         templateUrl: 'chapter.html',
     *         controller: 'ChapterController'
     *       });
     *
     *       // configure html5 to get links working on jsfiddle
     *       $locationProvider.html5Mode(true);
     *     });
     *
     *   </file>
     *
     *   <file name="protractor.js" type="protractor">
     *     it('should load and compile correct template', function() {
     *       element(by.linkText('Moby: Ch1')).click();
     *       var content = element(by.css('[ng-view]')).getText();
     *       expect(content).toMatch(/controller\: ChapterController/);
     *       expect(content).toMatch(/Book Id\: Moby/);
     *       expect(content).toMatch(/Chapter Id\: 1/);
     *
     *       element(by.partialLinkText('Scarlet')).click();
     *
     *       content = element(by.css('[ng-view]')).getText();
     *       expect(content).toMatch(/controller\: BookController/);
     *       expect(content).toMatch(/Book Id\: Scarlet/);
     *     });
     *   </file>
     * </example>
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeStart
     * @eventType broadcast on root scope
     * @description
     * Broadcasted before a route change. At this  point the route services starts
     * resolving all of the dependencies needed for the route change to occur.
     * Typically this involves fetching the view template as well as any dependencies
     * defined in `resolve` route property. Once  all of the dependencies are resolved
     * `$routeChangeSuccess` is fired.
     *
     * The route change (and the `$location` change that triggered it) can be prevented
     * by calling `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on}
     * for more details about event object.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {Route} next Future route information.
     * @param {Route} current Current route information.
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeSuccess
     * @eventType broadcast on root scope
     * @description
     * Broadcasted after a route change has happened successfully.
     * The `resolve` dependencies are now available in the `current.locals` property.
     *
     * {@link ngRoute.directive:ngView ngView} listens for the directive
     * to instantiate the controller and render the view.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {Route} current Current route information.
     * @param {Route|Undefined} previous Previous route information, or undefined if current is
     * first route entered.
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeError
     * @eventType broadcast on root scope
     * @description
     * Broadcasted if any of the resolve promises are rejected.
     *
     * @param {Object} angularEvent Synthetic event object
     * @param {Route} current Current route information.
     * @param {Route} previous Previous route information.
     * @param {Route} rejection Rejection of the promise. Usually the error of the failed promise.
     */

    /**
     * @ngdoc event
     * @name $route#$routeUpdate
     * @eventType broadcast on root scope
     * @description
     * The `reloadOnSearch` property has been set to false, and we are reusing the same
     * instance of the Controller.
     *
     * @param {Object} angularEvent Synthetic event object
     * @param {Route} current Current/previous route information.
     */

    var forceReload = false,
        preparedRoute,
        preparedRouteIsUpdateOnly,
        $route = {
          routes: routes,

          /**
           * @ngdoc method
           * @name $route#reload
           *
           * @description
           * Causes `$route` service to reload the current route even if
           * {@link ng.$location $location} hasn't changed.
           *
           * As a result of that, {@link ngRoute.directive:ngView ngView}
           * creates new scope and reinstantiates the controller.
           */
          reload: function() {
            forceReload = true;

            var fakeLocationEvent = {
              defaultPrevented: false,
              preventDefault: function fakePreventDefault() {
                this.defaultPrevented = true;
                forceReload = false;
              }
            };

            $rootScope.$evalAsync(function() {
              prepareRoute(fakeLocationEvent);
              if (!fakeLocationEvent.defaultPrevented) commitRoute();
            });
          },

          /**
           * @ngdoc method
           * @name $route#updateParams
           *
           * @description
           * Causes `$route` service to update the current URL, replacing
           * current route parameters with those specified in `newParams`.
           * Provided property names that match the route's path segment
           * definitions will be interpolated into the location's path, while
           * remaining properties will be treated as query params.
           *
           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
           */
          updateParams: function(newParams) {
            if (this.current && this.current.$$route) {
              newParams = angular.extend({}, this.current.params, newParams);
              $location.path(interpolate(this.current.$$route.originalPath, newParams));
              // interpolate modifies newParams, only query params are left
              $location.search(newParams);
            } else {
              throw $routeMinErr('norout', 'Tried updating route when with no current route');
            }
          }
        };

    $rootScope.$on('$locationChangeStart', prepareRoute);
    $rootScope.$on('$locationChangeSuccess', commitRoute);

    return $route;

    /////////////////////////////////////////////////////

    /**
     * @param on {string} current url
     * @param route {Object} route regexp to match the url against
     * @return {?Object}
     *
     * @description
     * Check if the route matches the current url.
     *
     * Inspired by match in
     * visionmedia/express/lib/router/router.js.
     */
    function switchRouteMatcher(on, route) {
      var keys = route.keys,
          params = {};

      if (!route.regexp) return null;

      var m = route.regexp.exec(on);
      if (!m) return null;

      for (var i = 1, len = m.length; i < len; ++i) {
        var key = keys[i - 1];

        var val = m[i];

        if (key && val) {
          params[key.name] = val;
        }
      }
      return params;
    }

    function prepareRoute($locationEvent) {
      var lastRoute = $route.current;

      preparedRoute = parseRoute();
      preparedRouteIsUpdateOnly = preparedRoute && lastRoute && preparedRoute.$$route === lastRoute.$$route
          && angular.equals(preparedRoute.pathParams, lastRoute.pathParams)
          && !preparedRoute.reloadOnSearch && !forceReload;

      if (!preparedRouteIsUpdateOnly && (lastRoute || preparedRoute)) {
        if ($rootScope.$broadcast('$routeChangeStart', preparedRoute, lastRoute).defaultPrevented) {
          if ($locationEvent) {
            $locationEvent.preventDefault();
          }
        }
      }
    }

    function commitRoute() {
      var lastRoute = $route.current;
      var nextRoute = preparedRoute;

      if (preparedRouteIsUpdateOnly) {
        lastRoute.params = nextRoute.params;
        angular.copy(lastRoute.params, $routeParams);
        $rootScope.$broadcast('$routeUpdate', lastRoute);
      } else if (nextRoute || lastRoute) {
        forceReload = false;
        $route.current = nextRoute;
        if (nextRoute) {
          if (nextRoute.redirectTo) {
            if (angular.isString(nextRoute.redirectTo)) {
              $location.path(interpolate(nextRoute.redirectTo, nextRoute.params)).search(nextRoute.params)
                       .replace();
            } else {
              $location.url(nextRoute.redirectTo(nextRoute.pathParams, $location.path(), $location.search()))
                       .replace();
            }
          }
        }

        $q.when(nextRoute).
          then(resolveLocals).
          then(function(locals) {
            // after route change
            if (nextRoute == $route.current) {
              if (nextRoute) {
                nextRoute.locals = locals;
                angular.copy(nextRoute.params, $routeParams);
              }
              $rootScope.$broadcast('$routeChangeSuccess', nextRoute, lastRoute);
            }
          }, function(error) {
            if (nextRoute == $route.current) {
              $rootScope.$broadcast('$routeChangeError', nextRoute, lastRoute, error);
            }
          });
      }
    }

    function resolveLocals(route) {
      if (route) {
        var locals = angular.extend({}, route.resolve);
        angular.forEach(locals, function(value, key) {
          locals[key] = angular.isString(value) ?
              $injector.get(value) :
              $injector.invoke(value, null, null, key);
        });
        var template = getTemplateFor(route);
        if (angular.isDefined(template)) {
          locals['$template'] = template;
        }
        return $q.all(locals);
      }
    }


    function getTemplateFor(route) {
      var template, templateUrl;
      if (angular.isDefined(template = route.template)) {
        if (angular.isFunction(template)) {
          template = template(route.params);
        }
      } else if (angular.isDefined(templateUrl = route.templateUrl)) {
        if (angular.isFunction(templateUrl)) {
          templateUrl = templateUrl(route.params);
        }
        if (angular.isDefined(templateUrl)) {
          route.loadedTemplateUrl = $sce.valueOf(templateUrl);
          template = $templateRequest(templateUrl);
        }
      }
      return template;
    }


    /**
     * @returns {Object} the current active route, by matching it against the URL
     */
    function parseRoute() {
      // Match a route
      var params, match;
      angular.forEach(routes, function(route, path) {
        if (!match && (params = switchRouteMatcher($location.path(), route))) {
          match = inherit(route, {
            params: angular.extend({}, $location.search(), params),
            pathParams: params});
          match.$$route = route;
        }
      });
      // No route matched; fallback to "otherwise" route
      return match || routes[null] && inherit(routes[null], {params: {}, pathParams:{}});
    }

    /**
     * @returns {string} interpolation of the redirect path with the parameters
     */
    function interpolate(string, params) {
      var result = [];
      angular.forEach((string || '').split(':'), function(segment, i) {
        if (i === 0) {
          result.push(segment);
        } else {
          var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
          var key = segmentMatch[1];
          result.push(params[key]);
          result.push(segmentMatch[2] || '');
          delete params[key];
        }
      });
      return result.join('');
    }
  }];
}

ngRouteModule.provider('$routeParams', $RouteParamsProvider);


/**
 * @ngdoc service
 * @name $routeParams
 * @requires $route
 *
 * @description
 * The `$routeParams` service allows you to retrieve the current set of route parameters.
 *
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 *
 * The route parameters are a combination of {@link ng.$location `$location`}'s
 * {@link ng.$location#search `search()`} and {@link ng.$location#path `path()`}.
 * The `path` parameters are extracted when the {@link ngRoute.$route `$route`} path is matched.
 *
 * In case of parameter name collision, `path` params take precedence over `search` params.
 *
 * The service guarantees that the identity of the `$routeParams` object will remain unchanged
 * (but its properties will likely change) even when a route change occurs.
 *
 * Note that the `$routeParams` are only updated *after* a route change completes successfully.
 * This means that you cannot rely on `$routeParams` being correct in route resolve functions.
 * Instead you can use `$route.current.params` to access the new route's parameters.
 *
 * @example
 * ```js
 *  // Given:
 *  // URL: http://server.com/index.html#/Chapter/1/Section/2?search=moby
 *  // Route: /Chapter/:chapterId/Section/:sectionId
 *  //
 *  // Then
 *  $routeParams ==> {chapterId:'1', sectionId:'2', search:'moby'}
 * ```
 */
function $RouteParamsProvider() {
  this.$get = function() { return {}; };
}

ngRouteModule.directive('ngView', ngViewFactory);
ngRouteModule.directive('ngView', ngViewFillContentFactory);


/**
 * @ngdoc directive
 * @name ngView
 * @restrict ECA
 *
 * @description
 * # Overview
 * `ngView` is a directive that complements the {@link ngRoute.$route $route} service by
 * including the rendered template of the current route into the main layout (`index.html`) file.
 * Every time the current route changes, the included view changes with it according to the
 * configuration of the `$route` service.
 *
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from to the DOM  |
 *
 * The enter and leave animation occur concurrently.
 *
 * @knownIssue If `ngView` is contained in an asynchronously loaded template (e.g. in another
 *             directive's templateUrl or in a template loaded using `ngInclude`), then you need to
 *             make sure that `$route` is instantiated in time to capture the initial
 *             `$locationChangeStart` event and load the appropriate view. One way to achieve this
 *             is to have it as a dependency in a `.run` block:
 *             `myModule.run(['$route', function() {}]);`
 *
 * @scope
 * @priority 400
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @param {string=} autoscroll Whether `ngView` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the view is updated.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the `autoscroll` attribute value evaluated
 *                    as an expression yields a truthy value.
 * @example
    <example name="ngView-directive" module="ngViewExample"
             deps="angular-route.js;angular-animate.js"
             animations="true" fixBase="true">
      <file name="index.html">
        <div ng-controller="MainCtrl as main">
          Choose:
          <a href="Book/Moby">Moby</a> |
          <a href="Book/Moby/ch/1">Moby: Ch1</a> |
          <a href="Book/Gatsby">Gatsby</a> |
          <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
          <a href="Book/Scarlet">Scarlet Letter</a><br/>

          <div class="view-animate-container">
            <div ng-view class="view-animate"></div>
          </div>
          <hr />

          <pre>$location.path() = {{main.$location.path()}}</pre>
          <pre>$route.current.templateUrl = {{main.$route.current.templateUrl}}</pre>
          <pre>$route.current.params = {{main.$route.current.params}}</pre>
          <pre>$routeParams = {{main.$routeParams}}</pre>
        </div>
      </file>

      <file name="book.html">
        <div>
          controller: {{book.name}}<br />
          Book Id: {{book.params.bookId}}<br />
        </div>
      </file>

      <file name="chapter.html">
        <div>
          controller: {{chapter.name}}<br />
          Book Id: {{chapter.params.bookId}}<br />
          Chapter Id: {{chapter.params.chapterId}}
        </div>
      </file>

      <file name="animations.css">
        .view-animate-container {
          position:relative;
          height:100px!important;
          background:white;
          border:1px solid black;
          height:40px;
          overflow:hidden;
        }

        .view-animate {
          padding:10px;
        }

        .view-animate.ng-enter, .view-animate.ng-leave {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s;

          display:block;
          width:100%;
          border-left:1px solid black;

          position:absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
          padding:10px;
        }

        .view-animate.ng-enter {
          left:100%;
        }
        .view-animate.ng-enter.ng-enter-active {
          left:0;
        }
        .view-animate.ng-leave.ng-leave-active {
          left:-100%;
        }
      </file>

      <file name="script.js">
        angular.module('ngViewExample', ['ngRoute', 'ngAnimate'])
          .config(['$routeProvider', '$locationProvider',
            function($routeProvider, $locationProvider) {
              $routeProvider
                .when('/Book/:bookId', {
                  templateUrl: 'book.html',
                  controller: 'BookCtrl',
                  controllerAs: 'book'
                })
                .when('/Book/:bookId/ch/:chapterId', {
                  templateUrl: 'chapter.html',
                  controller: 'ChapterCtrl',
                  controllerAs: 'chapter'
                });

              $locationProvider.html5Mode(true);
          }])
          .controller('MainCtrl', ['$route', '$routeParams', '$location',
            function($route, $routeParams, $location) {
              this.$route = $route;
              this.$location = $location;
              this.$routeParams = $routeParams;
          }])
          .controller('BookCtrl', ['$routeParams', function($routeParams) {
            this.name = "BookCtrl";
            this.params = $routeParams;
          }])
          .controller('ChapterCtrl', ['$routeParams', function($routeParams) {
            this.name = "ChapterCtrl";
            this.params = $routeParams;
          }]);

      </file>

      <file name="protractor.js" type="protractor">
        it('should load and compile correct template', function() {
          element(by.linkText('Moby: Ch1')).click();
          var content = element(by.css('[ng-view]')).getText();
          expect(content).toMatch(/controller\: ChapterCtrl/);
          expect(content).toMatch(/Book Id\: Moby/);
          expect(content).toMatch(/Chapter Id\: 1/);

          element(by.partialLinkText('Scarlet')).click();

          content = element(by.css('[ng-view]')).getText();
          expect(content).toMatch(/controller\: BookCtrl/);
          expect(content).toMatch(/Book Id\: Scarlet/);
        });
      </file>
    </example>
 */


/**
 * @ngdoc event
 * @name ngView#$viewContentLoaded
 * @eventType emit on the current ngView scope
 * @description
 * Emitted every time the ngView content is reloaded.
 */
ngViewFactory.$inject = ['$route', '$anchorScroll', '$animate'];
function ngViewFactory($route, $anchorScroll, $animate) {
  return {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    link: function(scope, $element, attr, ctrl, $transclude) {
        var currentScope,
            currentElement,
            previousLeaveAnimation,
            autoScrollExp = attr.autoscroll,
            onloadExp = attr.onload || '';

        scope.$on('$routeChangeSuccess', update);
        update();

        function cleanupLastView() {
          if (previousLeaveAnimation) {
            $animate.cancel(previousLeaveAnimation);
            previousLeaveAnimation = null;
          }

          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            previousLeaveAnimation = $animate.leave(currentElement);
            previousLeaveAnimation.then(function() {
              previousLeaveAnimation = null;
            });
            currentElement = null;
          }
        }

        function update() {
          var locals = $route.current && $route.current.locals,
              template = locals && locals.$template;

          if (angular.isDefined(template)) {
            var newScope = scope.$new();
            var current = $route.current;

            // Note: This will also link all children of ng-view that were contained in the original
            // html. If that content contains controllers, ... they could pollute/change the scope.
            // However, using ng-view on an element with additional content does not make sense...
            // Note: We can't remove them in the cloneAttchFn of $transclude as that
            // function is called before linking the content, which would apply child
            // directives to non existing elements.
            var clone = $transclude(newScope, function(clone) {
              $animate.enter(clone, null, currentElement || $element).then(function onNgViewEnter() {
                if (angular.isDefined(autoScrollExp)
                  && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                  $anchorScroll();
                }
              });
              cleanupLastView();
            });

            currentElement = clone;
            currentScope = current.scope = newScope;
            currentScope.$emit('$viewContentLoaded');
            currentScope.$eval(onloadExp);
          } else {
            cleanupLastView();
          }
        }
    }
  };
}

// This directive is called during the $transclude call of the first `ngView` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngView
// is called.
ngViewFillContentFactory.$inject = ['$compile', '$controller', '$route'];
function ngViewFillContentFactory($compile, $controller, $route) {
  return {
    restrict: 'ECA',
    priority: -400,
    link: function(scope, $element) {
      var current = $route.current,
          locals = current.locals;

      $element.html(locals.$template);

      var link = $compile($element.contents());

      if (current.controller) {
        locals.$scope = scope;
        var controller = $controller(current.controller, locals);
        if (current.controllerAs) {
          scope[current.controllerAs] = controller;
        }
        $element.data('$ngControllerController', controller);
        $element.children().data('$ngControllerController', controller);
      }
      scope[current.resolveAs || '$resolve'] = locals;

      link(scope);
    }
  };
}


})(window, window.angular);


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)();
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n\n/*!\n * Pikaday\n * Copyright © 2014 David Bushell | BSD & MIT license | https://dbushell.com/\n */.pika-single{z-index:9999;display:block;position:relative;color:#333;background:#fff;border:1px solid #ccc;border-bottom-color:#bbb;font-family:Helvetica Neue,Helvetica,Arial,sans-serif}.pika-single:after,.pika-single:before{content:\" \";display:table}.pika-single:after{clear:both}.pika-single.is-hidden{display:none}.pika-single.is-bound{position:absolute;box-shadow:0 5px 15px -5px rgba(0,0,0,.5)}.pika-lendar{float:left;width:240px;margin:8px}.pika-title{position:relative;text-align:center}.pika-label{display:inline-block;position:relative;z-index:9999;overflow:hidden;margin:0;padding:5px 3px;font-size:14px;line-height:20px;font-weight:700;background-color:#fff}.pika-title select{cursor:pointer;position:absolute;z-index:9998;margin:0;left:0;top:5px;opacity:0}.pika-next,.pika-prev{display:block;cursor:pointer;position:relative;outline:none;border:0;padding:0;width:20px;height:30px;text-indent:20px;white-space:nowrap;overflow:hidden;background-color:transparent;background-position:50%;background-repeat:no-repeat;background-size:75% 75%;opacity:.5}.pika-next:hover,.pika-prev:hover{opacity:1}.is-rtl .pika-next,.pika-prev{float:left;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==\")}.is-rtl .pika-prev,.pika-next{float:right;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=\")}.pika-next.is-disabled,.pika-prev.is-disabled{cursor:default;opacity:.2}.pika-select{display:inline-block}.pika-table{width:100%;border-collapse:collapse;border-spacing:0;border:0}.pika-table td,.pika-table th{width:14.285714285714286%;padding:0}.pika-table th{color:#999;font-size:12px;line-height:25px;font-weight:700;text-align:center}.pika-button{cursor:pointer;display:block;box-sizing:border-box;-moz-box-sizing:border-box;outline:none;border:0;margin:0;width:100%;padding:5px;color:#666;font-size:12px;line-height:15px;text-align:right;background:#f5f5f5;height:auto}.pika-week{font-size:11px;color:#999}.is-today .pika-button{color:#3af;font-weight:700}.has-event .pika-button,.is-selected .pika-button{color:#fff;font-weight:700;background:#3af;box-shadow:inset 0 1px 3px #178fe5;border-radius:3px}.has-event .pika-button{background:#005da9;box-shadow:inset 0 1px 3px #0076c9}.is-disabled .pika-button,.is-inrange .pika-button{background:#d5e9f7}.is-startrange .pika-button{color:#fff;background:#6cb31d;box-shadow:none;border-radius:3px}.is-endrange .pika-button{color:#fff;background:#3af;box-shadow:none;border-radius:3px}.is-disabled .pika-button{pointer-events:none;cursor:default;color:#999;opacity:.3}.is-outside-current-month .pika-button{color:#999;opacity:.3}.is-selection-disabled{pointer-events:none;cursor:default}.pika-button:hover,.pika-row.pick-whole-week:hover .pika-button{color:#fff;background:#ff8000;box-shadow:none;border-radius:3px}.pika-table abbr{border-bottom:none;cursor:help}", ""]);

// exports


/***/ },
/* 38 */
/***/ function(module, exports) {

module.exports = {
	"selectedStates": {},
	"brokerInformation": {
		"state": "",
		"gender": null,
		"brokerLicenses": [],
		"federalMarketplaceUserID": "",
		"medicaQualified": false
	},
	"agencyInformation": {
		"businessState": "",
		"taxClassification": null,
		"agencyLicenses": [],
		"usingAgency": false,
		"generalAgencyName": ""
	},
	"commissionInformation": {
		"assignee": "myself",
		"sameAsAgency": false,
		"assigneeState": ""
	},
	"declarations": {
		"questionsAndResponses": {
			"A": {
				"question": "Have you, or an organization over which you exercised management or policy control, ever:",
				"response": false,
				"explanation": "",
				"subQuestions": {
					"1": {
						"question": "Declared bankruptcy, filed a bankruptcy petition or been declared bankrupt?",
						"response": false,
						"explanation": ""
					},
					"2": {
						"question": "Had earnings garnished?",
						"response": false,
						"explanation": ""
					},
					"3": {
						"question": "Made a compromise with creditors?",
						"response": false,
						"explanation": ""
					},
					"4": {
						"question": "Been charged with a felony or misdemeanor (including petty misdemeanors within the last 10 years) in a domestic or foreign court?",
						"response": false,
						"explanation": ""
					}
				}
			},
			"B": {
				"question": "Do you have any satisfied or unsatisfied judgments or liens against you?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"C": {
				"question": "Has a bonding company denied, paid out or revoked a bond for you?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"D": {
				"question": "Have you ever voluntarily or involuntarily surrendered any professional license?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"E": {
				"question": "Has any federal regulatory agency or any state regulatory agency ever:",
				"response": false,
				"explanation": "",
				"subQuestions": {
					"1": {
						"question": "Found you to have made a false statement or omission or been dishonest, unfair or unethical?",
						"response": false,
						"explanation": ""
					},
					"2": {
						"question": "Found you to have been involved in violation of regulations or statutes?",
						"response": false,
						"explanation": ""
					},
					"3": {
						"question": "Found you to have been a cause of a business having its authorization to do business denied, suspended, revoked or restricted?",
						"response": false,
						"explanation": ""
					},
					"4": {
						"question": "Denied, suspended or revoked your registration or license, or otherwise prevented you from associating with any business or disciplined you by restricting your activities?",
						"response": false,
						"explanation": ""
					}
				}
			},
			"F": {
				"question": "Have you ever had a complaint filed against you involving insurance products or securities?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"G": {
				"question": "Have you ever been involved with, or a party to, any litigation with any insurance company or any entity which is engaged in the sale, marketing or administration of insurance or securities?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"H": {
				"question": "Have you ever been involved with, or a party to, any litigation which involved issues of misrepresentation, fraud, or misappropriation of funds?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"I": {
				"question": "Have you ever been discharged or permitted to resign because you were accused of:",
				"response": false,
				"explanation": "",
				"subQuestions": {
					"1": {
						"question": "Violating investment or insurance related statutes, regulations, rules or industry standards of conduct?",
						"response": false,
						"explanation": ""
					},
					"2": {
						"question": "Fraud or the wrongful taking of property?",
						"response": false,
						"explanation": ""
					},
					"3": {
						"question": "Failure to supervise in connection with investment or insurance-related statutes,regulations, rules or industry standards of conduct?",
						"response": false,
						"explanation": ""
					}
				}
			},
			"J": {
				"question": "Are you now the subject of any complaint, investigation or proceeding that could result in a 'Yes'; answer to any part of this questionnaire?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			}
		}
	}
};

/***/ },
/* 39 */
/***/ function(module, exports) {

module.exports = {
	"brokerInformation": {},
	"agencyInformation": {},
	"commissionInformation": {
		"assignee": "myself"
	},
	"generalInformation": {
		"taxClassification": "indiv"
	}
};

/***/ },
/* 40 */
/***/ function(module, exports) {

module.exports = [
	{
		"id": 0,
		"name": "January"
	},
	{
		"id": 1,
		"name": "February"
	},
	{
		"id": 2,
		"name": "March"
	},
	{
		"id": 3,
		"name": "April"
	},
	{
		"id": 4,
		"name": "May"
	},
	{
		"id": 5,
		"name": "June"
	},
	{
		"id": 6,
		"name": "July"
	},
	{
		"id": 7,
		"name": "August"
	},
	{
		"id": 8,
		"name": "September"
	},
	{
		"id": 9,
		"name": "October"
	},
	{
		"id": 10,
		"name": "November"
	},
	{
		"id": 11,
		"name": "December"
	}
];

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/Pikaday/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = __webpack_require__(4); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution lifted from date.js (MIT license): https://github.com/datejs/Datejs
        return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // data-attribute on the input field with an aria assistance text (only applied when `bound` is set)
        ariaLabel: 'Use the arrow keys to pick a date',

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // minimum number of days in the week that gets week number one
        // default ISO 8601, week 01 is the week with the first Thursday (4)
        firstWeekOfYearMinDays: 4,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect : true,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null,

        // Enable keyboard input
        keyboardInput: true
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if(!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }

            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    isoWeek = function(date, firstWeekOfYearMinDays) {
        // Ensure we're at the start of the day.
        date.setHours(0, 0, 0, 0);

        // Thursday in current week decides the year because January 4th
        // is always in the first week according to ISO8601.
        var yearDay        = date.getDate(),
            weekDay        = date.getDay(),
            dayInFirstWeek = firstWeekOfYearMinDays,
            dayShift       = dayInFirstWeek - 1, // counting starts at 0
            daysPerWeek    = 7,
            prevWeekDay    = function(day) { return (day + daysPerWeek - 1) % daysPerWeek; };

        // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
        date.setDate(yearDay + dayShift - prevWeekDay(weekDay));

        var jan4th      = new Date(date.getFullYear(), 0, dayInFirstWeek),
            msPerDay    = 24 * 60 * 60 * 1000,
            daysBetween = (date.getTime() - jan4th.getTime()) / msPerDay,
            weekNum     = 1 + Math.round((daysBetween - dayShift + prevWeekDay(jan4th.getDay())) / daysPerWeek);

        return weekNum;
    },

    renderWeek = function (d, m, y, firstWeekOfYearMinDays) {
        var date = new Date(y, m, d),
            week = hasMoment ? moment(date).isoWeek() : isoWeek(date, firstWeekOfYearMinDays);

        return '<td class="pika-week">' + week + '</td>';
    },

    renderRow = function(days, isRTL, pickWholeWeek, isRowSelected)
    {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? ' disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                    case 8:
                    case 46:
                        self.setDate(null);
                        break;
                }
            }
        };

        self._parseFieldValue = function()
        {
            if (opts.parse) {
                return opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                var date = moment(opts.field.value, opts.format, opts.formatStrict);
                return (date && date.isValid()) ? date.toDate() : null;
            } else {
                return new Date(Date.parse(opts.field.value));
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            date = self._parseFieldValue();
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);

        if (opts.keyboardInput) {
            addEvent(document, 'keydown', self._onKeyChange);
        }

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                opts.defaultDate = self._parseFieldValue();
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
              return this._o.toString(this._d, format);
            }
            if (hasMoment) {
              return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * clear and reset the date
         */
        clear: function()
        {
            this.setDate(null);
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            for (var c = 0; c < opts.numberOfMonths; c++) {
                randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', opts.ariaLabel);
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect, leftAligned, bottomAligned;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
            leftAligned = true;
            bottomAligned = true;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
                leftAligned = false;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
                bottomAligned = false;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';

            addClass(this.el, leftAligned ? 'left-aligned' : 'right-aligned');
            addClass(this.el, bottomAligned ? 'bottom-aligned' : 'top-aligned');
            removeClass(this.el, !leftAligned ? 'left-aligned' : 'right-aligned');
            removeClass(this.el, !bottomAligned ? 'bottom-aligned' : 'top-aligned');
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year, opts.firstWeekOfYearMinDays));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }

                if (!this._o.container) {
                    this.el.style.position = 'static'; // reset
                    this.el.style.left = 'auto';
                    this.el.style.top = 'auto';
                }
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            var opts = this._o;

            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (opts.keyboardInput) {
                removeEvent(document, 'keydown', this._onKeyChange);
            }
            if (opts.field) {
                removeEvent(opts.field, 'change', this._onInputChange);
                if (opts.bound) {
                    removeEvent(opts.trigger, 'click', this._onInputClick);
                    removeEvent(opts.trigger, 'focus', this._onInputFocus);
                    removeEvent(opts.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;
}));


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cfieldset\u003E\u003Clegend\u003E\u003Cdiv class=\"sr-only\"\u003EDate of Birth\u003C\u002Fdiv\u003E\u003C\u002Flegend\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-6\"\u003E\u003Cselect class=\"date-group-month\" ng-options=\"month.id as month.name for month in monthsOfTheYear\" ng-model=\"birthday.month\" id=\"dob-month\" name=\"birthdayMonth\"\u003E\u003Coption value=\"\"\u003EMonth\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Clabel for=\"dob-month\"\u003EDate of Birth\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3\"\u003E\u003Cinput type=\"text\" id=\"dob-day\" placeholder=\"Day\" ng-model=\"birthday.date\" pattern=\"[0-9]*\" maxlength=\"2\" name=\"birthdayDay\"\u003E\u003Clabel class=\"sr-only\" for=\"dob-day\"\u003EBirthday Day\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-3\"\u003E\u003Cinput type=\"text\" id=\"dob-year\" placeholder=\"Year\" ng-model=\"birthday.year\" pattern=\"[0-9]{2}|[0-9]{4}\" minlength=\"1\" maxlength=\"4\" name=\"birthdayYear\"\u003E\u003Clabel class=\"sr-only\" for=\"dob-year\"\u003EBirthday Year\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"application-actions clearfix\"\u003E\u003Cdiv class=\"application-actions__previous\"\u003E\u003Cbutton class=\"btn btn-tertiary btn-previous\" type=\"button\" ng-click=\"previousStep()\"\u003Eback\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-actions__next\"\u003E\u003Cbutton class=\"btn btn-info\" type=\"submit\" value=\"next\"\u003E\u003Cspan ng-if=\"!isLastStep\"\u003Enext\u003C\u002Fspan\u003E\u003Cspan ng-if=\"isLastStep\"\u003Esubmit\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"address-validator\"\u003E\u003Ch3\u003EPlease verify your {{ model.type }} address\u003C\u002Fh3\u003E\u003Cdiv class=\"address-validator-message\" ng-if=\"model.addresses.length\"\u003E\u003Cp class=\"label-text\"\u003EWe found a near-match to the address you entered. Please verify we found the right information.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"alert alert-danger uppercase-first\" ng-if=\"!model.addresses.length\"\u003E{{ model.type }} address could not be validated. Please provide a valid US Postal Service address.\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"model.addresses.length\"\u003E\u003Cdiv class=\"alert alert-danger\" ng-if=\"returnText\"\u003E{{ returnText }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\"\u003E\u003Ch3 class=\"address-validator-verify-address__sub-title\"\u003EYou entered:\u003C\u002Fh3\u003E\u003Cdiv class=\"address-validator-entered-address\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6\"\u003E\u003Cp class=\"address-validator-coverage-address\"\u003E\u003Cstrong\u003E{{ model.enteredAddress.assigneeName }}\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp class=\"address-validator-coverage-address\"\u003E{{ model.enteredAddress.address }}\u003C\u002Fp\u003E\u003Cp class=\"address-validator-coverage-address\" ng-if=\"model.enteredAddress.address2\"\u003E{{ model.enteredAddress.address2 }}\u003C\u002Fp\u003E\u003Cp class=\"address-validator-coverage-address\"\u003E{{ model.enteredAddress.city }}, {{ model.enteredAddress.state }} {{ model.enteredAddress.zipCode }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 address-validator-address__action\"\u003E\u003Cbutton class=\"unstyled-button btn-link standard-link\" ng-click=\"editAddress()\"\u003EGo back and edit\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"application-form-section\"\u003E\u003Ch3 class=\"address-validator-verify-address__sub-title\"\u003EStandardized address \u003Cspan ng-if=\"model.uspsAddresses.length &gt; 1\"\u003Eoptions:\u003C\u002Fspan\u003E\u003Cspan ng-if=\"model.uspsAddresses.length === 1\"\u003Eoption:\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003Cdiv class=\"address-validator-address\" ng-repeat=\"address in model.addresses\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 address-validator-address__content\"\u003E\u003Cp class=\"address-validator-coverage-address\"\u003E\u003Cstrong\u003E{{ name }}\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp class=\"address-validator-coverage-address\" ng-if=\"address.address\"\u003E{{ address.address }}\u003C\u002Fp\u003E\u003Cp class=\"address-validator-coverage-address\" ng-if=\"address.address2\"\u003E{{ address.address2 }}\u003C\u002Fp\u003E\u003Cp class=\"address-validator-coverage-address\"\u003E{{ address.city }}, {{ address.state }} {{ address.zipCode }}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 address-validator-address__action\"\u003E\u003Cbutton class=\"btn btn-info\" type=\"button\" ng-click=\"selectAddress(address)\"\u003ESelect\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ },
/* 46 */
/***/ function(module, exports) {

var g;

// This works in non-strict mode
g = (function() { return this; })();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ },
/* 47 */
/***/ function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			configurable: false,
			get: function() { return module.l; }
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			configurable: false,
			get: function() { return module.i; }
		});
		module.webpackPolyfill = 1;
	}
	return module;
}


/***/ },
/* 48 */
/***/ function(module, exports) {

/* (ignored) */

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_messages__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_route__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular_route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ApplicationService__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_AgencyInformationController__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controllers_GetStartedController__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__controllers_UpdatePayPacketController__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controllers_UpdatePayPacketInformationController__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__controllers_BrokerInformationController__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__controllers_CommissionAssignmentController__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__controllers_ProducerDeclarationsController__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controllers_ReviewController__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__controllers_ThankYouController__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_actionsDirective__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_angularMaskDirective__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_addressValidatorDirective__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_birthdayPickerDirective__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_datePickerDirective__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_ssnDirective__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__partials_get_started_pug__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__partials_get_started_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__partials_get_started_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__partials_update_pay_packet_pug__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__partials_update_pay_packet_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__partials_update_pay_packet_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__partials_update_pay_packet_information_pug__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__partials_update_pay_packet_information_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__partials_update_pay_packet_information_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__partials_broker_information_pug__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__partials_broker_information_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__partials_broker_information_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__partials_agency_information_pug__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__partials_agency_information_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__partials_agency_information_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__partials_commission_assignment_pug__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__partials_commission_assignment_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__partials_commission_assignment_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__partials_producer_declaration_pug__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__partials_producer_declaration_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__partials_producer_declaration_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__partials_thank_you_pug__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__partials_thank_you_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__partials_thank_you_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__partials_review_pug__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__partials_review_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__partials_review_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__sass_main_sass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__sass_main_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__sass_main_sass__);




































var direct = true;

__WEBPACK_IMPORTED_MODULE_0_angular___default.a
  .module('app', [ __WEBPACK_IMPORTED_MODULE_2_angular_route___default.a, __WEBPACK_IMPORTED_MODULE_1_angular_messages___default.a ])
  .controller('GetStartedController', __WEBPACK_IMPORTED_MODULE_5__controllers_GetStartedController__["a" /* default */])
  .controller('UpdatePayPacketController', __WEBPACK_IMPORTED_MODULE_6__controllers_UpdatePayPacketController__["a" /* default */])
  .controller('UpdatePayPacketInformationController', __WEBPACK_IMPORTED_MODULE_7__controllers_UpdatePayPacketInformationController__["a" /* default */])
  .controller('BrokerInformationController', __WEBPACK_IMPORTED_MODULE_8__controllers_BrokerInformationController__["a" /* default */])
  .controller('AgencyInformationController', __WEBPACK_IMPORTED_MODULE_4__controllers_AgencyInformationController__["a" /* default */])
  .controller('CommissionAssignmentController', __WEBPACK_IMPORTED_MODULE_9__controllers_CommissionAssignmentController__["a" /* default */])
  .controller('ProducerDeclarationsController', __WEBPACK_IMPORTED_MODULE_10__controllers_ProducerDeclarationsController__["a" /* default */])
  .controller('ReviewController', __WEBPACK_IMPORTED_MODULE_11__controllers_ReviewController__["a" /* default */])
  .controller('ThankYouController', __WEBPACK_IMPORTED_MODULE_12__controllers_ThankYouController__["a" /* default */])
  .service('ApplicationService', __WEBPACK_IMPORTED_MODULE_3__services_ApplicationService__["a" /* default */])
  .directive('actions', [ __WEBPACK_IMPORTED_MODULE_13__directives_actionsDirective__["a" /* default */] ])
  .directive('datePicker', [__WEBPACK_IMPORTED_MODULE_17__directives_datePickerDirective__["a" /* default */]])
  .directive('birthdayPicker', [ __WEBPACK_IMPORTED_MODULE_16__directives_birthdayPickerDirective__["a" /* default */] ])
  .directive('ssn', [ __WEBPACK_IMPORTED_MODULE_18__directives_ssnDirective__["a" /* default */] ])
  .directive('angularMask', __WEBPACK_IMPORTED_MODULE_14__directives_angularMaskDirective__["a" /* default */])
  .directive('addressValidator', [ __WEBPACK_IMPORTED_MODULE_15__directives_addressValidatorDirective__["a" /* default */] ])
  .config(['$routeProvider', '$locationProvider', '$compileProvider', function ($routeProvider, $locationProvider, $compileProvider) {
    // Explicitly saying NO to pushState as it would not be supported on BE side
    $locationProvider.html5Mode(false);
    $compileProvider.debugInfoEnabled(false);
    $routeProvider
      .when('/application/get-started', {
        controller: 'GetStartedController',
        template: __WEBPACK_IMPORTED_MODULE_19__partials_get_started_pug___default.a
      })
      .when('/application/update-pay-packet', {
        controller: 'UpdatePayPacketController',
        template: __WEBPACK_IMPORTED_MODULE_20__partials_update_pay_packet_pug___default.a
      })
      .when('/application/update-pay-packet/information', {
        controller: 'UpdatePayPacketInformationController',
        template: __WEBPACK_IMPORTED_MODULE_21__partials_update_pay_packet_information_pug___default.a
      })
      .when('/application/broker-information', {
        controller: 'BrokerInformationController',
        template: __WEBPACK_IMPORTED_MODULE_22__partials_broker_information_pug___default.a
      })
      .when('/application/agency-information', {
        controller: 'AgencyInformationController',
        template: __WEBPACK_IMPORTED_MODULE_23__partials_agency_information_pug___default.a
      })
      .when('/application/commission-assignment', {
        controller: 'CommissionAssignmentController',
        template: __WEBPACK_IMPORTED_MODULE_24__partials_commission_assignment_pug___default.a
      })
      .when('/application/producer-declaration', {
        controller: 'ProducerDeclarationsController',
        template: __WEBPACK_IMPORTED_MODULE_25__partials_producer_declaration_pug___default.a
      })
      .when('/application/review/:subRoute?', {
        controller: 'ReviewController',
        template: __WEBPACK_IMPORTED_MODULE_27__partials_review_pug___default.a
      })
      .when('/application/update-pay-packet/review/:subRoute?', {
        controller: 'ReviewController',
        template: __WEBPACK_IMPORTED_MODULE_27__partials_review_pug___default.a
      })
      .when('/application/thank-you', {
        controller: 'ThankYouController',
        template: __WEBPACK_IMPORTED_MODULE_26__partials_thank_you_pug___default.a
      })
      .when('/application/update-pay-packet/thank-you', {
        controller: 'ThankYouController',
        template: __WEBPACK_IMPORTED_MODULE_26__partials_thank_you_pug___default.a
      })
      .otherwise({
        redirectTo: '/application/get-started'
      });
  }])
  .run(['$rootScope', '$window', '$location', function ($rootScope, $window, $location) {
    $rootScope.$on('$locationChangeStart', function (event, next, current) {
      // very very basic validation to make sure steps aren't skipped
      if ($location.path() !== '/application/get-started' &&
          $location.path() !== '/application/update-pay-packet' &&
          direct) {
        if ($location.path().indexOf('update-pay-packet') > -1) {
          $location.path('/application/update-pay-packet');
        } else {
          $location.path('/application/get-started');
        }
        return;
      }
      $window.scrollTo(0, 0);
      direct = false;
    });
  }]);


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// bundle-63008d7da82110009e12.js